import {
  Component,
  OnInit,
  Renderer2,
  ViewChild,
  Input,
  OnDestroy,
  ChangeDetectorRef,
  ChangeDetectionStrategy
} from '@angular/core';

import { SessionService } from '../services/session.service';
import { UserInput } from '../models/data-cleanup-model';

import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  finalize,
  map,
  tap,
  switchMap,
  mergeMap,
  shareReplay,
} from 'rxjs/operators';
import { Observable, of, Subject } from 'rxjs';
import { FormBuilder, FormGroup, NgForm } from '@angular/forms';
import {
  NgbActiveModal,
  NgbCalendar,
  NgbModal,
} from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { Session } from '../models/Session';
import { Global } from '../app.global';
import { MasterDataService } from '../services/masterdata.service';
import { UserRolesService } from '../services/user-roles.service';
import { ConfirmationDialogService } from '../services/confirmation-dialog.service';
import { SFDCEvent } from '../models/sfdc-event-model';
import { formatDate } from '@angular/common';
import { Coordinator } from '../models/coordinator';
import { FacilitatorResult } from '../models/FacilitatorResult';
import { RandomUtil } from '../shared/contants/random-util';
import { AppConfig } from '../design/app';
import $ from 'jquery';
import { Modal, Collapse } from 'bootstrap';
import { log } from 'console';
import { DataCleanUpService } from '../services/datacleanup.service';
declare var bootstrap: any;
// import * as bootstrap from 'bootstrap';
// window.bootstrap = bootstrap;

@Component({
    selector: 'ngbd-modal-content',
    template: `
    <div class="modal-header">
      <h4 class="modal-title">Confirmation</h4>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="closePopUp()"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <p>
        Thank you for creating session. and Session link is : {{ sessionUrl }}
      </p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark" (click)="closePopUp()">
        OK
      </button>
    </div>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NgbdModalContent {
  @Input() sessionUrl;

  constructor(public activeModal: NgbActiveModal, public router: Router) { }

  closePopUp() {
    this.activeModal.dismiss();
    this.router.navigate(['/searchSession']);
  }
}

@Component({
    selector: 'app-add-session',
    templateUrl: './add-session.component.html',
    styleUrls: ['./add-session.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddSessionComponent implements OnInit, OnDestroy {
  @Input()
  session: Session;

  @Input()
  public stateDisable: boolean = true;

  @Input()
  public dropdownData_Sectors: any = [];

  @ViewChild('ngForm') formValues;

  addsessiongroup: FormGroup;
  tabItems: string[] = ['Domains', 'Emails', 'External Admins'];
  selecteTab = this.tabItems[0];
  public dropdownData: any = [];
  public sessionCountryMasterData: any = [];
  public WikipediaSevice: any;
  public facilitatorsData: any[];
  public coordinatorsData: Coordinator[] = [];
  private selectedLink: string;
  public countrySelect: any = [0];
  public stateSelect: any = [0];
  public departmentSelect: any = [0];
  public ppmdDisable: boolean = true;
  public otherDepartmentDisable: boolean = true;
  public clickedCountry: any;
  public AddSession: any;
  public deloitteSession: any;
  public externalSession: any;
  public nonClientSession: any;
  public companyName: any;
  public clientProgram: any;
  public secRestricted: any;
  public sponsoredCountry: any;
  public sessionCountry: any;
  public sessionCity: any;
  public sessionState: any;
  public sessionCoordinators: any;
  public sessionRequester: any;
  public responsiblePpmd: any;
  public serviceLineFunction: any;
  public sessionIndustry: any;
  public sessionSector: any;
  public sessionDepartment: any;
  public otherDepartment: any;
  public ppmd: any;
  public nonPpmd: any;
  public executives: any;
  public nonExecutives: any;
  public sessionDate: any;
  public sessionTime: any;
  public sessionTimezone: any;
  public sessionName: any = '';
  public certifiedFacilitator: any;
  public linkExpire: any;
  public sessionLink: any;
  public lastModifiedDate: any;
  public wbsPrdCode: any;
  public sessionParticipantManager: any;
  public sessionComments: any;
  public sessionCoordinatorsList: any = [];
  public sessionFacilitatorsList: any = [];
  public sessionType: any;
  submitted = false;
  public stateDisabled = false;
  public myData: any;
  //@Input()
  public Message: string;
  public sessionTypeDisabled: any;
  public invalidSessionRequester = false;
  public draftSession = false;
  myForm = NgForm;
  closeResult: string;
  time = { hour: [], minute: [] };
  meridian = true;
  spinners = false;
  searching = false;
  searchingWBS = false;
  activeWBSItemId: number | null = null;
  searchingWBSSurcharge = false;
  activeSurchargeWBSItemId: number | string | null = null;
  searchFailed = false;
  cityList: Array<any> = [];
  searchCoordinator$: Observable<any>;
  coordInput$ = new Subject<string>();
  selectedCoordinators = [];
  selectedFacilitator = [];
  specifyLabel: string = '';
  showProBono: boolean = false;
  showSpecify: boolean = false;
  showNAFields: boolean = false;
  disableServiceFunctionNA: boolean = true;
  disableSectorNA: boolean = true;
  disableIndustryNA: boolean = true;
  enableEmailInfo: boolean = false;
  showPPMDAsTextInput: boolean = true;
  selectedTab: string = 'domain';
  domainNameList: Array<any> = [];
  domainErrors: Array<any> = [];
  wrongDomains: Array<any> = [];
  participantEmailList: Array<any> = [];
  externalAdminEmailList: Array<any> = [];
  emailsErrors: Array<any> = [];
  clientEmailErrors: Array<any> = [];
  wrongEmails: Array<any> = [];
  masterData: any;
  disableSponsoredCountry: boolean = false;
  disableSubscriptionFields: boolean = false;
  subscriptionIDError: boolean = false;
  disableSesionFormat: boolean = false;
  invalidDomainEmailInfo: boolean = false;
  showEvent: boolean = false;
  showProgram: boolean = false;
  proBonoYes: boolean = false;
  multipleWBS: Array<any> = [{ id: 0, wbsCode: '', wbsPercentage: '', isSelectedFromPicklist: false, isWbsActive: null, isWbsStatusChecked: false, isWbsStatusChecking: false }];
  multipleWBSForSurcharge: Array<any> = [
    {
      id: '0_surcharge',
      wbsCode: '',
      wbsPercentage: '',
      isSelectedFromPicklist: false,
      isExistingWbs: false,
      isNewSurchargeCode: true,
      isWbsActive: null,
      isWbsStatusChecked: false,
      isWbsStatusChecking: false,
    },
  ];
  totalWBSPercentage: number = 0;
  totalWBSPercentageForSurcharge: number = 0;
  wbsError: boolean = false;
  wbsErrorForSurcharge: boolean = false;
  showSessionSubType: boolean = false;
  sessionId: number = 0;
  userRoleID: number;
  showApproveOptions: boolean = false;
  loggedInUserID: number;
  disableDeloitte: any = null;
  disableExternalClient: any = null;
  disableExternalNonClient: any = null;
  disableMixedAudience: any = null;
  nonDeloiiteSessionCount: number;
  showLoader: boolean = false;
  NonDeloitteUsersCount: number = 0;
  eventId: number = 0;
  eventName: string = '';
  eventLink: string = '';
  eventUrl: string = '';
  sfdcEvents: SFDCEvent[] = [];
  isSubTypeMandatory: boolean = false;
  textLimitErrorCoordinator: boolean = false;
  textLimitErrorPPMD: boolean = false;
  textLimitErrorCompany: boolean = false;
  textLimitErrorFacilitator: boolean = false;
  invalidppmd: boolean = false;
  validForm: boolean = false;
  idforpopup: number = 0;
  subscriptionIDErrormessage: string = '';
  minimumDate: any;
  maximumDate: any;
  showProgramFinance: boolean = true;
  disableAddWBS: boolean = true;
  disableAddWBSForSurcharge: boolean = true;
  wbsCodeEntered: string = '';
  wbsCodeEnteredForSurcharge: string = '';
  invalidDomainInfo: boolean = false;
  invalidEmailInfo: boolean = false;
  invalidClientAdminInfo: boolean = false;
  clientAdminInfo: boolean = false;
  invalidWBS: boolean = false;
  invalidWBSForSurcharge: boolean = false;
  inactiveWbsError: boolean = false;
  disableApproveDueToWbs: boolean = false;
  IsWBSCodeConfirmed: boolean = false;
  wbsid: any;
  wbsidForSurcharge: any;
  hostnameobj = window.location.hostname.replace('admin', '');
  showClientAdminAndManagerLink: boolean = false;
  managerLink: string = '';
  sessionUniqueID: string = '';
  commentsPlaceholder: string;
  operationType: string = 'Add';
  showSessionNotApproved: boolean = true;
  editedSubscriptionId: any = null;
  invalidCompany: boolean = false;
  disableLinkExpire: boolean = true;
  requiredDomainEmailsVal: boolean = false;
  lastModifiedBy: string = '';
  createdBy: string = '';
  FormatedCreatedDate: string = '';
  FormatedModifiedDate: string = '';

  isaudienceChanged: boolean = false;
  issubmitEnable: boolean = false;
  tempSubScriptionId: any = null;
  disableApprove: boolean = false;
  sponsoringCountries: Array<any> = [];
  staticSessionType: Array<any>;
  staticSessionTypeFlag: boolean = false;
  sessionProBonoFlag: boolean = false;
  sessionTypeSpecifyFlag: boolean = false;
  sessionTypeEventProgramFlag: boolean = false;
  staticSessionTypeEventFlag: boolean = false;
  staticSessionFormat: any;
  

  flag: boolean = false;
  existingCoordinatorlist: any = [];
  pleaseSpecifyFieldLength = 0;
  subscriptionAdmins: Array<any> = [];
  sessionNameInPopUp: string;
  invalidPercenatge: boolean;
  invalidPercenatgeForSurcharge: boolean;
  tempSessionName: string = '';
  public IsAfterSubmit: boolean = false;
  public afterEditIsAudianceChanged: boolean = false;
  private checkEditModeInProgress: boolean = false;
  private hasInitialCheckEditMode: boolean = false;
  isReportGeneration: boolean = false;
  isExtProfessional: boolean = false;
  twoDecimalPattern = '/^[0-9]+(.[0-9]{1,2})?$/';
  disableNonDeloitteProfessional: boolean = false;
  disableSurcharge: boolean = true;
  disableRate: boolean = false;
  approvalStatus: string = 'New';
  old_approvalStatus: string = 'New';
  sessionReport: any = null;
  statusChanged: boolean = false;
  public sessionFeedbackOptions = [
    { ID: "IAgree", name: "I agree - create Feedback ID" },
    { ID: "optOut", name: "Opt Out" },

  ];
  cadenceDate: Date = null;
  approvalDate: Date = null;
  showSurchargeWBS: boolean = false;
  isExistingSession: boolean = false;
  existingSessionDate: string = '';
  mdmWbsDeploymentDate: string = '';
  isSessionCreatedBeforeMdmWbsDeploymentDate: boolean = false;
  isExistingNonRecrutingSession: boolean = false;
  negativeSurcharge: string = '';
  disableParticipantsTab: boolean = false;
  auditTrailList: Array<any> = [];
  isClientCertifiedFacilitator: boolean = false;
  todayDate = new Date();
  session_date = new Date();
  isSessionDateGreaterTodayDate: boolean = false;
  selectedCompany: any = '';
  selectedCompanyDunsID: string = '';
  invalidWBSDunsID: boolean = false;
  disableSessionName: boolean = true;
  ModuleName: any = 'New Admin';
  isSubscriptionStatusError = false;
  subscriptionStatusErrorMesg = '';
  isLinkCopied = false;
  isFeedbackIdCopied = false;
  isDUClientEvent = false;
  isFLPEvent = false;
  optOut: string = null;
  FeedbackId: string = "";
  OptOutReason: string = '';
  invalidOptOutReason: boolean = false;
  isSFDCDisableOtherReasonInvalid: boolean = false;
  sfdcDisableOtherReasonInvalidMessage: string = 'Please enter a reason';
  isDisplaySubText = true;
  invalidOptOutReasonText = 'Please include a reason for opting out.';
  showRatefieldForFacAndCor = false;
  showSurchargefieldForFacAndCor = false;
  InvalidAge = false;
  InvalidAgeDisabled = false;
  OldSessionRequester = '';
  isUserSuperAdmin = false;
  isUserSubscriptionAdminForSession = false;
  subadminaddcnt = 0;
  userRoleList: any[] = [];
  disableWbsPercentage: boolean = false;
  disableSurchargePercentage: boolean = false;
  isInputWbsChanged: boolean = false;
  isInputWbsSurchargeChanged: boolean = false;
  responsiblePpmdEmail: any;
  sfdcDisableReasons: any[] = [];
  redirectUrl: string = 'https://ceprogram--fullcopy.my.salesforce.com/';
  doNotIntegrateWithSalesforce: boolean = false;

  disableContentArea: boolean = true;
  disableTopic: boolean = true;
  ContentAreaName: string = '';
  TopicName: string = '';
  allCountriesList: any = [];
  FacilitatorCount = 0;
  private facilitatorSearchCache = new Map<
    string,
    readonly FacilitatorResult[]
  >();
  private readonly facilitatorSearchCacheLimit = 50;
  enableSurchargeWBS: boolean = false;
  wbsDisable = false;
  isWBSMandatory: boolean = false;
  showAuditLabSubType: boolean = false;
  SFWbsStatus: any;
  currentWBS: any;
  private isAddingReplacementWbs = false;
  private myPopupInstance: Modal | null = null;
  constructor(
    private SessionService: SessionService,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    _global: Global,
    private masterDataService: MasterDataService,
    public userRoleService: UserRolesService,
    private ngbCalendar: NgbCalendar,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private confirmationDialogService: ConfirmationDialogService,
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef,
    private datacleanupservice: DataCleanUpService
  ) {
    this.auditTrailList = [];
    this.session = new Session();
    this.getSessionData();
  }
  ScrollIntoView(elem: string) {
    setTimeout(() => {
      document
        .querySelector(elem)
        .scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 100);
  }

  InitializeSessionTypeValues() {
    this.staticSessionType = [
      {
        SessionTypeID: 1,
        SessionAudience: 'Deloitte',
        SessionTypeName: 'Business Chemistry Standard Session',
        ToolTip:
          'Standard Business Chemistry session that is not embedded as part of a Deloitte Program or Lab (may be part of a larger meeting)',
        SessionMetaData: null,
        IsMetaDataMandatory: false,
        subTypes: null,
      },
      {
        SessionTypeID: 8,
        SessionAudience: 'ExternalClient',
        SessionTypeName: 'Business Chemistry Standard Session',
        ToolTip:
          'Standard Business Chemistry session that is not embedded as part of a Deloitte Program or Lab (may be part of a larger meeting)',
        SessionMetaData: null,
        IsMetaDataMandatory: false,
        subTypes: null,
      },
      {
        SessionTypeID: 16,
        SessionAudience: 'ExternalNonClient',
        SessionTypeName: 'Business Chemistry Standard Session',
        ToolTip:
          'Standard Business Chemistry session that is not embedded as part of a Deloitte Program or Lab (may be part of a larger meeting)',
        SessionMetaData: 'If pro-bono, please explain rationale',
        IsMetaDataMandatory: true,
        subTypes: null,
      },
      {
        SessionTypeID: 24,
        SessionAudience: 'MixedAudience',
        SessionTypeName: 'Business Chemistry Standard Session',
        ToolTip:
          'Standard Business Chemistry session that is not embedded as part of a Deloitte Program or Lab (may be part of a larger meeting)',
        SessionMetaData: 'If pro-bono, please explain rationale',
        IsMetaDataMandatory: true,
        subTypes: null,
      },
      {
        SessionTypeID: 27,
        SessionAudience: 'MixedAudience',
        SessionTypeName: 'Custom Business Chemistry Lab',
        ToolTip: 'Custom lab with a focus on Business Chemistry',
        SessionMetaData: null,
        IsMetaDataMandatory: false,
        subTypes: null,
      },
      {
        SessionTypeID: 4,
        SessionAudience: 'Deloitte',
        SessionTypeName: 'Custom Business Chemistry Lab',
        ToolTip: 'Custom lab with a focus on Business Chemistry',
        SessionMetaData: null,
        IsMetaDataMandatory: false,
        subTypes: null,
      },
      {
        SessionTypeID: 10,
        SessionAudience: 'ExternalClient',
        SessionTypeName: 'Custom Business Chemistry Lab',
        ToolTip: 'Custom lab with a focus on Business Chemistry',
        SessionMetaData: null,
        IsMetaDataMandatory: false,
        subTypes: null,
      },
      {
        SessionTypeID: 18,
        SessionAudience: 'ExternalNonClient',
        SessionTypeName: 'Custom Business Chemistry Lab',
        ToolTip: 'Custom lab with a focus on Business Chemistry',
        SessionMetaData: null,
        IsMetaDataMandatory: false,
        subTypes: null,
      },
      {
        SessionTypeID: 19,
        SessionAudience: 'ExternalNonClient',
        SessionTypeName: 'XA Program/Event',
        ToolTip:
          'Business Chemistry session embedded as part of a XA event, such as an Executive Transition Lab or Next Gen Academy',
        SessionMetaData: 'Please specify',
        IsMetaDataMandatory: true,
        subTypes: null,
      },
      {
        SessionTypeID: 11,
        SessionAudience: 'ExternalClient',
        SessionTypeName: 'XA Program/Event',
        ToolTip:
          'Business Chemistry session embedded as part of a XA event, such as an Executive Transition Lab or Next Gen Academy',
        SessionMetaData: 'Please specify',
        IsMetaDataMandatory: true,
        subTypes: null,
      },
      {
        SessionTypeID: 2,
        SessionAudience: 'Deloitte',
        SessionTypeName: 'XA Program/Event',
        ToolTip:
          'Business Chemistry session embedded as part of a XA event, such as an Executive Transition Lab or Next Gen Academy',
        SessionMetaData: 'Please specify program',
        IsMetaDataMandatory: true,
        subTypes: null,
      },
      {
        SessionTypeID: 26,
        SessionAudience: 'MixedAudience',
        SessionTypeName: 'XA Program/Event',
        ToolTip:
          'Business Chemistry session embedded as part of a XA event, such as an Executive Transition Lab or Next Gen Academy',
        SessionMetaData: 'Please specify',
        IsMetaDataMandatory: true,
        subTypes: null,
      },
      {
        SessionTypeID: 28,
        SessionAudience: 'MixedAudience',
        SessionTypeName: 'External Deloitte Program',
        ToolTip:
          'Session for Deloitte-sponsored program, i.e. Courageous Principals, Higher Ed Summit, or CORE',
        SessionMetaData: 'Please specify',
        IsMetaDataMandatory: true,
        subTypes: null,
      },
      {
        SessionTypeID: 17,
        SessionAudience: 'ExternalNonClient',
        SessionTypeName: 'Greenhouse Breakthrough Lab',
        ToolTip: 'Session for non-client Greenhouse Breakthrough Lab',
        SessionMetaData: null,
        IsMetaDataMandatory: false,
        subTypes: null,
      },
      {
        SessionTypeID: 25,
        SessionAudience: 'MixedAudience',
        SessionTypeName: 'Greenhouse Breakthrough Lab',
        ToolTip: 'Session for client Greenhouse Breakthrough Lab',
        SessionMetaData: null,
        IsMetaDataMandatory: false,
        subTypes: null,
      },
      {
        SessionTypeID: 3,
        SessionAudience: 'Deloitte',
        SessionTypeName: 'Greenhouse Breakthrough Lab',
        ToolTip: 'Custom internal Greenhouse Breakthrough Lab',
        SessionMetaData: null,
        IsMetaDataMandatory: false,
        subTypes: null,
      },
      {
        SessionTypeID: 9,
        SessionAudience: 'ExternalClient',
        SessionTypeName: 'Greenhouse Breakthrough Lab',
        ToolTip: 'Session for client Greenhouse Breakthrough Lab',
        SessionMetaData: null,
        IsMetaDataMandatory: false,
        subTypes: null,
      },
      {
        SessionTypeID: 13,
        SessionAudience: 'ExternalClient',
        SessionTypeName: 'Non-Recruiting College Event',
        ToolTip:
          'Business Chemistry session offered to College administration, staff, and/or students outside of a recruiting event (e.g., embedded in curriculum, staff development, client service)',
        SessionMetaData: null,
        IsMetaDataMandatory: false,
        subTypes: [
          {
            SessionSubTypeID: 1,
            SessionTypeID: 13,
            SessionSubTypeName: 'Administrators and staff only',
          },
          {
            SessionSubTypeID: 4,
            SessionTypeID: 13,
            SessionSubTypeName: 'Formalized curriculum',
          },
          {
            SessionSubTypeID: 3,
            SessionTypeID: 13,
            SessionSubTypeName: 'Students and administrator',
          },
          {
            SessionSubTypeID: 2,
            SessionTypeID: 13,
            SessionSubTypeName: 'Students only',
          },
        ],
      },
      {
        SessionTypeID: 20,
        SessionAudience: 'ExternalNonClient',
        SessionTypeName: 'Non-Recruiting College Event',
        ToolTip:
          'Business Chemistry session offered to College administration, staff, and/or students outside of a recruiting event (e.g., embedded in curriculum, staff development, client service)',
        SessionMetaData: null,
        IsMetaDataMandatory: false,
        subTypes: [
          {
            SessionSubTypeID: 5,
            SessionTypeID: 20,
            SessionSubTypeName: 'Administrators and staff only',
          },
          {
            SessionSubTypeID: 8,
            SessionTypeID: 20,
            SessionSubTypeName: 'Formalized curriculum',
          },
          {
            SessionSubTypeID: 7,
            SessionTypeID: 20,
            SessionSubTypeName: 'Students and administrator',
          },
          {
            SessionSubTypeID: 6,
            SessionTypeID: 20,
            SessionSubTypeName: 'Students only',
          },
        ],
      },
      {
        SessionTypeID: 12,
        SessionAudience: 'ExternalClient',
        SessionTypeName: 'Official Speaking Engagement',
        ToolTip:
          'Speaking engagement session link for Client audience (conference, seminar, etc.)',
        SessionMetaData: 'Please specify',
        IsMetaDataMandatory: false,
        subTypes: null,
      },
      {
        SessionTypeID: 5,
        SessionAudience: 'Deloitte',
        SessionTypeName: 'Official Speaking Engagement',
        ToolTip:
          'Speaking engagement session link for Deloitte-only audience (conference, seminar or professional organization)',
        SessionMetaData: 'Please specify',
        IsMetaDataMandatory: false,
        subTypes: null,
      },
      {
        SessionTypeID: 22,
        SessionAudience: 'ExternalNonClient',
        SessionTypeName: 'Official Speaking Engagement',
        ToolTip:
          'Speaking engagement session link for non-client audience (conference, seminar, etc.)',
        SessionMetaData: 'Please specify',
        IsMetaDataMandatory: false,
        subTypes: null,
      },
      {
        SessionTypeID: 29,
        SessionAudience: 'MixedAudience',
        SessionTypeName: 'Official Speaking Engagement',
        ToolTip:
          'Speaking engagement session link for mixed audience (conference, seminar, etc.)',
        SessionMetaData: 'Please specify',
        IsMetaDataMandatory: false,
        subTypes: null,
      },
      {
        SessionTypeID: 14,
        SessionAudience: 'ExternalClient',
        SessionTypeName: 'Recruiting Event',
        ToolTip:
          'Business Chemistry embedded within a Deloitte-sponsored recruiting event',
        SessionMetaData: null,
        IsMetaDataMandatory: false,
        subTypes: null,
      },
      {
        SessionTypeID: 21,
        SessionAudience: 'ExternalNonClient',
        SessionTypeName: 'Recruiting Event',
        ToolTip:
          'Business Chemistry embedded within a Deloitte-sponsored recruiting event',
        SessionMetaData: null,
        IsMetaDataMandatory: false,
        subTypes: null,
      },
      {
        SessionTypeID: 31,
        SessionAudience: 'ExternalNonClient',
        SessionTypeName: 'Talent Development Program',
        ToolTip:
          'Session for onboarding, milestone, or other talent development program',
        SessionMetaData: 'Please specify program',
        IsMetaDataMandatory: true,
        subTypes: null,
      },
      {
        SessionTypeID: 6,
        SessionAudience: 'Deloitte',
        SessionTypeName: 'Talent Development Program',
        ToolTip:
          'Session for onboarding, milestone, or other talent development program',
        SessionMetaData: 'Please specify program',
        IsMetaDataMandatory: true,
        subTypes: null,
      },
      {
        SessionTypeID: 15,
        SessionAudience: 'ExternalClient',
        SessionTypeName: 'Other Client',
        ToolTip: '',
        SessionMetaData: 'Please specify',
        IsMetaDataMandatory: true,
        subTypes: null,
      },
      {
        SessionTypeID: 7,
        SessionAudience: 'Deloitte',
        SessionTypeName: 'Other Internal Deloitte',
        ToolTip: '',
        SessionMetaData: 'Please specify session type',
        IsMetaDataMandatory: true,
        subTypes: null,
      },
      {
        SessionTypeID: 30,
        SessionAudience: 'MixedAudience',
        SessionTypeName: 'Other Mixed Group',
        ToolTip: '',
        SessionMetaData: 'Please specify',
        IsMetaDataMandatory: true,
        subTypes: null,
      },
      {
        SessionTypeID: 23,
        SessionAudience: 'ExternalNonClient',
        SessionTypeName: 'Other Non-Client',
        ToolTip: '',
        SessionMetaData: 'Please specify',
        IsMetaDataMandatory: true,
        subTypes: null,
      },
      {
        SessionTypeID: 32,
        SessionAudience: 'MixedAudience',
        SessionTypeName: 'Talent Development Program',
        ToolTip:
          'Session for onboarding, milestone, or other talent development program',
        SessionMetaData: 'Please specify program',
        IsMetaDataMandatory: true,
        subTypes: null,
      },
    ];
  }

  ngOnInit() {
    this.closeConfirmPopUp();
    this.InitializeSessionTypeValues();
    this.showLoader = true;
    this.setIsUserSuperAdmin();
    this.setUserDetails();
    // Initialize WBS mandatory status
    this.updateWBSMandatoryStatus();

    this.userRoleService.setDisableUserRoleList(true);
    this.initalizeStaticSessionFormat();
  }

  removeBackdrop() {
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
      backdrop.remove();
    }
  }

  // method to check if the user hase super admin role or not
  setIsUserSuperAdmin() {
    this.userRoleService.getUserRoleList().subscribe((result: any) => {
      this.userRoleList = result ? result : [];
      if (result && result.some((i) => i.roleId === 1)) {
        this.isUserSuperAdmin = true;
      } else if (result && result.some((i) => i.roleId === 6)) {
        this.isUserSubscriptionAdminForSession = true;
      }
    });
  }

  setUserDetails() {
    this.closeConfirmPopUp();

    // $("#mypopup").modal("hide");
    this.userRoleService.getLoggedInUserEmail().subscribe((email) => {
      this.session.sessionRequester = email;
    });

    this.userRoleService.getLoggedInUserID().subscribe((id) => {
      this.loggedInUserID = Number(id);
    });

    this.userRoleService.getUserRoleID().subscribe((id) => {
      this.userRoleID = Number(id);
      
      // Only call checkIfEditMode on initial load, not on subsequent role changes
      if (!this.hasInitialCheckEditMode) {
        this.hasInitialCheckEditMode = true;
        setTimeout(() => {
          this.checkIfEditMode();
          // this.closeConfirmPopUp();
          // $("#mypopup").modal("hide");
        }, 4000);
      }
      
      this.setInitialOptions();
    });
  }

  setInitialOptions() {
    this.visibilityApproveOptions();
    this.disableEventTypeNavigation();
    this.loadSponsoringCountry();
    this.loadSessionTypeDropDown();
    this.loadSessionFormatDropdown();
  }

  sessionCountryChange(countryid) {
    this.getSelectedSessionCountryName(countryid);
    this.session.sessionState = null;
    if (countryid == 23 || countryid == null) {
      this.stateDisable = false;
      this.session.sessionCity = null;
      this.cityList = [];
    } else {
      this.stateDisable = true;
      this.session.sessionCity = null;
      this.cityList = [];
    }
    this.dropdownData.States = this.masterData.States.filter(
      (state) => state.CountryID == countryid
    );
  }

  sessionStateChange(stateId) {
    this.cityList = this.onDropdownSelect(
      stateId,
      this.dropdownData,
      'Cities',
      'StateID'
    );
    this.session.sessionCity = null;
  }
  /*open(sessionguid) {
        let ngbModalOptions: NgbModalOptions = {
            backdrop: 'static',
            keyboard: false
        };
        const modalRef = this.modalService.open(NgbdModalContent, ngbModalOptions);
        modalRef.componentInstance.sessionUrl = sessionguid;
    }*/

  departmentChange(event) {
    if (event.target.value == 26 || event.target.value == null) {
      this.otherDepartmentDisable = false;
    } else {
      this.session.otherDepartment = '';
      this.otherDepartmentDisable = true;
    }

    // if condition will execute on creating a new session
    if (this.sessionId === 0) {
      this.generateSessionName();
    }

    // Adding if() condition as Session Name should update on change of Session Audiance AND (companyName OR Department OR Date)
    if (this.sessionId !== 0 && this.afterEditIsAudianceChanged === true) {
      this.generateSessionName();
    }
  }

  industryChange(event) {
    this.dropdownData_Sectors = this.dropdownData.Sectors.filter(
      (sector) => sector.IndustryID == event
    );
    this.session.sessionSector = null;
    const item = this.dropdownData.Industries.find(
      (index) => index.ID == event
    );
    this.session.sessionIndustry = item ? event : null;
    this.disableIndustryNA = true;
    if (item && item.Name.includes('N/A')) {
      this.disableIndustryNA = false;
      this.session.sessionSector = this.dropdownData_Sectors[0].SectorID;
      this.onSectorChange(this.dropdownData_Sectors[0].SectorID);
    } else {
      this.disableSectorNA = true;
    }
  }

  handleSessionNameGeneration() {
    if (
      this.session.sessionDate &&
      this.session.sessionDepartment &&
      (this.session.companyName != null ||
        this.session.companyName.Name != undefined)
    ) {
      let companyName = '';

      if (!this.session.companyName.Name)
        companyName = this.session.companyName ? this.session.companyName : '';
      else
        companyName = this.session.companyName
          ? this.session.companyName.Name
          : '';

      const department =
        this.session.sessionDepartment === 26
          ? this.session.otherDepartment?.trim()
          : this.dropdownData.Departments.find(
            (index) => index.ID == this.session.sessionDepartment
          ).Name;

      if (companyName && department) {
        this.session.sessionName =
          companyName +
          ' - ' +
          department +
          ' - ' +
          this.dateToString(this.session.sessionDate);
      }
    } else {
      this.session.sessionName = '';
    }
  }

  sessionType1(e: string, flag: boolean): void {
    setTimeout(() => {
      //  const collapseElement = document.querySelector('#accordion .accordion1');
      //  if (collapseElement) {
      //    const collapseInstance = new (window as any).bootstrap.Collapse(collapseElement, {
      //      show: true
      //    });
      //  }

      var collapseElement = document.querySelector('#accordion .accordion1');
      const element = document.querySelector('#accordion .accordion1');
      if (element) {
        element.classList.add('show');
        element.classList.remove('collapse');
      }

      // var collapseInstance = new bootstrap.Collapse(collapseElement,{show:true});
      //  $("#accordion .accordion1").collapse("show");
    }, 100);
    this.selectedLink = e;
    this.session.sessionType = e;
    this.isaudienceChanged = true;
    this.issubmitEnable = true;
    this.staticSessionTypeFlag = false;
    this.sessionProBonoFlag = false;
    this.sessionTypeSpecifyFlag = false;
    this.sessionTypeEventProgramFlag = false;
    this.staticSessionTypeEventFlag = false;
    this.pleaseSpecifyFieldLength = 0;
    this.afterEditIsAudianceChanged = flag;
    this.InvalidAge = false;
    // Update WBS mandatory status when session type changes
    this.updateWBSMandatoryStatus();
    if (this.masterData && Object.keys(this.masterData).length > 0) {
      this.loadSessionTypeDropDown();
      this.loadSessionFormatDropdown();
    }
    if (e === 'Deloitte') {
      this.commentsPlaceholder = 'Comments';
    } else {
      this.commentsPlaceholder = '';
    }
    if (
      !this.session.approvalStatus ||
      this.session.approvalStatus === 'To Review'
    ) {
      this.session.approvalStatus = 'Approval Pending';
    }
    if (
      e === 'ExternalNonClient' &&
      (this.session.sessionTypes == 1 ||
        this.session.sessionTypes == 8 ||
        this.session.sessionTypes == 16 ||
        this.session.sessionTypes == 24)
    ) {
      this.session.sessionTypes = 16;
      this.onAudiencetypeProbono(this.session.sessionTypes);
    } else if (
      e === 'MixedAudience' &&
      (this.session.sessionTypes == 1 ||
        this.session.sessionTypes == 8 ||
        this.session.sessionTypes == 16 ||
        this.session.sessionTypes == 24)
    ) {
      this.session.sessionTypes = 24;
      this.onAudiencetypeProbono(this.session.sessionTypes);
    } else {
      this.showProBono = false;
      this.session.proBono = null;
    }

    if (e === 'Deloitte') {
      this.showSessionNotApproved = false;
    } else {
      this.showSessionNotApproved = true;
    }

    setTimeout(() => {
      const obj = { Name: this.companyName };
      this.session.companyName = obj;

      // this if condition will execute on change of Session Audiance
      // on initial load this if condition will not execute
      if (flag !== false) {
        if (!this.session.companyName.Name && e != 'Deloitte') {
          if (
            this.session.sessionName &&
            this.session.sessionName.includes('Deloitte')
          )
            this.tempSessionName = this.session.sessionName;
          this.session.sessionName = '';
        }
        if (this.session.sessionName && this.session.companyName.Name)
          this.generateSessionName(); // on change of Audiance generate the Session Name

        if (
          this.tempSessionName &&
          !this.session.companyName.Name &&
          e === 'Deloitte'
        ) {
          this.session.sessionName = this.tempSessionName;
        }
      }
    }, 150);

    this.resetChargebackFields();
    this.calculateChargebackAndSurcharge();

    if (flag) {
      this.updateSecRestrictedOptionsOnChangeAudience();
    } else {
      this.updateSecRestrictedOptionsAtInitialLoad();
    }
    this.checkInvalidCompany();
  }

  isSelected(name: string): boolean {
    if (!this.selectedLink) {
      return false;
    }

    return this.selectedLink === name;
  }

  formatMatches = (value: any) => value.Name || null;
  formatCoordinator = (value: any) =>
    value && value.EmailAddress
      ? value.FirstName + ' ' + value.LastName + '(' + value.EmailAddress + ')'
      : '';
  formatPPMD = (value: any) =>
    value && value.AD_EmailAdress
      ? value.Name_First +
      ' ' +
      value.Name_Last +
      ' ' +
      '(' +
      value.AD_EmailAdress +
      ')'
      : '';
  formatPPMDSelection = (value: any) => {
    if (value && value.Name_First && value.Name_Last) {
      this.invalidppmd = false;
      return value.Name_First + ' ' + value.Name_Last;
    }
    return '';
  };
  formatFacillitator = (value: any) =>
    value && value.Email
      ? value.FirstName + ' ' + value.LastName + '(' + value.Email + ')'
      : '';

  searchword = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => (this.searching = true)),
      switchMap((term) =>
        this.SessionService.searchword(term, 0).pipe(
          tap(() => (this.searchFailed = false)),
          catchError(() => {
            this.searchFailed = true;
            return of([]);
          })
        )
      ),
      tap(() => (this.searching = false))
    );
  searchPPMD = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      tap(() => (this.searching = true)),
      switchMap((term) => {
        this.invalidppmd = true;
        this.textLimitErrorPPMD =
          term && term.length > 0 && term.length < 3 ? true : false;
        return this.SessionService.searchword(term, 1).pipe(
          tap(() => (this.searchFailed = false)),
          catchError(() => {
            this.searchFailed = true;
            return of([]);
          })
        );
      }),
      tap(() => (this.searching = false))
    );

  searchCoordinator = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      tap(() => (this.searching = true)),
      switchMap((term) => {
        this.textLimitErrorCoordinator =
          term && term.length > 0 && term.length < 3 ? true : false;
        return this.SessionService.searchword(term, 2).pipe(
          tap(() => (this.searchFailed = false)),
          catchError(() => {
            this.searchFailed = true;
            return of([]);
          })
        );
      }),
      tap(() => (this.searching = false))
    );

  searchFacilitators = (
    text$: Observable<string>
  ): Observable<readonly FacilitatorResult[]> =>
    text$.pipe(
      debounceTime(250),
      map((term) => (term || '').trim()),
      distinctUntilChanged((prev, curr) =>
        prev.toLowerCase() === curr.toLowerCase()
      ),
      tap(() => (this.searching = true)),
      switchMap((term) => {
        if (term.length === 0) {
          this.searching = false;
          return of([]);
        }

        const sessionType = this.session.sessionType;
        const sessionTypes = Number(this.session.sessionTypes);
        const contentArea = Number(this.session.contentArea);
        const topic = this.session.Topic;
        const sessionTypesEvent = this.session.sessionTypesEvent;
        const isRole2468 =
          this.userRoleID === 2 ||
          this.userRoleID === 4 ||
          this.userRoleID === 6 ||
          this.userRoleID === 8;
        const isRole153 =
          this.userRoleID === 1 || this.userRoleID === 5 || this.userRoleID === 3;
        const isDeloitteExternalMixed =
          sessionType == 'Deloitte' ||
          sessionType == 'ExternalClient' ||
          sessionType == 'MixedAudience';

        let CertificationlevelID = 0;
        if (
          ((isRole2468 && isDeloitteExternalMixed) ||
            sessionType == 'ExternalNonClient') &&
          !(
            (this.session.contentArea == null || this.session.contentArea == 0) &&
            sessionType == 'ExternalNonClient'
          ) &&
          ((sessionTypes == 1 && contentArea == 2) ||
            sessionTypes == 8 ||
            sessionTypes == 16 ||
            sessionTypes == 24)
        ) {
          CertificationlevelID = 1;
        }
        if (
          contentArea == 2 &&
          this.userRoleID === 1 &&
          (sessionTypes == 4 ||
            sessionTypes == 10 ||
            sessionTypes == 18 ||
            sessionTypes == 27)
        ) {
          CertificationlevelID = 1;
        }
        //if (this.session.proBono == 'yes') {
        //  CertificationlevelID = 0;
        //}
        let facilitatorCount = this.selectedFacilitator.length;
        const isRole153SessionAllowed =
          (isRole153 &&
            isDeloitteExternalMixed &&
            (sessionTypes == 1 || sessionTypes == 8 || sessionTypes == 24)) ||
          (this.userRoleID === 1 &&
            (sessionTypes == 4 ||
              sessionTypes == 10 ||
              sessionTypes == 18 ||
              sessionTypes == 27));
        const isRole2468SessionAllowed =
          isRole2468 &&
          isDeloitteExternalMixed &&
          (sessionTypes == 1 || sessionTypes == 8 || sessionTypes == 24);

        if (
          this.isClientCertifiedFacilitator === false &&
          facilitatorCount >= 1 &&
          (((!isRole153SessionAllowed) && contentArea == 2) || isRole2468SessionAllowed)
        ) {
          facilitatorCount = 0;
        }

        this.FacilitatorCount = facilitatorCount;

        const cacheKey = [
          term.toLowerCase(),
          facilitatorCount,
          CertificationlevelID,
          this.userRoleID,
          sessionType,
          sessionTypes,
          contentArea,
          topic,
          sessionTypesEvent,
          this.selectedFacilitator.length,
          this.isClientCertifiedFacilitator,
        ].join('|');
        const cachedResult = this.facilitatorSearchCache.get(cacheKey);
        if (cachedResult) {
          this.searchFailed = false;
          this.searching = false;
          return of(cachedResult);
        }

        return this.SessionService.searchFacilitator(
          facilitatorCount,
          term,
          CertificationlevelID,
          sessionTypes,
          contentArea,
          topic,
          sessionTypesEvent,
          sessionType
        ).pipe(
          map((facilitators) => facilitators as readonly FacilitatorResult[]),
          tap((facilitators) => {
            this.searchFailed = false;
            if (this.facilitatorSearchCache.size >= this.facilitatorSearchCacheLimit) {
              const firstKey = this.facilitatorSearchCache.keys().next().value;
              if (firstKey) {
                this.facilitatorSearchCache.delete(firstKey);
              }
            }
            this.facilitatorSearchCache.set(cacheKey, facilitators);
          }),
          catchError(() => {
            this.searchFailed = true;
            return of([]);
          }),
          finalize(() => (this.searching = false))
        );
      })
    );

  onOpenChargeCodeAccordian() {
    var chargebackfees: any = document.getElementById('chargebackfees');
    if (chargebackfees) {
      //this.wbsDisable =
      //  chargebackfees.disabled
      //    && (this.session.gxFees == null || this.session.gxFees == 0)
      //    ? true
      //    : false;
      this.disableAddWBS = this.wbsDisable ? true : false;
      this.onWbsCodeEntered();
    }
    // Update WBS mandatory status
    this.updateWBSMandatoryStatus();
  }
  /**
   * Returns true when the Charge Codes (WBS) accordion is hidden from the user,
   * mirroring the exact [hidden] binding on #tab4 in the template.
   * When the accordion is hidden the field cannot be filled, so WBS must never
   * be treated as mandatory.
   */
  isWBSAccordionHidden(): boolean {
    return (
      (
        (this.userRoleID != 1 && this.userRoleID != 3) &&
        (
          this.session.sponsoredCountry != 23 ||
          (
            this.session.sessionTypes != 8 &&
            this.session.sessionTypes != 16 &&
            this.session.sessionTypes != 24 &&
            this.session.sessionTypes != 33 &&
            this.session.sessionTypes != 34 &&
            this.session.sessionTypes != 35 &&
            !((this.session.sessionTypes == 13 && this.session.sessionSubTypes != 2) || (this.session.sessionTypes == 20 && this.session.sessionSubTypes != 6)) &&
            //this.session.sessionTypes != 14 &&
            //this.session.sessionTypes != 21 &&
            //this.session.sessionTypes != 15 &&
            //this.session.sessionTypes != 30 &&
            //this.session.sessionTypes != 23 &&
            this.session.sessionTypesEvent != 17 &&
            this.session.sessionTypesEvent != 18 &&
            this.session.sessionTypesEvent != 19
          )
        )
      ) ||
      this.isSelected('Deloitte')
    );
  }
  updateWBSMandatoryStatus() {
    // WBS is mandatory when it's enabled (not disabled) and for non-Deloitte sessions
    const allowedTypes = [8, 13, 14, 15, 16, 20, 21, 23, 24, 28, 30, 33, 34, 35];
    const XAEvent = [11, 19, 26];
    const allowedXAEvent = [6, 10, 14, 17, 18, 19]
    const allowedTransLAb = [7, 11, 15];
    const allowedProgram = [193, 194, 194];
    const disableTypes = [3, 4, 5, 9, 10, 12, 17, 18, 22, 25, 27, 29];
    const xaTypesWithEventRules = [2, 11, 19, 26];
    const xaEventDisableList = [1, 2, 4, 5, 6, 8, 9, 10, 12, 13, 14, 16];
    const transLabEventList = [3, 7, 11, 15];
    const excludedProgramIds = [192, 193, 194, 195];
    const subTypeBasedDisableTypes = [13, 20];
    const subTypeDisableList = [2, 6];

    const sessionType = Number(this.session.sessionTypes);
    const sessionTypeEvent = Number(this.session.sessionTypesEvent);
    const sessionTypeProgram = Number(this.session.sessionTypesProgram);
    const sessionSubType = Number(this.session.sessionSubTypes);

    this.wbsDisable =
      this.session.proBono == 'yes' || this.disableSubscriptionFields ||
      disableTypes.includes(sessionType) ||
      (xaTypesWithEventRules.includes(sessionType) && xaEventDisableList.includes(sessionTypeEvent)) ||
      (xaTypesWithEventRules.includes(sessionType) &&
        transLabEventList.includes(sessionTypeEvent) &&
        !excludedProgramIds.includes(sessionTypeProgram)) ||
      (subTypeBasedDisableTypes.includes(sessionType) && subTypeDisableList.includes(sessionSubType));
   
    if ((allowedTypes.includes(Number(this.session.sessionTypes))) ||
      ((XAEvent.includes(Number(this.session.sessionTypes))) && (allowedXAEvent.includes(Number(this.session.sessionTypesEvent)))) ||
      ((XAEvent.includes(Number(this.session.sessionTypes))) && (allowedTransLAb.includes(Number(this.session.sessionTypesEvent))) && (allowedProgram.includes(Number(this.session.sessionTypesProgram))))
    ) {
      // WBS is mandatory only when:
      // 1. Not Deloitte session
      // 2. Sponsored country is US (23)
      // 3. WBS is not disabled
      // 4. SFDC is not disabled (user can edit)
      // 5. Not pro-bono
      // 6. No subscription ID
      // 7. Not a new session created by admin (sessionId == 0 && userRoleID == 1)
      // 8. SFDC Integration is not disabled (this.session.disableSFDCIntegration should be false)
      if ((!this.isSelected('Deloitte') && 
           this.session.sponsoredCountry == 23 && 
           !this.wbsDisable && 
           !this.sfdcDisabled && 
           this.session.proBono != 'yes' && 
           !this.session.subscriptionId &&
           !(this.userRoleID == 1) &&
           !this.session.disableSFDCIntegration)) {
        this.isWBSMandatory = true;
      } else {
        this.isWBSMandatory = false;
      }
    }
    else {
      this.isWBSMandatory = false;
    }
    // Final guard: if the WBS accordion is hidden the user cannot fill in a WBS
    // code, so it must never be treated as mandatory regardless of the above logic.
    if (this.isWBSAccordionHidden()) {
      this.isWBSMandatory = false;
      this.invalidWBS = false;
      this.wbsid = null;
      this.wbsError = false;
    }
  }

  private shouldUseWbsPicklist(): boolean {
    const allowedTypes = [8, 13, 14, 15, 16, 20, 21, 23, 24, 28, 30, 33, 34, 35];
    const XAEvent = [11, 19, 26];
    const allowedXAEvent = [6, 10, 14, 17, 18, 19];
    const allowedTransLAb = [7, 11, 15];
    const allowedProgram = [193, 194, 194];

    const isAllowedType =
      allowedTypes.includes(Number(this.session.sessionTypes)) ||
      (XAEvent.includes(Number(this.session.sessionTypes)) &&
        allowedXAEvent.includes(Number(this.session.sessionTypesEvent))) ||
      (XAEvent.includes(Number(this.session.sessionTypes)) &&
        allowedTransLAb.includes(Number(this.session.sessionTypesEvent)) &&
        allowedProgram.includes(Number(this.session.sessionTypesProgram)));

    if (!isAllowedType) {
      return false;
    }

    return (
      !this.isSelected('Deloitte') &&
      this.session.sponsoredCountry == 23 &&
      !this.wbsDisable &&
      //!this.sfdcDisabled &&
      this.session.proBono != 'yes' &&
      !this.session.subscriptionId &&
      !this.session.disableSFDCIntegration
    );
  }
  checkWbsDisable(wbsItem: any): boolean {
    // Check if this specific WBS code should be enabled based on SFDC status
    // Returns true if WBS should be disabled, false if it should be enabled
    if (this.SFWbsStatus?.length > 0 && wbsItem?.wbsCode) {
      for (const event of this.SFWbsStatus) {
        for (const wbs of event.WbsStatus) {
          if (wbsItem.wbsCode === wbs.WbsCode && wbs.Status === 'Ready to Process') {
            // WBS is in SFDC with 'Ready to Process' status, should be enabled
            return false;
          }
        }
      }
    }
    // Default: return true (disabled) if not found in SFDC or no match
    return true;
  }
  sfdcDisabled: any;
  isWBSFieldDisabled(item: any): boolean {
    // Determine if a specific WBS field should be disabled
    if (
      this.isSessionCreatedBeforeMdmWbsDeploymentDate &&
      item?.isExistingWbs &&
      item?.isWbsActive === false
    ) {
      return true;
    }
    const hasInactiveExisting = this.multipleWBS?.some(
      (wbsItem) => wbsItem.isExistingWbs && wbsItem.isWbsActive === false
    );
    const ignoreWbsDisableForReplacement =
      this.operationType === 'Edit' && hasInactiveExisting && !item?.isExistingWbs;
    const effectiveWbsDisable = ignoreWbsDisableForReplacement ? false : this.wbsDisable;
    // First check the base disable conditions
    const baseDisabled = (!item.isNewWbsCode &&
      (this.isSessionCreatedFromCommercialization || 
       (this.sessionId !== 0 && this.userRoleID == 4 && this.session.approvalStatus == 'Approved') || 
       (this.sessionId !== 0 && this.session.approvalStatus == 'Approved' && this.session.subscriptionId && item.wbsCode && (this.userRoleID != 1 && this.userRoleID != 3)) || 
       (this.eventName != '' && this.eventName != null) || 
       (this.userRoleID == 3 && this.session.approvalStatus == 'Approved' && (this.sessionId != 0 && this.session.subscriptionId && this.session.sponsoredCountry == 23 && item.wbsCode))
      )) || effectiveWbsDisable;
    
    // If base conditions say it's disabled, check if SFDC status allows it to be enabled
    if (baseDisabled && this.sessionId !== 0) {
      // Check SFDC status - if checkWbsDisable returns false, the field should be enabled
       this.sfdcDisabled = this.checkWbsDisable(item);
      return this.sfdcDisabled; // Return SFDC decision
    }
    
    // Return the base disabled state
    return baseDisabled;
  }
  resetSelectedFacilitator() {
    if (
      !(
        this.sessionId !== 0 &&
        (this.session.approvalStatus == 'Approved' ||
          (this.userRoleID === 4 && this.session.approvalStatus != 'Draft')) &&
        this.userRoleID !== 1 &&
        this.userRoleID != 3
      )
    ) {
      this.selectedFacilitator = [];
    }
  }

  searchCompanies = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => (this.searching = true)),
      switchMap((term) =>
        this.SessionService.searchword(term, 0).pipe(
          tap(() => (this.searchFailed = false)),
          catchError(() => {
            this.searchFailed = true;
            return of([]);
          })
        )
      ),
      tap(() => (this.searching = false))
    );

  // WBS Code typeahead search - triggers only when complete WBS (22 characters) is entered
  // and only for US (sponsoredCountry = 23)
  searchWBS = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => (this.searchingWBS = true)),
      switchMap((term) => {
        if (!this.shouldUseWbsPicklist()) {
          this.searchingWBS = false;
          return of([]);
        }
        
        if (!term || term.length < 22) {
          this.searchingWBS = false;
          return of([]);
        }
        return this.SessionService.getWBSCodes(term).pipe(
          tap(() => (this.searchFailed = false)),
          catchError(() => {
            this.searchFailed = true;
            return of([]);
          }),
          // Use finalize to ensure searchingWBS flag is reset when API completes
          finalize(() => (this.searchingWBS = false)),
          // Use shareReplay to keep the request alive even after ngbTypeahead unsubscribes on blur
          // This prevents the API call from being cancelled when user focuses out
          shareReplay(1)
        );
      })
    );

  searchWBSSurcharge = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => (this.searchingWBSSurcharge = true)),
      switchMap((term) => {
        if (!this.shouldUseWbsPicklist()) {
          this.searchingWBSSurcharge = false;
          return of([]);
        }

        if (!term || term.length < 22) {
          this.searchingWBSSurcharge = false;
          return of([]);
        }

        return this.SessionService.getWBSCodes(term).pipe(
          tap(() => (this.searchFailed = false)),
          catchError(() => {
            this.searchFailed = true;
            return of([]);
          }),
          finalize(() => (this.searchingWBSSurcharge = false)),
          shareReplay(1)
        );
      })
    );

  // Format WBS for display in typeahead dropdown
  formatWBS = (wbs: any) => {
    if (wbs && typeof wbs === 'object') {
      // Use Element field from new API response structure
      return wbs.Element || wbs.WBSCode || wbs.wbsCode || '';
    }
    return wbs || '';
  };

  // Handle WBS selection from typeahead dropdown
  onWBSSelect(event: any, itemId: number) {
    if (event && event.item) {
      // Prevent ngbTypeahead from setting the model to the object
      event.preventDefault();
      
      const selectedWBS = event.item;
      // Use Element and DunsNumber from new API response structure
      const wbsCode = selectedWBS.Element || selectedWBS.WBSCode || selectedWBS.wbsCode || '';
      const wbsDunsID = (selectedWBS.DunsNumber || selectedWBS.DunsID || selectedWBS.dunsId || '').toString().trim();
      const companyDunsID = (this.selectedCompanyDunsID || '').toString().trim();
      const shouldBypassDunsValidation = this.shouldBypassWbsDunsValidation(wbsCode);
      
      // Update the WBS code in multipleWBS array
      this.multipleWBS.map((item) => {
        if (item.id === itemId) {
          item.wbsCode = wbsCode;
          item.wbsDunsID = wbsDunsID;
          item.isNewWbsCode = true;
          item.isSelectedFromPicklist = true; // Mark as selected from picklist
          item.isExistingWbs = false;
          item.isWbsActive = true;
          item.isWbsStatusChecked = true;
          item.isWbsStatusChecking = false;
        }
      });

      // Validate DunsID matches with selected company's DunsID
      if (!shouldBypassDunsValidation && (!companyDunsID || !wbsDunsID || companyDunsID !== wbsDunsID)) {
        this.invalidWBSDunsID = true;
        this.invalidWBS = true;
        this.wbsid = itemId;
        $('#' + itemId).addClass('is-invalid');
      } else {
        this.invalidWBSDunsID = false;
        // Re-run standard WBS validation
        this.validateWBSCode();
        // Open WBS popup after valid selection
        this.openWBSpopup();
      }

      this.isInputWbsChanged = true;
      this.updateWBSMandatoryStatus();
      this.onWbsCodeEntered();
      this.updateInactiveWbsState();
      this.syncSurchargeWbsFromPrimary();
    }
  }

  onWBSSelectForSurcharge(event: any, itemId: any) {
    if (event && event.item) {
      event.preventDefault();

      const selectedWBS = event.item;
      const wbsCode = selectedWBS.Element || selectedWBS.WBSCode || selectedWBS.wbsCode || '';

      this.multipleWBSForSurcharge.map((item) => {
        if (item.id === itemId) {
          item.wbsCode = wbsCode;
          item.isNewSurchargeCode = true;
          item.isSelectedFromPicklist = true;
          item.isExistingWbs = false;
          item.isWbsActive = true;
          item.isWbsStatusChecked = true;
          item.isWbsStatusChecking = false;
        }
      });

      this.validateWBSCodeForSurcharge();
      this.isInputWbsSurchargeChanged = true;
      this.onWbsCodeEnteredForSurcharge();
    }
  }

  onCompanySelect(companyData) {
    if (companyData && companyData.item) {
      if (this.sessionId === 0) {
        this.generateSessionName();
      }
      if (!this.disableSubscriptionFields) {
        this.session.clientProgram = companyData.item.ClientProgramID
          ? companyData.item.ClientProgramID
          : null;
        this.session.sessionIndustry = companyData.item.IndustryID
          ? companyData.item.IndustryID
          : null;
        this.industryChange(this.session.sessionIndustry);
        this.session.sessionSector = companyData.item.SectorID
          ? companyData.item.SectorID
          : null;
        const item = this.dropdownData_Sectors.find(
          (index) => index.SectorID == companyData.item.SectorID
        );
        if (item == undefined) {
          this.session.sessionSector = null;
        } else {
          this.session.sessionSector = companyData.item.SectorID;
        }
      }

      this.clickedCountry = companyData.item.ID;
      this.selectedCompany = companyData.item.Name;
      // Store DunsID from selected company for WBS validation
      this.selectedCompanyDunsID = companyData.item.DunsID || '';
      // Reset WBS DunsID validation when company changes
      this.invalidWBSDunsID = false;
      this.checkInvalidCompany();
      
      // Re-validate existing WBS codes against new company's DUNS ID
      if (this.multipleWBS && this.multipleWBS.length > 0 && this.multipleWBS[0].wbsCode) {
        this.validateWBSCode();
      }
    }
  }
  enableContentArea() {
    this.session.contentArea = null;
    this.session.Topic = null;
    if (
        Number(this.session.sessionTypes) === 1 ||
        Number(this.session.sessionTypes) === 8 ||
        Number(this.session.sessionTypes) === 16 ||
        Number(this.session.sessionTypes) === 24 ||

      Number(this.session.sessionTypes) === 4 ||
      Number(this.session.sessionTypes) === 10 ||
      Number(this.session.sessionTypes) === 18 ||
      Number(this.session.sessionTypes) === 27 ||

      ((Number(this.session.sessionTypes) === 11 ||
        Number(this.session.sessionTypes) === 19 ||
        Number(this.session.sessionTypes) === 26) &&
        (Number(this.session.sessionTypesEvent) == 17 ||
          Number(this.session.sessionTypesEvent) == 18 ||
          Number(this.session.sessionTypesEvent) == 19))
    ) {
      this.disableContentArea = false;
    } else {
      this.disableContentArea = true;
    }
  }
  onContentChange() {
    this.session.Topic = null;

    this.disableApproveOptions();
  }
  generateSessionName() {
    if (this.session.sessionDate && this.session.sessionDepartment) {
      let companyName = '';
      if (this.session.sessionType == 'Deloitte') {
        companyName = 'Deloitte';
      } else if (!this.session.companyName.Name)
        companyName =
          this.session.companyName &&
            typeof this.session.companyName == 'string'
            ? this.session.companyName
            : '';
      else
        companyName = this.session.companyName
          ? this.session.companyName.Name
          : '';

      const department =
        this.session.sessionDepartment == 26
          ? this.session.otherDepartment?.trim()
          : this.dropdownData.Departments.find(
            (index) => index.ID == this.session.sessionDepartment
          ).Name;
        if (companyName) {
        let sessionName = companyName;
        if (department) {
          sessionName += ' - ' + department;
        }
        sessionName += ' - ' + this.dateToString(this.session.sessionDate);

        this.session.sessionName = sessionName;
        this.disableSessionName = false;
        this.invalidSessionName = false;
      } 
    }
  }

  getSessionData() {
    this.showLoader = true;
    this.masterDataService.getMasterDataDetails().subscribe((res) => {
      this.dropdownData = JSON.parse(JSON.stringify(res));
      this.masterData = JSON.parse(JSON.stringify(res));
      this.loadTopicDropdown();
      this.loadSponsoringCountry();
      this.loadSessionCountry();
      this.loadServiceFunctionDropdown();
      this.loadIndustryDropdown();
      this.loadDepartmentDropdown();
      this.loadSFDCDisableReasons();
      this.allCountriesList = this.dropdownData.Countries;
    });
  }
  loadSessionCountry() {
    this.sessionCountryMasterData = this.dropdownData.Countries.filter(
      (country) => country.ID != 266
    );
  }
  getSessionAllFacilitators() {
    this.showLoader = true;
    this.SessionService.getSessionAllFacilitatorsData().subscribe((res) => {
      this.facilitatorsData = res;
      setTimeout(() => {
        // this.checkIfEditMode();
        // this.closeConfirmPopUp();
        // $("#mypopup").modal("hide");
      }, 3000);
    });
  }
  getSessionAllCoordinators() {
    this.SessionService.getSessionAllCoordinatorsData().subscribe((res) => {
      this.coordinatorsData = res.Data;
    });
  }

  onDropdownSelect(id, masterData, listType, parentId) {
    let list = masterData[listType] ? masterData[listType] : [];
    let modifiedCityList = [];
    if (Number(id)) {
      modifiedCityList = list.filter((data) => data[parentId] == id);
      list = JSON.parse(JSON.stringify(modifiedCityList));
    }
    return list;
  }

  onSearchCoordinator(text) {
    this.coordinatorsData = [];
    if (text.length > 2) {
      this.SessionService.getSessionAllCoordinatorsData().subscribe((res) => {
        this.coordinatorsData = res.Data;
      });
    }
  }

  updateCoordinator(event, operation, stopExecution?, restrictLoad?) {
    const item = event.item ? event.item : event;
    if (item && operation) {
      if (operation == 'add') {
        if (item.Email == undefined) {
          item.Email = item.EmailAddress;
        }

        if (item.EmailAddress == undefined) {
          item.EmailAddress = item.Email;
        }

        if (item.UserId == undefined) {
          item.UserId = item.ID;
        }

        this.selectedCoordinators.forEach((c) => {
          if (c.Email == undefined) {
            c.Email = c.EmailAddress;
          }
        });

        const existingEmail = this.selectedCoordinators.find(
          (data) => data.Email.toLowerCase() == item.Email.toLowerCase()
        );
        if (!existingEmail) {
          this.selectedCoordinators.push(item);
          if (!existingEmail && stopExecution) {
            this.existingCoordinatorlist.push(JSON.parse(JSON.stringify(item)));
          }
        }
      }

      if (operation == 'delete') {
        this.selectedCoordinators = this.selectedCoordinators.filter(
          (data) => data.UserId != item.UserId
        );
        if (stopExecution) {
          this.existingCoordinatorlist = this.existingCoordinatorlist.filter(
            (data) => data.UserId != item.UserId
          );
        }
      }
    }

    if (event.item && stopExecution) {
      event.preventDefault();
    }
    this.session.sessionCoordinators = null;
    if (!restrictLoad) {
      this.isaudienceChanged = true;
      this.issubmitEnable = true;
    }
  }

  updateCertifiedFacilitator(event, operation) {
    const item = event.item ? event.item : event;
    if (item && operation) {
      if (operation == 'add') {
        const existingEmail = this.selectedFacilitator.find(
          (data) => data.Email.toLowerCase() == item.Email.toLowerCase()
        );
        if (!existingEmail) {
          this.selectedFacilitator.push(item);
        }
      }

      if (operation == 'delete') {
        this.selectedFacilitator = this.selectedFacilitator.filter(
          (data) => data.ID != item.ID
        );
      }
    }

    if (event.item) {
      event.preventDefault();
      this.session.certifiedFacilitator = null;
    }
    this.isaudienceChanged = true;
    this.issubmitEnable = true;
    // checking for client certified facilitator
    const existingClientCertifiedFacilitator = this.selectedFacilitator.find(
      (data) => data.CertificationlevelID == 1
    );
    if (existingClientCertifiedFacilitator) {
      this.isClientCertifiedFacilitator = true;
      // If topic is selected, check if any facilitator has that topic
      if (this.session.Topic) {
        const facilitatorHasTopic = this.selectedFacilitator.some((facilitator) => {
          if (!facilitator.topics) return false;
          const facilitatorTopics = facilitator.topics.split(',').map(t => t.trim());
          return facilitatorTopics.includes(String(this.session.Topic));
        });
        if (!facilitatorHasTopic) {
          this.isClientCertifiedFacilitator = false;
        }
      }
    } else {
      this.isClientCertifiedFacilitator = false;
    }
    this.checkCertifiedFacilitators();
  }

  selectedSessionTypeDescription: any;
  selectedSessionTypeName: string = '';
  onSelectSessionType(sessionTypeId, changeThroughHTML?) {
    this.enableContentArea();
    if (
      Number(sessionTypeId) == 4 ||
      Number(sessionTypeId) == 10 ||
      Number(sessionTypeId) == 18 ||
      Number(sessionTypeId) == 27 ||
      Number(sessionTypeId) == 3 ||
      Number(sessionTypeId) == 9 ||
      Number(sessionTypeId) == 17 ||
      Number(sessionTypeId) == 25 ||
      Number(sessionTypeId) == 5 ||
      Number(sessionTypeId) == 12 ||
      Number(sessionTypeId) == 22 ||
      Number(sessionTypeId) == 29 ||
      Number(sessionTypeId) == 6 ||
      Number(sessionTypeId) == 31 ||
      Number(sessionTypeId) == 32 ||
      Number(sessionTypeId) == 7
    ) {
      this.doNotIntegrateWithSalesforce = true;
    } else {
      this.doNotIntegrateWithSalesforce = false;
    }
    this.showSpecify = false;
    this.showAuditLabSubType = false;
    this.specifyLabel = '';
    this.session.sessionTypeSpecify = '';
    this.showEvent = false;
    this.showProgram = false;
    this.showProBono = false;
    this.session.proBono = null;
    this.proBonoYes = false;
    this.showSessionSubType = false;
    this.session.sessionSubTypes = null;
    this.isSubTypeMandatory = false;
    this.session.sessionTypesEvent = null; //this statement has added for fixing Bug-1953848
    this.session.sessionTypesProgram = null;
    this.pleaseSpecifyFieldLength = 0;
    this.getSelectedSessionTypeName(sessionTypeId);
    let selectedSessionTypeData = null;
    this.optOut = null;
    this.OptOutReason = '';
    if (sessionTypeId) {
      if (
        this.dropdownData &&
        this.dropdownData.SessionType &&
        this.dropdownData.SessionType.length > 0
      ) {
        const item = this.dropdownData.SessionType.find(
          (data) => data.SessionTypeID == sessionTypeId
        );
        selectedSessionTypeData = item;
        this.isSubTypeMandatory =
          item && item.IsMetaDataMandatory ? item.IsMetaDataMandatory : false;
      }
      if (
        sessionTypeId == 2 ||
        sessionTypeId == 11 ||
        sessionTypeId == 19 ||
        sessionTypeId == 26
      ) {
        this.showEvent = true;
        if (this.masterData && this.masterData.SessionTypeEvents.length > 0) {
          this.dropdownData.SessionTypeEvents =
            this.masterData.SessionTypeEvents.filter(
              (event) => event.sessiontypeID == sessionTypeId
            );
        }

        this.session.sessionTypesEvent = null;
      } else if (sessionTypeId == 13 || sessionTypeId == 20) {
        this.showSessionSubType = true;
        if (this.masterData && this.masterData.SessionSubType.length > 0) {
          this.dropdownData.SessionSubType =
            this.masterData.SessionSubType.filter(
              (event) => event.SessionTypeID == sessionTypeId
            );
        }
      } else {
        const item = this.dropdownData.SessionType.find(
          (index) => index.SessionTypeID == sessionTypeId
        );
        if (item && item.SessionMetaData) {
          this.specifyLabel = item.SessionMetaData;
          if (item.SessionMetaData.includes('pro-bono')) {
            this.showProBono = true;
          } else {
            this.showSpecify = true;
            this.session.sessionTypeSpecify = '';
          }
        }
      }
    }
    this.resetChargebackFields();
    this.calculateChargebackAndSurcharge();

    if (
      changeThroughHTML == true &&
      selectedSessionTypeData != null &&
      selectedSessionTypeData != undefined
    ) {
      this.selectedSessionTypeDescription =
        selectedSessionTypeData?.Popup_Description;
      this.selectedSessionTypeName = selectedSessionTypeData.SessionTypeName;
      this.OpenSessionConfirmationPopUp();
    } else {
      this.selectedSessionTypeDescription = '';
      this.selectedSessionTypeName = '';
      const sessionPopUp = new Modal(document.getElementById('sessionPopUp'));
      sessionPopUp.hide();
      // $("#sessionPopUp").modal("hide");
    }

    this.disableApproveOptions();
    if (this.userRoleID === 5) {
      this.session.approvalStatus = this.approvalStatus;
    }

    // set the session type and session format list
    this.setSessionTypeAndSessionFormatList(this.session.subscriptionId);
  }
  getUniqueList(array, property) {
    const uniqueList = [
      ...new Map(array.map((item) => [item[property], item])).values(),
    ];
    return uniqueList;
  }

  //US: 2636088
  public OpenSessionConfirmationPopUp() {
    const sessionPopUp = new Modal(document.getElementById('sessionPopUp'));
    sessionPopUp.show();
    this.removeBackdrop();

    // $("#sessionPopUp").modal({
    //   backdrop: "static",
    //   keyboard: false,
    // });

    // $("#sessionPopUp").modal("show");
    // $(".modal-backdrop").remove();
  }

  // US: 2636088
  // reset the session type and dependent field
  NoBtnClicked() {
    const sessionPopUp = new Modal(document.getElementById('sessionPopUp'));
    sessionPopUp.hide();
    // $("#sessionPopUp").modal("hide");
    this.resetChargebackFields();
    this.resetSessionType();
    this.disableApproveOptions();
    this.disableContentArea = true;
  }

  resetSessionType() {
    this.session.sessionTypes = null;
    this.session.sessionSubTypes = null;
    this.session.sessionTypesEvent = null;
    this.session.sessionTypesProgram = null;
    this.session.sessionTypeSpecify = null;
    this.showSessionSubType = false;
    this.showEvent = false;
    this.showProgram = false;
    this.showSpecify = false;
    this.showProBono = false;
    this.session.proBono = null;
    this.session.sessionTypeSpecify = '';
    this.session.contentArea = null;
    this.session.Topic = null;
  }

  // US: 2636088
  //session type will remain same
  yesBtnClicked() {
    const sessionPopUp = new Modal(document.getElementById('sessionPopUp'));
    sessionPopUp.hide();
    //  $("#sessionPopUp").modal("hide");
  }

  sessioneventobj: any;

  onSessionEventChange(eventId) {
    this.sessioneventobj = this.dropdownData.SessionTypeEvents.filter(
      (b) =>
        b.Name == 'Finance Leadership Program (FLP)' ||
        b.Name == 'DU Client Experience Team-Led Standard Session'
    );

    //only if condition has added for fixing Bug-1953848
    if (eventId == null || eventId == 0) {
      this.showSpecify = false;
    } else if (
      eventId != 0 &&
      this.sessioneventobj.some((data) => data.eventID == eventId)
    ) {
      this.showProgramFinance = false;
      this.showSpecify = false;
    } else {
      this.showProgramFinance = true;
    }
  }

  onAudiencetypeProbono(sessionTypes) {
    const item = this.dropdownData.SessionType.find(
      (index) => index.SessionTypeID == sessionTypes
    );
    if (item && item.SessionMetaData) {
      this.specifyLabel = item.SessionMetaData;
      if (item.SessionMetaData.includes('pro-bono')) {
        this.showProBono = true;
      }
    }
  }

  onSelectSessionTypesEvent(eventId) {
    this.showSpecify = false;
    this.showAuditLabSubType = false;
    this.pleaseSpecifyFieldLength = 0;
    if (eventId) {
      if (this.masterData && this.masterData.EventPrograms.length > 0) {
        this.dropdownData.EventPrograms = this.masterData.EventPrograms.filter(
          (program) => program.eventID == eventId
        );
        const temp = this.dropdownData.EventPrograms.splice(
          this.dropdownData.EventPrograms.findIndex(
            (res) => res.Name == 'Other'
          ),
          1
        )[0];

        if (temp) {
          this.dropdownData.EventPrograms.push(temp);
          this.showProgram = true;
        } else {
          this.showProgram = false;
        }
      }
      this.session.sessionTypesProgram = null;
      this.onSessionEventChange(eventId);
    }
    this.session.sessionTypesEvent = eventId;
    this.resetChargebackFields();
    this.calculateChargebackAndSurcharge();
  }
  onSelectSessionTypesProgram(programId) {
    if (programId) {
      //filter program specification
      if (this.masterData && this.masterData.ProgramSpecification.length > 0) {
        this.dropdownData.ProgramSpecification = this.masterData.ProgramSpecification.filter(
          (program) => program.EventProgramID == programId
        );
      }
      const item = this.dropdownData.EventPrograms.find(
        (program) => program.programID == programId
      );
      this.specifyLabel = 'Please specify';
      this.session.sessionTypeSpecify = '';
      this.pleaseSpecifyFieldLength = 0;
      if (programId != 192 && programId != 193 && programId != 194 && programId != 195) {
        this.showSpecify = item ? item.PleaseSpecify : false;
        this.showAuditLabSubType = false;
      } else {
        this.showAuditLabSubType = true;
        this.showSpecify = false;
      }
      this.resetChargebackFields();
      this.calculateChargebackAndSurcharge();
    }
  }

  onProbonoCheck(value) {
    this.session.proBono = value;
    this.proBonoYes = value == 'yes' ? true : false;
    this.calculateChargebackAndSurcharge();
    this.wbsDisable = true;
    if (value == 'no') {
      this.session.explainRationale = null;
      this.wbsDisable = false;
    }
    this.updateWBSMandatoryStatus();
    if (value == 'yes') {
      this.invalidWBS = false;
      this.wbsid = null;
      this.wbsError = false;
      this.invalidPercenatge = false;
      this.multipleWBS.forEach((item) => {
        $('#' + item.id).removeClass('is-invalid');
      });
      this.ClearWBS('all');
    }
    this.resetSelectedFacilitator();
  }
  resetOptOut() {
    this.optOut = null;
    this.OptOutReason = '';
  }
  sponsoredCountryChange(countryId, restrictPPMDChange?) {
    this.getSelectedSponsoringCountryName(countryId);
    this.showNAFields = countryId == 23 || countryId == null ? false : true;
    this.isDisplaySubText = countryId == 23 || countryId == null ? true : false;
    this.showPPMDAsTextInput =
      countryId == 23 || countryId == 259 || countryId == 265 || countryId == 266 || countryId == 267 ||countryId == 268 || countryId == 269 ? false : true;

    this.session.responsiblePpmd = !restrictPPMDChange
      ? ''
      : this.session.responsiblePpmd;
    this.loadServiceFunctionDropdown(this.showNAFields);
    this.loadIndustryDropdown(this.showNAFields);

    this.resetChargebackFields();
    this.calculateChargebackAndSurcharge();
    if (countryId && countryId == 23) {
      this.session.currencyType = 4;
    }
    this.checkInvalidCompany();
  }

  onServiceFunctionChange(id) {
    if (
      this.dropdownData.ServiceFunctions &&
      this.dropdownData.ServiceFunctions.length > 0
    ) {
      const item = this.dropdownData.ServiceFunctions.find(
        (index) => index.ID == id
      );
      this.disableServiceFunctionNA = true;
      if (item && item.Name.includes('N/A')) {
        this.disableServiceFunctionNA = false;
      }
      $('select[name="serviceLineFunction"]').removeClass('is-invalid');
    }
  }

  onSectorChange(id) {
    if (this.dropdownData_Sectors && this.dropdownData_Sectors.length > 0) {
      const item = this.dropdownData_Sectors.find(
        (index) => index.SectorID == id
      );
      this.disableSectorNA = true;
      if (item && item.SectorName.includes('N/A')) {
        this.disableSectorNA = false;
      }
    }
  }

  onCheckboxChange(event) {
    this.enableEmailInfo = event.target.checked;
    this.requiredDomainEmailsVal = event.target.checked;
    this.invalidEmailInfo = false;
    this.invalidDomainInfo = false;
    this.invalidClientAdminInfo = false;
    this.isaudienceChanged = true;
    this.issubmitEnable = true;
  }

  private dateToString = (date) => {
    const tempDay = date.day ? date.day : date.trim().split('-')[1];
    const tempMonth = date.month ? date.month : date.trim().split('-')[0];
    const year = date.year ? date.year : date.trim().split('-')[2];
    const day = tempDay.toLocaleString('en-US', {
      minimumIntegerDigits: 2,
      useGrouping: false,
    });
    const month = tempMonth.toLocaleString('en-US', {
      minimumIntegerDigits: 2,
      useGrouping: false,
    });
    return `${month}.${day}.${year}`;
  };

  private formattedDateInRequest = (date) => {
    if (date) {
      const day = date.day.toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
      const month = date.month.toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
      return `${date.year}-${month}-${day}`;
    } else {
      return ``;
    }
  };
  InvalidSessionDate: boolean = false;
  onFocusoutSessionDate(event?) {
    if (
      this.subscriptionModuleData &&
      this.subscriptionModuleData.SubscriptionStatus
    ) {
      const manualSessionDate = new Date(
        this.formattedDateInRequest(event ? event : this.session.sessionDate)
      );
      let subscriptionEndDate = this.subscriptionModuleData.EndDate.split('T');
      let subscriptionStartDate =
        this.subscriptionModuleData.StartDate.split('T');
      subscriptionEndDate = new Date(subscriptionEndDate[0]);
      subscriptionStartDate = new Date(subscriptionStartDate[0]);
      if (
        (manualSessionDate > subscriptionEndDate ||
          manualSessionDate < subscriptionStartDate) &&
        !this.subscriptionIDError &&
        !this.isSubscriptionStatusError &&
        this.subscriptionModuleData.SubscriptionStatus
      ) {
        this.InvalidSessionDate = true;
        this.disableLinkExpire = true;
      } else {
        this.InvalidSessionDate = false;
        this.disableLinkExpire = false;
        if (!event) {
          this.visibilityOfLinkExpiration();
        }
      }
    } else {
      this.InvalidSessionDate = false;
      this.disableLinkExpire = false;
    }
  }
  onDateChange(event) {
    if (event) {
      this.session.sessionDate = event.day
        ? event
        : this.formatStandardDate(event);
      this.session_date = new Date(
        this.session.sessionDate['year'],
        this.session.sessionDate['month'] - 1,
        this.session.sessionDate['day']
      );

      // if condition will execute on creating a new session
      if (this.sessionId === 0) {
        this.generateSessionName();
      }

      // Adding if() condition as Session Name should update on change of Session Audiance AND (companyName OR Department OR Date)
      if (this.sessionId !== 0 && this.afterEditIsAudianceChanged === true) {
        this.generateSessionName();
      }

      //on change of date check again whether session date is falling within the range of subscription start & end date
      if (
        this.session.subscriptionId &&
        !this.subscriptionIDError &&
        !this.isSubscriptionStatusError
      ) {
        this.updateFieldsBasedOnSubscription(
          this.subscriptionModuleData,
          false,
          false,
          true
        );
      }
      if (
        this.subscriptionModuleData &&
        this.subscriptionModuleData.SubscriptionStatus
      ) {
        const manualSessionDate = new Date(this.formattedDateInRequest(event));
        let subscriptionEndDate =
          this.subscriptionModuleData.EndDate.split('T');
        let subscriptionStartDate =
          this.subscriptionModuleData.StartDate.split('T');
        subscriptionEndDate = new Date(subscriptionEndDate[0]);
        subscriptionStartDate = new Date(subscriptionStartDate[0]);
        if (
          (manualSessionDate > subscriptionEndDate ||
            manualSessionDate < subscriptionStartDate) &&
          !this.subscriptionIDError &&
          !this.isSubscriptionStatusError
        ) {
          this.InvalidSessionDate = true;
          this.disableLinkExpire = true;
        } else {
          this.InvalidSessionDate = false;
          this.disableLinkExpire = false;
        }
      } else {
        this.InvalidSessionDate = false;
        this.disableLinkExpire = false;
      }

      if (this.maximumDate) {
        const updatedLinkExpire = this.ngbCalendar.getNext(event);
        this.session.linkExpire =
          new Date(this.formattedDateInRequest(updatedLinkExpire)).getTime() >
            new Date(this.formattedDateInRequest(this.maximumDate)).getTime()
            ? event
            : this.ngbCalendar.getNext(this.session.sessionDate);
      } else {
        this.session.linkExpire = this.ngbCalendar.getNext(
          this.session.sessionDate
        );
      }

      if (this.session_date.getTime() > this.todayDate.getTime()) {
        this.isSessionDateGreaterTodayDate = true;
      } else {
        this.isSessionDateGreaterTodayDate = false;
      }
    } else {
      this.disableSessionName = true;
    }
  }

  openFacillitator() {
    const selectedCountry = this.session.sessionCountry
      ? Number(this.session.sessionCountry)
      : 0;
    const selectedState = this.session.sessionState
      ? Number(this.session.sessionState)
      : 0;
    var selectedCity = 0;
    if (this.session.sessionCity) {
      selectedCity = !this.stateDisable
        ? this.cityList.find((data) => (data.CityID = this.session.sessionCity))
          .CityID
          ? Number(
            this.cityList.find(
              (data) => (data.CityID = this.session.sessionCity)
            ).CityID
          )
          : 0
        : 0;
    }

    // Determine certification level based on session type and content area
    let selectedCertificationLevel = 2; // default
    if ((this.session.sessionType == 'Deloitte' || this.session.sessionType == 'ExternalNonClient') && this.session.contentArea == 2) {
      selectedCertificationLevel = 3;
    } else if ((this.session.sessionType == 'ExternalClient' || this.session.sessionType == 'MixedAudience') && this.session.contentArea == 2) {
      selectedCertificationLevel = 1;
    }

    const selectedContentArea = this.session.contentArea
      ? Number(this.session.contentArea)
      : null;
    const selectedTopic = this.session.Topic
      ? Number(this.session.Topic)
      : null;

    window.open(
      '/facilitatorSearch?country=' +
      selectedCountry +
      '&state=' +
      selectedState +
      '&city=' +
      selectedCity +
      '&level=' +
      selectedCertificationLevel +
      '&contenArea=' +
      selectedContentArea +
      '&topic=' +
      selectedTopic
    );
  }

  onTabClick(tabName) {
    this.selectedTab = tabName;
    this.invalidEmailInfo = false;
    this.invalidDomainInfo = false;
    this.invalidClientAdminInfo = false;
  }

  updateDomain(domainNames: string, operation) {
    this.domainErrors = [];
    this.wrongDomains = [];
    this.session.domainInfo = '';
    this.isaudienceChanged = true;
    this.issubmitEnable = true;
    if (domainNames) {
      if (operation == 'add') {
        const domainValidator = /^([A-Z0-9-]+\.)+[A-Z]{2,10}$/i;
        const listOfDomains = domainNames
          .replace(/ /g, '')
          .replace(/\n/g, ',')
          .split(',');
        const domainErrors = new Set();
        listOfDomains.map((domain) => {
          if (domain) {
            if (
              !domainValidator.test(domain) ||
              domain.toLowerCase().startsWith('deloitte') ||
              (this.dropdownData.Deloittesubsidarydomains &&
                this.dropdownData.Deloittesubsidarydomains.find(
                  (s) => s.domainName == domain
                ))
            ) {
              domainErrors.add(
                'Invalid domain(s) found. Please correct before continuing.'
              );
              this.wrongDomains.push(domain);
              if(this.wrongDomains.length !== 0){
                this.invalidDomainInfo = false;
              }
            } else if (
              this.domainNameList.find(
                (data: string) => data.toLowerCase() == domain.toLowerCase()
              )
            ) {
              const errorMsg = domain + ' already exists';
              domainErrors.add(errorMsg);
              this.wrongDomains.push(domain);
            } else if (this.domainNameList.length == 50) {
              domainErrors.add(
                'The maximum limit of 50 domains has been exceeded.'
              );
              this.wrongDomains.push(domain);
            } else {
              this.domainNameList.push(domain);
            }
          }
        });
        this.domainErrors = Array.from(domainErrors);   
        this.session.domainInfo = this.wrongDomains.join(',');
      }
      if (operation == 'delete') {
        this.domainNameList = this.domainNameList.filter(
          (domain) => domain != domainNames
        );
        this.checkValidParticipantDetails();
      }
    } else if (this.selectedTab === 'domain') {
      this.invalidDomainInfo =
        this.enableEmailInfo && this.session.domainInfo.length === 0;
      this.invalidEmailInfo = false;
    } else {
      this.invalidEmailInfo =
        this.enableEmailInfo && this.session.participantEmailInfo.length === 0;
      this.invalidDomainInfo = false;
    }
  }

  updateParticipantEmail(emails: string, operation: string) {
    this.emailsErrors = [];
    this.wrongEmails = [];
    this.session.participantEmailInfo = '';
    this.isaudienceChanged = true;
    this.issubmitEnable = true;
    if (emails) {
      this.invalidEmailInfo = false;
      if (operation === 'add') {
        const emailValidator =
          /^[A-Z0-9._%!-+-']+@([A-Z0-9-]+\.)+[A-Z]{2,10}$/i;
        const listOfEmails = emails
          .replace(/ /g, '')
          .replace(/\n/g, ',')
          .split(','); 
        const emailsErrors = new Set();
        listOfEmails.map((email) => {
          if (email) {
            if (
              !emailValidator.test(email) ||
              email.toLowerCase().includes('@deloitte') ||
              (this.dropdownData.Deloittesubsidarydomains &&
                this.dropdownData.Deloittesubsidarydomains.find(
                  (s) => s.domainName == email.toLowerCase().split('@)')[1]
                ))
            ) {
              emailsErrors.add(
                ' Invalid email(s) found. Please correct before continuing.'
              );
              this.wrongEmails.push(email);
            } else if (
              this.participantEmailList.find(
                (data: string) => data.toLowerCase() == email.toLowerCase()
              )
            ) {
              const erroMsg = email + ' already exists';
              emailsErrors.add(erroMsg);
              this.wrongEmails.push(email);
            } else if (this.participantEmailList.length == 5000) {
              emailsErrors.add(
                'The maximum limit of 5000 emails has been exceeded.'
              );
              this.wrongEmails.push(email);
            } else {
              this.participantEmailList.push(email);
            }
          }
        });
        this.emailsErrors = Array.from(emailsErrors);  
        this.session.participantEmailInfo = this.wrongEmails.join(',');
      }
      if (operation === 'delete') {
        this.participantEmailList = this.participantEmailList.filter(
          (domain) => domain != emails
        );
      }
    } else if (this.selectedTab === 'domain') {
      this.invalidDomainInfo =
        this.enableEmailInfo && this.session.domainInfo.length === 0;
      this.invalidEmailInfo = false;
    } else {
      this.invalidEmailInfo =
        this.enableEmailInfo && this.session.participantEmailInfo.length === 0;
      this.invalidDomainInfo = false;
    }
  }

  updateClientAdmin(clientAddmin: string, operation: string) {
    this.clientEmailErrors = [];
    this.wrongEmails = [];
    this.session.clientEmailInfo = '';
    this.isaudienceChanged = true;
    this.issubmitEnable = true;
    if (clientAddmin) {
      this.invalidEmailInfo = false;
      if (operation === 'add') {
        const emailValidator =
          /^[A-Z0-9._%!-+-']+@([A-Z0-9-]+\.)+[A-Z]{2,10}$/i;
        const listOfEmails = clientAddmin
          .replace(/ /g, '')
          .replace(/\n/g, ',')
          .split(',');
        const clientEmailErrors = new Set();
        listOfEmails.map((email) => {
          if (email) {
            if (
              !emailValidator.test(email) ||
              email.toLowerCase().includes('@deloitte') ||
              (this.dropdownData.Deloittesubsidarydomains &&
                this.dropdownData.Deloittesubsidarydomains.find(
                  (res) => res.domainName == email.toLowerCase().split('@')[1]
                ))
            ) {
               clientEmailErrors.add(
                ' Invalid email(s) found. Please correct before continuing.'
              );
              this.invalidDomainInfo = false;

              this.wrongEmails.push(email);
            } else if (
              this.externalAdminEmailList.find(
                (data: string) => data.toLowerCase() == email.toLowerCase()
              )
            ) {
              const erroMsg = email + ' already exists';
              clientEmailErrors.add(erroMsg);
              this.wrongEmails.push(email);
            } else if (this.externalAdminEmailList.length >= 25) {
              clientEmailErrors.add(
                'The maximum limit of 25 emails has been exceeded.'
              );
              this.wrongEmails.push(email);
            } else {
              this.externalAdminEmailList.push(email);
            }
          }
        });
        this.clientEmailErrors = Array.from(clientEmailErrors);
        this.session.clientEmailInfo = this.wrongEmails.join(',');
      }
      if (operation === 'delete') {
        this.externalAdminEmailList = this.externalAdminEmailList.filter(
          (domain) => domain != clientAddmin
        );
      }
    } else {
      if (this.selectedTab === 'clientadmins') {
        this.invalidClientAdminInfo =
          this.enableEmailInfo && this.session.clientEmailInfo.length === 0;
        this.invalidEmailInfo = false;
      } else {
        this.invalidClientAdminInfo =
          this.enableEmailInfo &&
          this.session.participantEmailInfo.length === 0;
        this.invalidClientAdminInfo = false;
      }
      this.invalidEmailInfo = true;

      // if(this.invalidEmailInfo === true){
      //   this.invalidDomainInfo === false;
      // }
    }
  }

  checkValidParticipantDetails() {
    if (this.session.sessionType != 'Deloitte') {
      if (this.selectedTab === 'clientadmins') {
        this.selectedTab = 'domain';
        this.onTabClick('domain');
      }

      if (
        this.enableEmailInfo &&
        this.domainNameList.length === 0 &&
        this.participantEmailList.length === 0
      ) {
        if (this.selectedTab === 'domain' && this.domainNameList.length === 0) {
          this.invalidDomainInfo = true;
        }

        if (
          this.selectedTab === 'participant' &&
          this.participantEmailList.length === 0
        ) {
          this.invalidEmailInfo = true;
        }

        return this.invalidDomainInfo || this.invalidEmailInfo;
      }
    }
    return false;
  }

  loadServiceFunctionDropdown(includeNA?) {
    if (this.masterData && this.masterData.ServiceFunctions.length > 0) {
      if (includeNA) {
        this.dropdownData.ServiceFunctions =
          this.masterData.ServiceFunctions.filter(
            (data) => !data.IsMDR && data.IsActive
          );
      } else {
        if (
          this.session.serviceLineFunction != null &&
          this.session.serviceLineFunction != undefined &&
          this.session.serviceLineFunction == 20
        ) {
          this.session.serviceLineFunction = null;
        }

        this.dropdownData.ServiceFunctions =
          this.masterData.ServiceFunctions.filter(
            (data) => !data.IsMDR && data.IsActive && !data.Name.includes('N/A')
          );
      }
    }
  }

  loadIndustryDropdown(includeNA?) {
    if (this.masterData && this.masterData.Industries.length > 0) {
      if (includeNA) {
        this.dropdownData.Industries = this.masterData.Industries.filter(
          (data) => !data.IsMDR && data.IsActive
        );
      } else {
        this.dropdownData.Industries = this.masterData.Industries.filter(
          (data) => !data.IsMDR && data.IsActive && !data.Name.includes('N/A')
        );
      }
    }
    this.sortIndustries();
  }

  sortIndustries(): void {
    if (this.dropdownData.Industries) {
      const fromIndex = this.dropdownData.Industries.findIndex(
        (res) => res.ID == 54
      );
      const toIndex = this.dropdownData.Industries.findIndex(
        (res) => res.ID == 6
      );
      const element = this.dropdownData.Industries.splice(fromIndex, 1)[0];
      this.dropdownData.Industries.splice(toIndex, 0, element);
    }
  }

  /**
   * method to set session type and session format list.
   * if user has mutilple role along with subscription admin and doesn't have admin role
   * and subscription id is not null then set session type and format based on subscription admin role
   * else set it default i.e. based on highest precedence role.
   * @param id the subscription id of the session.
   */
  setSessionTypeAndSessionFormatList(id) {
    if (
      id &&
      this.userRoleID !== 1 &&
      !this.isUserSuperAdmin &&
      this.isUserSubscriptionAdminForSession
    ) {
      this.dropdownData.SessionType = this.masterData.SessionType.filter(
        (s) => s.SessionAudience == this.selectedLink && s.RoleId == 6
      );
      const key = 'SessionTypeName';
      this.dropdownData.SessionType = this.getUniqueList(
        this.dropdownData.SessionType,
        key
      );
      const requiredSessionTypeList = this.getUniqueList(
        this.masterData.SessionType,
        key
      );
      this.dropdownData.SessionType = this.dropdownData.SessionType.sort(
        (a, b) =>
          requiredSessionTypeList.indexOf(a[key]) -
          requiredSessionTypeList.indexOf(b[key])
      );

      if (this.masterData && this.masterData.SessionFormat) {
        this.dropdownData.SessionFormat = this.masterData['SessionFormat']
          ? this.masterData['SessionFormat']
          : [];
      }
      this.dropdownData.SessionFormat = this.dropdownData.SessionFormat.filter(
        (f) => f.RoleId == 6
      )
        ? this.getUniqueList(
          this.dropdownData.SessionFormat.filter((f) => f.RoleId == 6),
          'SessionFormatName'
        )
        : [];
    } else {
      this.dropdownData.SessionType = this.masterData.SessionType.filter(
        (SessionType) => SessionType.SessionAudience == this.selectedLink
      );
      const key = 'SessionTypeName';
      this.dropdownData.SessionType = this.getUniqueList(
        this.dropdownData.SessionType,
        key
      );
      const requiredSessionTypeList = this.getUniqueList(
        this.masterData.SessionType,
        key
      );
      this.dropdownData.SessionType = this.dropdownData.SessionType.sort(
        (a, b) =>
          requiredSessionTypeList.indexOf(a[key]) -
          requiredSessionTypeList.indexOf(b[key])
      );

      if (this.masterData && this.masterData.SessionFormat) {
        this.dropdownData.SessionFormat = this.masterData['SessionFormat']
          ? this.masterData['SessionFormat']
          : [];
      }
      this.dropdownData.SessionFormat = this.dropdownData.SessionFormat
        ? this.getUniqueList(
          this.dropdownData.SessionFormat,
          'SessionFormatName'
        )
        : [];
    }

    // for subscription based session set the session format ID
    if (
      this.subscriptionModuleData &&
      this.subscriptionModuleData.SubscriptionType
    ) {
      this.setSessionFormat(this.subscriptionModuleData);
    }
  }

  /**
   * method to set the session format ID for subscription based session
   * if the session type is standard then set to 3 else 4 if it's digital
   * @param subscriptionData object that contain subscription details
   */
  setSessionFormat(subscriptionData: any) {
    this.session.sessionFormat =
      subscriptionData.SubscriptionType.toLowerCase() == 'digital experience' ? 3 : 4;
    const sessionFormatAvailable = this.dropdownData.SessionFormat.find(
      (data) => data.SessionFormatID == this.session.sessionFormat
    );
    if (!sessionFormatAvailable) {
      const addedSesssionFormat = this.staticSessionFormat.find(
        (data) => data.SessionFormatID == this.session.sessionFormat
      );
      this.dropdownData.SessionFormat.push(addedSesssionFormat);
    }
    this.disableSesionFormat = true;
  }

  subscriptionModuleData: any;

  onFocusOutSubscriptionField(event: any) {
    const id = (event.target as HTMLInputElement)?.value;
    this.onFocusOutSubscription(id);
  }
  onFocusOutSubscription(id, restrictLoad?) {
    this.setSessionTypeAndSessionFormatList(id);
    this.isSessionDateWithinRange = false;
    this.isSessionSingleLink = false;
    if (id == '') {
      this.isSubscriptionStatusError = false;
      this.subscriptionStatusErrorMesg = '';
      this.subscriptionIDError = false;
      this.subscriptionIDErrormessage = '';
    }
    if (this.subscriptionIDError) {
      this.subscriptionIDError = true;
    } else {
      this.subscriptionIDError = false;
    }

    if (id == '' || id == undefined || id == null) {
      this.flag = true;
      if (
        this.existingCoordinatorlist != undefined &&
        this.existingCoordinatorlist != null
      ) {
        this.selectedCoordinators = JSON.parse(
          JSON.stringify(this.existingCoordinatorlist)
        );
      }
      this.resetBeforeSubsciption();
    }
    if (
      (Number(id) && Number(id) != this.tempSubScriptionId) ||
      (Number(id) &&
        Number(id) == this.tempSubScriptionId &&
        this.flag === true)
    ) {
      this.flag = false;
      this.tempSubScriptionId = Number(id);
      if (this.sessionId === 0) {
        this.resetBeforeSubsciption();
      }
      this.SessionService.getSubscriptionData(id).subscribe((response) => {
        if (response.Success) {
          const res = response.Data;
          this.isSubscriptionStatusError = false;
          this.subscriptionStatusErrorMesg = '';
          const subscriptionData = JSON.parse(JSON.stringify(res));
          this.subscriptionModuleData = subscriptionData;
          let canCountryAdminCreateSubscriptionSession = true;

          if (
            this.userRoleID === 3 &&
            !this.sponsoringCountries.some(
              (c) => c.ID == subscriptionData?.SponsoringCountryID
            )
          ) {
            canCountryAdminCreateSubscriptionSession = false;
          }
          if (
            res != null &&
            res['SubscriptionStatus'] &&
            canCountryAdminCreateSubscriptionSession
          ) {
            if (
              res['SubscriptionStatus'].toLowerCase() == 'active' ||
              res['SubscriptionStatus'].toLowerCase() == 'hold'
            ) {
              const resetCompany: boolean = restrictLoad == true ? false : true;
              if (
                this.session.sessionType != subscriptionData.SessionAudience
              ) {
                this.updateFieldsBasedOnSubscription(
                  subscriptionData,
                  true,
                  resetCompany,
                  restrictLoad
                );
              } else {
                this.updateFieldsBasedOnSubscription(
                  subscriptionData,
                  false,
                  resetCompany,
                  restrictLoad
                );
              }
            } else if (res['SubscriptionStatus'].toLowerCase() == 'inactive') {
              this.isSubscriptionStatusError = true;
              this.subscriptionStatusErrorMesg = 'Inactive Subscription Id';
            } else if (res['SubscriptionStatus'].toLowerCase() == 'cancelled') {
              this.isSubscriptionStatusError = true;
              this.subscriptionStatusErrorMesg = 'Cancelled Subscription Id';
            }
            else if (res['SubscriptionStatus'].toLowerCase() == 'approval pending') {
              this.isSubscriptionStatusError = true;
              this.subscriptionStatusErrorMesg = 'Subscription Is Not Approved';
            }
            if (
              !this.subscriptionIDError &&
              !this.isSubscriptionStatusError &&
              !restrictLoad
            ) {
              this.session.gxFees = null;
              this.session.surcharge = null;
            }
          } else {
            this.subscriptionIDError = true;
            this.subscriptionIDErrormessage =
              'Incorrect Subscription ID, please verify';
          }

          this.onFocusoutSessionDate();
        } else {
          this.subscriptionIDError = true;
        }
      });
    } else if (!Number(id) && id != undefined && id != '') {
      this.subscriptionIDError = true;
      this.subscriptionIDErrormessage =
        'Incorrect Subscription ID, please verify';
    } else {
      this.subscriptionModuleData = {};
      this.onFocusoutSessionDate();
      // need to discuss
      //   this.resetBeforeSubsciption();
    }
  }
  isSessionDateWithinRange: boolean = false; // is Session Date Within subscription date range
  isSessionSingleLink: boolean = false;
  updateFieldsBasedOnSubscription(
    subscriptionData,
    resetFields,
    resetCompany,
    restrictLoad?
  ) {
    this.isSessionDateWithinRange = false;
    this.isSessionSingleLink = false;
    this.subscriptionIDErrormessage = '';
    this.subscriptionIDError = false;

    if (
      (subscriptionData.LinkType &&
        subscriptionData.LinkType.toLowerCase() == 'singlelink' &&
        !(
          subscriptionData.SessionsCount == null ||
          subscriptionData.SessionsCount == undefined ||
          subscriptionData.SessionsCount == '' ||
          subscriptionData.SessionsCount == 0
        )) ||
      (subscriptionData.LinkType &&
        subscriptionData.LinkType.toLowerCase() != 'multilink' &&
        subscriptionData.Company == null &&
        subscriptionData.SubscriptionType == null)
    ) {
      this.subscriptionIDError = true;

      if (
        subscriptionData.Company != null &&
        subscriptionData.SubscriptionType != null &&
        this.session.subscriptionId != this.editedSubscriptionId
      ) {
        this.subscriptionIDErrormessage = 'Single link Subscription fulfilled';
        this.isSessionSingleLink = true;
        return;
      } else {
        //below date changes for elseif condition to check whether session date is falling under subscription start/end date or not
        const tempSubStartDate = this.ConvertDateToStringFormat(
          subscriptionData.StartDate
        );
        const tempSubStartDate2 = this.setDateFormat(tempSubStartDate);

        const tempSubEndDate = this.ConvertDateToStringFormat(
          subscriptionData.EndDate
        );
        const tempSubEndDate2 = this.setDateFormat(tempSubEndDate);

        const tempSessionDate = this.setDateFormat(this.session.sessionDate);

        if (
          subscriptionData.Company == null &&
          subscriptionData.SubscriptionType == null
        ) {
          this.subscriptionIDErrormessage =
            'Incorrect Subscription ID, please verify';
          return;
        }
        // else if (
        //   tempSubStartDate2 >= tempSessionDate &&
        //   tempSubEndDate2 >= tempSessionDate
        // )
        else if (
          tempSubStartDate2 > tempSessionDate &&
          tempSubEndDate2 < tempSessionDate
        ) {
          //if condition sub start session date
          this.subscriptionIDErrormessage =
            "The session date must fall within the subscription date range; please change the date you've entered";
          this.isSessionDateWithinRange = true;
          // return;
        } else {
          this.subscriptionIDError = false;
          this.isSessionDateWithinRange = false;
        }
      }
      //return;
    } //below elseif condition for multilink; to check whether session date is falling under subscription start/end date or not
    else if (
      subscriptionData.LinkType &&
      subscriptionData.LinkType.toLowerCase() == 'multilink'
    ) {
      const tempSubStartDate = this.ConvertDateToStringFormat(
        subscriptionData.StartDate
      );
      const tempSubStartDate2 = this.setDateFormat(tempSubStartDate);

      const tempSubEndDate = this.ConvertDateToStringFormat(
        subscriptionData.EndDate
      );
      const tempSubEndDate2 = this.setDateFormat(tempSubEndDate);

      const tempSessionDate = this.setDateFormat(this.session.sessionDate);

      if (
        subscriptionData.Company == null &&
        subscriptionData.SubscriptionType == null
      ) {
        this.subscriptionIDErrormessage =
          'Incorrect Subscription ID, please verify';
        this.subscriptionIDError = true;
        return;
      }
      // else if (
      //   tempSubStartDate2 >= tempSessionDate &&
      //   tempSubEndDate2 >= tempSessionDate
      // )
      else if (
        tempSubStartDate2 > tempSessionDate &&
        tempSubEndDate2 < tempSessionDate
      ) {
        //if condition sub start session date
        this.subscriptionIDErrormessage =
          "The session date must fall within the subscription date range; please change the date you've entered";
        this.isSessionDateWithinRange = true;
        this.subscriptionIDError = true;
        // return;
      } else {
        this.isSessionDateWithinRange = false;
        this.subscriptionIDError = false;
      }
    } //below else if for specific single link && sessioncount = 0
    else if (
      subscriptionData.LinkType &&
      subscriptionData.LinkType.toLowerCase() == 'singlelink' &&
      subscriptionData.SessionsCount == 0
    ) {
      //below date changes for elseif condition to check whether session date is falling under subscription start/end date or not
      const tempSubStartDate = this.ConvertDateToStringFormat(
        subscriptionData.StartDate
      );
      const tempSubStartDate2 = this.setDateFormat(tempSubStartDate);

      const tempSubEndDate = this.ConvertDateToStringFormat(
        subscriptionData.EndDate
      );
      const tempSubEndDate2 = this.setDateFormat(tempSubEndDate);

      const tempSessionDate = this.setDateFormat(this.session.sessionDate);

      if (
        subscriptionData.Company == null &&
        subscriptionData.SubscriptionType == null
      ) {
        this.subscriptionIDErrormessage =
          'Incorrect Subscription ID, please verify';
        this.subscriptionIDError = true;
        return;
      }
      // else if (
      //   tempSubStartDate2 >= tempSessionDate &&
      //   tempSubEndDate2 >= tempSessionDate
      // )
      else if (
        tempSubStartDate2 > tempSessionDate &&
        tempSubEndDate2 < tempSessionDate
      ) {
        //if condition sub start session date
        this.subscriptionIDErrormessage =
          "The session date must fall within the subscription date range; please change the date you've entered";
        this.isSessionDateWithinRange = true;
        this.subscriptionIDError = true;
        // return;
      } else {
        this.subscriptionIDError = false;
        this.subscriptionIDError = false;
      }
    }

    //Bug 3137187 fix
    if (
      subscriptionData.SubscriptionStatus &&
      (subscriptionData.SubscriptionStatus.toLowerCase() == 'active' ||
        subscriptionData.SubscriptionStatus.toLowerCase() == 'hold')
    ) {
      // HTML event
      this.disableSubscriptionFields = true;

      //Bug 3137423 fix

      if (resetFields == true) {
        this.onSessionAudienceChange(subscriptionData.SessionAudience, true);
      }

      if (subscriptionData.SponsoringCountryID) {
        this.session.sponsoredCountry = subscriptionData.SponsoringCountryID;
        this.sponsoredCountryChange(this.session.sponsoredCountry);
        this.disableSponsoredCountry = true;
      }

      if (resetCompany == true) {
        if (subscriptionData.Company) {
          this.session.companyName = { Name: subscriptionData.Company };
          this.selectedCompany = subscriptionData.Company;
          this.companyName = subscriptionData.Company;
          $('#companyID').val(subscriptionData.Company);
          if (this.sessionId === 0) {
            this.generateSessionName();
          }
        }
      }

      if (subscriptionData.ClientProgramID) {
        this.session.clientProgram = subscriptionData.ClientProgramID;
      }
      if (subscriptionData.SecRestrictedID) {
        this.session.secRestricted = subscriptionData.SecRestrictedID;
      }
      if (subscriptionData.ServiceFunctionID) {
        this.session.serviceLineFunction = subscriptionData.ServiceFunctionID;
        this.onServiceFunctionChange(this.session.serviceLineFunction);
      }
      if (subscriptionData.IndustryID) {
        this.session.sessionIndustry = subscriptionData.IndustryID;
        this.industryChange(this.session.sessionIndustry);
      }

      if (subscriptionData.SectorID) {
        const item = this.dropdownData_Sectors.find(
          (index) => index.SectorID == subscriptionData.SectorID
        );
        if (item == undefined) {
          this.session.sessionSector = null;
        } else {
          this.session.sessionSector = subscriptionData.SectorID;
        }
      }

      if (
        (subscriptionData.PPMDEmail &&
          subscriptionData.PPMDFirstName &&
          subscriptionData.PPMDLastName) ||
        (this.showPPMDAsTextInput && subscriptionData.PPMDEmail)
      ) {
        if (this.showPPMDAsTextInput) {
          this.session.responsiblePpmd = subscriptionData.PPMDEmail;
        } else {
          const name =
            subscriptionData.PPMDFirstName +
            ' ' +
            subscriptionData.PPMDLastName +
            ' ' +
            '(' +
            subscriptionData.PPMDEmail +
            ')';
          $('.responsiblePpmd').val(name);
          this.session.responsiblePpmd = {
            Name_First: subscriptionData.PPMDFirstName,
            Name_Last: subscriptionData.PPMDLastName,
            AD_EmailAdress: subscriptionData.PPMDEmail,
          };
        }
      }

      if (
        subscriptionData.SubscriptionAdmins &&
        subscriptionData.SubscriptionAdmins.length > 0 &&
        this.operationType !== 'Edit' &&
        this.subadminaddcnt < 1
      ) {
        this.subadminaddcnt = 1;
        subscriptionData.SubscriptionAdmins.map((data) => {
          this.updateCoordinator({ item: data }, 'add', false, restrictLoad);
        });
      }
    }

    if (subscriptionData.SubscriptionType) {
      this.setSessionFormat(subscriptionData);
    }

    if (subscriptionData.StartDate && !this.subscriptionIDError) {
      this.minimumDate = this.formatStandardDate(subscriptionData.StartDate);
      this.maximumDate = this.formatStandardDate(subscriptionData.EndDate);
    }

    if (restrictLoad) {
      this.subscriptionAdmins =
        subscriptionData.SubscriptionAdmins &&
          subscriptionData.SubscriptionAdmins.length > 0
          ? subscriptionData.SubscriptionAdmins
          : [];
      if (this.userRoleID === 6) {
        this.visibilityApproveOptions();
      }
      if (this.userRoleID === 5) {
        this.disableApproveOptions();
      }
    }
    // CR: United States – USI and United States – Germany should not appear in the country list for  commercialization
    if (
      subscriptionData.SubscriptionType != null &&
      subscriptionData.SubscriptionType.toLowerCase() == 'commercialization'
    ) {
      this.dropdownData.Countries = this.dropdownData.Countries.filter(
        (item) => item.ID != 259 && item.ID != 265 && item.ID != 266 && item.ID != 267 && item.ID != 268 && item.ID != 269 
      );
      if (
        this.session.sessionCountry == 259 ||
        this.session.sessionCountry == 265 ||
        this.session.sessionCountry == 266 ||
        this.session.sessionCountry == 267 ||
        this.session.sessionCountry == 268 ||
        this.session.sessionCountry == 269
      ) {
        this.session.sessionCountry = null;
        this.stateDisable = true;
      }
    }
  }

  ConvertDateToStringFormat(dt) {
    dt = new Date(dt);

    const dateObj = { day: '', month: '', year: 0 };
    const day = ('' + dt.getDate()).slice(-2);
    const month = ('' + (dt.getMonth() + 1)).slice(-2);
    dateObj.day = day;
    dateObj.month = month;
    dateObj.year = dt.getFullYear();
    return dateObj;
  }

  setDateFormat(event) {
    if (event != null) {
      const year = event.year;
      const month = event.month <= 9 ? '0' + event.month : event.month;
      const day = event.day <= 9 ? '0' + event.day : event.day;
      const finalDate = year + '-' + month + '-' + day;
      return finalDate;
    }
    return null;
  }

  resetBeforeSubsciption() {
    this.subscriptionIDError = false;
    this.session.sponsoredCountry =
      this.sessionId === 0 ? null : this.session.sponsoredCountry;
    this.sponsoredCountryChange(this.session.sponsoredCountry, true);
    this.disableSponsoredCountry = false;
    this.disableSubscriptionFields = false;
    $('#companyID').val('');
    this.session.companyName = '';
    this.subadminaddcnt = 0;
    this.companyName = '';
    if (this.sessionId === 0) {
      this.session.clientProgram = null;
    }
    this.session.sessionIndustry = null;
    this.session.sessionSector = null;
    this.session.secRestricted = null;
    this.session.serviceLineFunction = null;
    if (this.sessionId === 0) {
      if (this.showPPMDAsTextInput === false) {
        this.session.responsiblePpmd = {
          Name_First: '',
          Name_Last: '',
          AD_EmailAdress: '',
        };
      } else {
        this.session.responsiblePpmd = '';
      }
    }
    this.disableSesionFormat = false;
    this.session.sessionFormat = null;
    if (this.sessionId === 0) {
      this.session.sessionDate = null;
    }
    this.minimumDate = undefined;
    this.maximumDate = undefined;
    this.dropdownData.Countries = this.allCountriesList;
  }

  updateWBSFields(operation: any, id: any = 0) {
    if (operation == 'add') {
      this.disableWbsPercentage = true;
      const percentage =
        this.multipleWBS.length == 1
          ? ''
          : (100 - this.calculateTotalWBSPercentage()).toString();
      this.multipleWBS.push({
        id: RandomUtil.secureRandom(),
        wbsCode: '',
        wbsPercentage: percentage,
        isNewWbsCode: true,
        isSelectedFromPicklist: false,
        isExistingWbs: false,
        isWbsActive: null,
        isWbsStatusChecked: false,
        isWbsStatusChecking: false,
      });
      this.totalWBSPercentage = this.calculateTotalWBSPercentage();
    }

    if (operation == 'delete') {
      this.multipleWBS = this.multipleWBS.filter((data) => data.id != id);
      this.totalWBSPercentage = this.calculateTotalWBSPercentage();
    }

    if (this.multipleWBS.length <= 1) {
      this.multipleWBS[0].wbsPercentage = '';
      this.session.overageWBS = this.multipleWBS[0].id;
      this.totalWBSPercentage = 0;
    }

    this.onWbsCodeEntered();
    if (operation != 'add') {
      this.validateWBSCode();
    }
    this.isaudienceChanged = true;
    this.issubmitEnable = true;
    this.checkWBSError();
    this.updateInactiveWbsState();
  }

  updateWBSFieldsForSurcharge(operation: any, id: any = 0) {
    this.disableSurchargePercentage = true;
    if (operation == 'add') {
      const percentage =
        this.multipleWBSForSurcharge.length == 1
          ? ''
          : 100 - this.calculateTotalWBSPercentageForSurcharge();

      this.multipleWBSForSurcharge.push({
        id: RandomUtil.secureRandom(),
        wbsCode: '',
        wbsPercentage: percentage,
        isSelectedFromPicklist: false,
        isExistingWbs: false,
        isNewSurchargeCode: true,
        isWbsActive: null,
        isWbsStatusChecked: false,
        isWbsStatusChecking: false,
      });
      this.totalWBSPercentageForSurcharge =
        this.calculateTotalWBSPercentageForSurcharge();
    }

    if (operation == 'delete') {
      this.multipleWBSForSurcharge = this.multipleWBSForSurcharge.filter(
        (data) => data.id != id
      );
      this.totalWBSPercentageForSurcharge =
        this.calculateTotalWBSPercentageForSurcharge();
    }

    if (this.multipleWBSForSurcharge.length <= 1) {
      this.multipleWBSForSurcharge[0].wbsPercentage = '';
      this.totalWBSPercentageForSurcharge = 0;
    }

    this.onWbsCodeEnteredForSurcharge();
    if (operation != 'add') {
      this.validateWBSCodeForSurcharge();
    }
    this.isaudienceChanged = true;
    this.issubmitEnable = true;
    this.checkWBSErrorForSurcharge();
  }

  calculateTotalWBSPercentage() {
    this.totalWBSPercentage = 0;
    if (this.multipleWBS && this.multipleWBS.length > 0) {
      this.multipleWBS.map((data) => {
        this.totalWBSPercentage =
          Number(this.totalWBSPercentage) + Number(data.wbsPercentage);
      });
    }
    return this.totalWBSPercentage;
  }

  calculateTotalWBSPercentageForSurcharge() {
    this.totalWBSPercentageForSurcharge = 0;
    if (
      this.multipleWBSForSurcharge &&
      this.multipleWBSForSurcharge.length > 0
    ) {
      this.multipleWBSForSurcharge.map((data) => {
        this.totalWBSPercentageForSurcharge =
          Number(this.totalWBSPercentageForSurcharge) +
          Number(data.wbsPercentage);
      });
    }
    return this.totalWBSPercentageForSurcharge;
  }

  onWBSPercentageChange(event, id) {
    if (event) {
      this.multipleWBS.map((item) => {
        if (item.id == id) {
          item.wbsPercentage = event.target.value;
        }
      });
    }
    this.totalWBSPercentage = this.calculateTotalWBSPercentage();
    this.isaudienceChanged = true;
    this.issubmitEnable = true;
    this.checkWBSError();
  }

  onWBSPercentageChangeForSurcharge(event, id) {
    if (event) {
      this.multipleWBSForSurcharge.map((item) => {
        if (item.id == id) {
          item.wbsPercentage = event.target.value;
        }
      });
    }
    this.totalWBSPercentageForSurcharge =
      this.calculateTotalWBSPercentageForSurcharge();
    this.isaudienceChanged = true;
    this.issubmitEnable = true;
  }

  onWBSCodeChange(event, id) {
    if (!event) {
      return;
    }

    const updatedWbsCode = event.target?.value ?? '';
    this.multipleWBS.map((item) => {
      if (item.id == id) {
        item.wbsCode = updatedWbsCode;
        item.isNewWbsCode = true;
        item.isExistingWbs = false;
        // Mark as not selected from picklist (manually entered)
        item.isSelectedFromPicklist = false;
        // Reset DunsID validation when user types manually
        item.wbsDunsID = '';
        // Manual edits should clear previous valid state/details from old selected code
        item.isWbsActive = null;
        item.isWbsStatusChecked = false;
        item.isWbsStatusChecking = false;
      }
    });

    if (this.wbsid == id) {
      this.wbsid = null;
    }

    // Reset WBS DunsID validation when user types manually
    this.invalidWBSDunsID = false;
    this.isInputWbsChanged = true;
    // Update WBS mandatory status when code changes
    this.updateWBSMandatoryStatus();
    this.onWbsCodeEntered();
    this.updateInactiveWbsState();
  }

  private isWbsCodeFormatValid(wbsCode: string): boolean {
    if (!wbsCode) {
      return false;
    }

    return !(
      wbsCode.length != 22 ||
      (wbsCode.match(/-/g) || []).length != 4 ||
      /^[a-z0-9]+$/i.test(wbsCode)
    );
  }

  private hasDuplicatePrimaryWbs(item: any): boolean {
    const currentCode = this.normalizeWbsCode(item?.wbsCode);
    if (!currentCode) {
      return false;
    }

    return this.multipleWBS?.some(
      (wbsItem) =>
        wbsItem?.id !== item?.id &&
        this.normalizeWbsCode(wbsItem?.wbsCode) === currentCode
    );
  }

  private isWbsDunsValid(item: any): boolean {
    const wbsCode = item?.wbsCode;
    if (!wbsCode) {
      return false;
    }

    const shouldBypassDunsValidation = this.shouldBypassWbsDunsValidation(wbsCode);
    if (shouldBypassDunsValidation) {
      return true;
    }

    const companyDunsID = (this.selectedCompanyDunsID || '').toString().trim();
    const wbsDunsID = (item?.wbsDunsID || '').toString().trim();
    return !!companyDunsID && !!wbsDunsID && companyDunsID === wbsDunsID;
  }

  shouldShowInactiveWbsSuccessIcon(item: any): boolean {
    return !!(
      item?.wbsCode &&
      item?.isWbsStatusChecked &&
      item?.isWbsActive === false &&
      this.operationType === 'Edit' &&
      item?.isExistingWbs &&
      this.isWbsCodeFormatValid(item.wbsCode) &&
      !this.hasDuplicatePrimaryWbs(item) &&
      this.isWbsDunsValid(item)
    );
  }

  shouldShowWbsSuccessIcon(item: any): boolean {
    if (!item?.wbsCode || !item?.isWbsStatusChecked) {
      return false;
    }

    if (!this.isWbsCodeFormatValid(item.wbsCode)) {
      return false;
    }

    if (this.hasDuplicatePrimaryWbs(item)) {
      return false;
    }

    if (!this.isWbsDunsValid(item)) {
      return false;
    }

    if (this.shouldShowInactiveWbsSuccessIcon(item)) {
      return true;
    }

    if (this.shouldUseWbsPicklist()) {
      return item?.isSelectedFromPicklist === true && item?.isWbsActive === true;
    }

    return item?.isWbsActive === true;
  }

  shouldShowInactiveWbsSuccessIconForSurcharge(item: any): boolean {
    return !!(
      item?.wbsCode &&
      item?.isWbsStatusChecked &&
      item?.isWbsActive === false &&
      this.operationType === 'Edit' &&
      item?.isExistingWbs &&
      this.isWbsCodeFormatValid(item.wbsCode)
    );
  }

  shouldShowWbsSuccessIconForSurcharge(item: any): boolean {
    if (!item?.wbsCode || !item?.isWbsStatusChecked) {
      return false;
    }

    if (!this.isWbsCodeFormatValid(item.wbsCode)) {
      return false;
    }

    if (
      this.multipleWBSForSurcharge?.some(
        (wbsItem) =>
          wbsItem?.id !== item?.id &&
          this.normalizeWbsCode(wbsItem?.wbsCode) === this.normalizeWbsCode(item?.wbsCode)
      )
    ) {
      return false;
    }

    if (this.shouldShowInactiveWbsSuccessIconForSurcharge(item)) {
      return true;
    }

    if (this.shouldUseWbsPicklist()) {
      return item?.isSelectedFromPicklist === true && item?.isWbsActive === true;
    }

    return item?.isWbsActive === true;
  }

  onWBSCodeChangeForSurcharge(event, id) {
    if (!event) {
      return;
    }

    const updatedWbsCode = event.target?.value ?? '';
    this.multipleWBSForSurcharge.map((item) => {
      if (item.id == id) {
        item.wbsCode = updatedWbsCode;
        item.isNewSurchargeCode = true;
        item.isExistingWbs = false;
        item.isSelectedFromPicklist = false;
        item.isWbsActive = null;
        item.isWbsStatusChecked = false;
        item.isWbsStatusChecking = false;
      }
    });

    if (this.wbsidForSurcharge == id) {
      this.wbsidForSurcharge = null;
    }

    this.isInputWbsSurchargeChanged = true;
    this.onWbsCodeEnteredForSurcharge();
  }

  private hasEnteredMainWBSValue(): boolean {
    return (
      this.multipleWBS?.some(
        (item) => !!item?.wbsCode && item.wbsCode.trim() !== ''
      ) ?? false
    );
  }

  private shouldValidateMainWBS(): boolean {
    // Never validate when the accordion is not even visible to the user
    if (this.isWBSAccordionHidden()) {
      return false;
    }

    const hasEditableWBSField =
      this.multipleWBS?.some((item) => !this.isWBSFieldDisabled(item)) ?? false;

    return (
      !this.isSelected('Deloitte') &&
      !this.wbsDisable &&
      hasEditableWBSField &&
      (this.isWBSMandatory || this.hasEnteredMainWBSValue()) &&
      this.session?.proBono != 'yes' &&
      !this.session?.disableSFDCIntegration
    );
  }
  checkWBSError() {
    if (!this.shouldValidateMainWBS()) {
      this.wbsError = false;
      return;
    }
    this.wbsError =
      this.multipleWBS.length > 1 && this.totalWBSPercentage != 100
        ? true
        : false;
  }

  checkWBSErrorForSurcharge() {
    this.wbsErrorForSurcharge =
      this.multipleWBSForSurcharge.length > 1 &&
        this.totalWBSPercentageForSurcharge != 100
        ? true
        : false;
  }

  statusChanges: boolean = false;
  onApprove(value: string) {
    if (value === 'Approved' && this.inactiveWbsError) {
      this.openWbsAccordionAndFocus();
      return;
    }
    if (this.session.approvalStatus != value) {
      this.statusChanges = true;
    }
    this.session.approvalStatus = value;
    if (this.session.approvalStatus == 'Approved') this.statusChanged = true;
    if (
      this.session.approvalStatus == 'Approved' &&
      this.session.sessionType != 'Deloitte'
    ) {
      this.showClientAdminAndManagerLink = true;
    } else this.showClientAdminAndManagerLink = false;

    if (this.session.sessionType == 'Deloitte' && this.userRoleID === 2) {
      this.disableApproveOptions();
    }
  }

  resetApprovalStatus(value: string) {
    if (
      this.session.approvalStatus == 'Approval Pending' &&
      this.session.sessionType == 'Deloitte'
    ) {
      this.session.approvalStatus = 'Approved';
    }
  }

  checkPleaseSpecifyLength(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const inputValue = inputElement.value;

    if (inputValue) {
      this.pleaseSpecifyFieldLength = inputValue.length;
    }
  }
  ProgramSpecificationLength(event) {
    this.pleaseSpecifyFieldLength = event.length;
  }

  updatePleaseSpecifyLength() {
    this.pleaseSpecifyFieldLength = 0;
  }

  disableParticipantDetailsTab() {
    if (
      this.session.sessionLink &&
      (this.session.approvalStatus.toLowerCase() == 'not approved' ||
        this.session.approvalStatus.toLowerCase() == 'cancelled')
    ) {
      this.disableParticipantsTab = true;
    }
  }

  checkValidSessionRequesterEmail() {
    this.validateSessionRequesterEmail();
    if (this.invalidSessionRequester === false) {
      return false;
    } else {
      return true;
    }
  }

  validateSessionRequesterEmail() {
    const emailPattern = /^[A-Z0-9._%!-+-']+@([A-Z0-9-]+\.)+[A-Z]{2,10}$/i;
    const userInput = {
      userNameOrEmail: Array.from(new Set(this.session.sessionRequester.toLowerCase().split(';').map(email => email.trim().toLowerCase()).filter(email => email))).join(';')
    };

    this.datacleanupservice.getUserDetails(userInput).subscribe((result) => {
      result = result.Data;
      const isRegistered = result[0]?.IsRegistered || false;

      if (this.isSessionCreatedFromCommercialization) {
        if (emailPattern.test(this.session.sessionRequester.toLowerCase())) {
          $('#sessionRequester').removeClass('is-invalid');
          this.invalidSessionRequester = false;
        } else {
          $('#sessionRequester').addClass('is-invalid');
          this.invalidSessionRequester = true;
        }
      } else {
        const deloitte = '@deloitte.com';
        let isDeloitteSubsidaryDomain = false;

        if (
          this.masterData.Deloittesubsidarydomains != null &&
          this.masterData.Deloittesubsidarydomains != undefined &&
          this.masterData.Deloittesubsidarydomains.length > 0
        ) {
          this.masterData.Deloittesubsidarydomains.forEach((dsd) => {
            if (
              this.session.sessionRequester
                .toLowerCase()
                .endsWith('@' + dsd.domainName)
            ) {
              isDeloitteSubsidaryDomain = true;
            }
          });
        }

        if (this.session.sessionRequester.toLowerCase() === '') {
          $('#sessionRequester').addClass('is-invalid');
          this.invalidSessionRequester = false;
        } else if (
          emailPattern.test(this.session.sessionRequester.toLowerCase()) &&
          (this.session.sessionRequester.toLowerCase().endsWith(deloitte) ||
            isDeloitteSubsidaryDomain)
        ) {
          $('#sessionRequester').removeClass('is-invalid');
          this.invalidSessionRequester = false;
        } else if (!isRegistered) {
          $('#sessionRequester').addClass('is-invalid');
          this.invalidSessionRequester = true;
        } else {
          $('#sessionRequester').addClass('is-invalid');
          this.invalidSessionRequester = true;
        }
      }
    });
  }

  validateServiceLineNAValue(value): void {
    this.session.serviceLineNA = value.replace(/^\s+|\s+$/gm, '');
  }

  validateIndustryNAValue(value): void {
    this.session.industryNA = value.replace(/^\s+|\s+$/gm, '');
  }

  validateSectorNAValue(value): void {
    this.session.sectorNA = value.replace(/^\s+|\s+$/gm, '');
  }
  validateCityTextValue(value): void {
    this.session.sessionCity = value.replace(/^\s+|\s+$/gm, '');
  }
  validateProbonoTextValue(value): void {
    this.session.explainRationale = value.replace(/^\s+|\s+$/gm, '');
  }
  validatesessionTypeSpecifyValue(value): void {
    this.session.sessionTypeSpecify = value.replace(/^\s+|\s+$/gm, '');
  }
  validateOtherDepartmentTextValue(value): void {
    this.session.otherDepartment = value.replace(/^\s+|\s+$/gm, '');
  }
  isSessionFeedbackVisible(): boolean {
    return (
      (this.session.sponsoredCountry == '23' || this.session.sponsoredCountry == '266') &&
      !this.InvalidAge &&
      !this.session.subscriptionId &&
      (
        (this.session.sessionType == 'ExternalClient' &&
          (
            this.session.sessionTypes == '8' ||
            this.session.sessionTypes == '10' ||
            (this.session.sessionTypes == '13' && this.session.sessionSubTypes == '1') ||
            this.session.sessionTypes == '15'
          )
        ) ||
        (this.session.sessionType == 'ExternalNonClient' &&
          (
            this.session.sessionTypes == '16' ||
            this.session.sessionTypes == '18' ||
            (this.session.sessionTypes == '20' && this.session.sessionSubTypes == '5') ||
            this.session.sessionTypes == '31' ||
            this.session.sessionTypes == '23'
          )
        ) ||
        (this.session.sessionType == 'MixedAudience' &&
          (
            this.session.sessionTypes == '24' ||
            this.session.sessionTypes == '27' ||
            this.session.sessionTypes == '28' ||
            this.session.sessionTypes == '32' ||
            this.session.sessionTypes == '30'
          )
        )
      )
    );
  }

  onSubmit(event, form: FormGroup) {
    this.showLoader = true;
    this.updateWBSMandatoryStatus();
    if (this.isSessionFeedbackVisible() && this.optOut == null) {
      this.optOut = "IAgree"; 
    }
    this.validForm = true;
    if (
      this.subscriptionModuleData &&
      this.subscriptionModuleData['SubscriptionStatus'] &&
      (this.subscriptionModuleData['SubscriptionStatus'].toLowerCase() ==
        'inactive' ||
        this.subscriptionModuleData['SubscriptionStatus'].toLowerCase() ==
        'cancelled') &&
      this.isSubscriptionStatusError
    ) {
      if (
        this.subscriptionModuleData['SubscriptionStatus'].toLowerCase() ==
        'inactive'
      ) {
        this.subscriptionStatusErrorMesg = 'Inactive Subscription Id';
      } else if (
        this.subscriptionModuleData['SubscriptionStatus'].toLowerCase() ==
        'cancelled'
      ) {
        this.subscriptionStatusErrorMesg = 'Cancelled Subscription Id';
      }
      this.isSubscriptionStatusError = true;
      this.showLoader = false;
      this.IsAfterSubmit = false;
      this.validForm = false;
      return;
    }
    if (this.checkValidSessionRequesterEmail()) {
      this.IsAfterSubmit = false;
      this.showLoader = false;

      return;
    }

    let companyName;

    if (this.session.sessionType == 'Deloitte') {
      companyName = this.session.companyName.Name;
      this.selectedCompany = this.session.companyName.Name;
    } else {
      companyName = this.session.companyName
        ? this.session.companyName.Name
          ? this.session.companyName.Name
          : this.session.companyName
        : null;
    }

    if (this.draftSession === true) {
      if (
        this.checkValidParticipantDetails() ||
        this.selectedCoordinators.length === 0 ||
        this.subscriptionIDError ||
        this.invalidCompany ||
        this.invalidSessionName 
      ) {
        this.validForm = false;
        this.showLoader = false;
        this.IsAfterSubmit = false;
        return;
      }
    } else if (
      this.checkValidParticipantDetails() ||
      this.checkCertifiedFacilitators() ||
      this.selectedCoordinators.length === 0 ||
      ((this.selectedFacilitator.length === 0 ||
        ((this.isClientCertifiedFacilitator === false ||
          this.selectedFacilitator.length === 0) &&
          (this.session.sessionType == 'ExternalClient' ||
            this.session.sessionType == 'MixedAudience') &&
          (this.userRoleID === 2 || this.userRoleID === 4) &&
          (this.session.sessionTypes == 8 ||
            this.session.sessionTypes == 24))) &&
        !(
          (this.sessionId !== 0 &&
            ((this.session.approvalStatus == 'Approved' &&
              (this.userRoleID === 4 ||
                this.userRoleID === 2 ||
                this.userRoleID === 5 ||
                this.userRoleID === 6)) ||
              (this.session.approvalStatus != 'Approval Pending' &&
                this.userRoleID === 4))) ||
          this.session.proBono == 'yes'
        )) ||
      this.textLimitErrorPPMD ||
      (!this.showPPMDAsTextInput && this.invalidppmd) ||
      this.subscriptionIDError ||
      this.invalidCompany ||
      (this.isSessionDateGreaterTodayDate == true &&
        this.sessionId !== 0 &&
        (this.selectedFacilitator.length === 0 ||
          this.isClientCertifiedFacilitator === false) &&
        (this.session.sessionType == 'ExternalClient' ||
          this.session.sessionType == 'MixedAudience') &&
        (this.userRoleID === 2 || this.userRoleID === 4) &&
        (this.session.sessionTypes == 8 || this.session.sessionTypes == 24) &&
        !(
          (this.sessionId !== 0 &&
            ((this.session.approvalStatus == 'Approved' &&
              (this.userRoleID === 4 ||
                this.userRoleID === 2 ||
                this.userRoleID === 5 ||
                this.userRoleID === 6)) ||
              (this.session.approvalStatus != 'Approval Pending' &&
                this.userRoleID === 4))) ||
          this.session.proBono == 'yes'
        )) ||
      this.invalidSessionName || 
      (this.optOut == "optOut" && (this.invalidOptOutReason || this.OptOutReason === ''))
    ) {
      this.validForm = false;
      this.showLoader = false;
      this.IsAfterSubmit = false;
      return;
    }
    
    // Check if WBS is mandatory but not provided
    if (this.shouldValidateMainWBS() && this.multipleWBS[0] && (!this.multipleWBS[0].wbsCode || this.multipleWBS[0].wbsCode.trim() === '')) {
      this.validateWBSCodeOnSubmit();
      this.validForm = false;
      this.showLoader = false;
      this.IsAfterSubmit = false;
      return;
    }

    this.updateInactiveWbsState();
    if (!this.isSelected('Deloitte') && this.inactiveWbsError ) {
      this.validForm = false;
      this.showLoader = false;
      this.IsAfterSubmit = false;
      this.openWbsAccordionAndFocus();
      return;
    }
    
    // Check if WBS DunsID doesn't match with company DunsID
    if (this.invalidWBSDunsID) {
      this.validForm = false;
      this.showLoader = false;
      this.IsAfterSubmit = false;
      this.openWbsAccordionAndFocus();
      return;
    }
    
    // Check if session type conditions are met for WBS unavailable
    const isSessionTypeValidForWBSUnavailable = (): boolean => {
      const allowedSessionTypes = [8, 11, 13, 14, 15, 16, 19, 20, 21, 23, 24, 26, 28, 30, 33, 34, 35];
      const sessionType = Number(this.session.sessionTypes);
      
      if (!allowedSessionTypes.includes(sessionType)) {
        return false;
      }
      
      // For session types 11, 19, 26 - check event
      if ([11, 19, 26].includes(sessionType)) {
        const allowedEvents = [6, 7, 10, 11, 14, 15, 17, 18, 19];
        const eventType = Number(this.session.sessionTypesEvent);
        
        if (!allowedEvents.includes(eventType)) {
          return false;
        }
        
        // For events 7, 11, 15 - check program
        if ([7, 11, 15].includes(eventType)) {
          const allowedPrograms = [193, 194, 195];
          const programType = Number(this.session.sessionTypesProgram);
          
          if (!allowedPrograms.includes(programType)) {
            return false;
          }
        }
      }
      
      return true;
    };
    
    if (this.multipleWBS[0] && (!this.multipleWBS[0].wbsCode || this.multipleWBS[0].wbsCode.trim() === '') && this.userRoleID == 1 && !this.session.disableSFDCIntegration && this.session.approvalStatus == 'Approved' && isSessionTypeValidForWBSUnavailable()) {
      this.session.disableSFDCIntegration = true;
      this.session.sfdcDisableReasonId = 4;
      this.session.sfdcDisableOtherReason = 'WBS unavailable'
    }
    if (
      !this.isSelected('Deloitte') &&
      ((this.shouldValidateMainWBS() &&
        (this.wbsError || this.invalidWBS || this.invalidPercenatge)) ||
        this.wbsErrorForSurcharge ||
        this.invalidWBSForSurcharge ||
        this.invalidPercenatgeForSurcharge)
    ) {
      this.showLoader = false;
      this.IsAfterSubmit = false;
      return;
    }

    this.submitted = true;
    this.sessionCoordinatorsList = this.selectedCoordinators.map((o) => {
      return { CoordinatorID: o.UserId };
    });
    this.sessionFacilitatorsList = this.selectedFacilitator.map((o) => {
      return { FacilitatorID: o.ID };
    });

    let wbsList = [];
    let wbsListForSurcharge = [];
    const sessionRestrictoins = [];
    const sessionExternalAdmins = [];

    if (this.session.sessionType != 'Deloitte') {
      wbsList = this.multipleWBS.map((data) => {
        return { wbscode: data.wbsCode, Description: data.wbsPercentage };
      });

      wbsListForSurcharge = this.multipleWBSForSurcharge.map((data) => {
        return { wbscode: data.wbsCode, Description: data.wbsPercentage };
      });

      if (
        this.session.approvalStatus == 'Approved' &&
        this.session.sessionType != 'Deloitte' &&
        this.session.surcharge > 0 &&
        wbsList[0].wbscode &&
        this.isPrimaryWbsValidForCopy() &&
        !wbsListForSurcharge[0].wbscode
      ) {
        wbsListForSurcharge[0].wbscode = wbsList[0].wbscode;
      }

      if (this.domainNameList && this.domainNameList.length > 0) {
        this.domainNameList.map((domain) => {
          sessionRestrictoins.push({ Type: '2', Description: domain });
        });
      }

      if (this.participantEmailList && this.participantEmailList.length > 0) {
        this.participantEmailList.map((email) => {
          sessionRestrictoins.push({ Type: '1', Description: email });
        });
      }
      if (
        this.externalAdminEmailList &&
        this.externalAdminEmailList.length > 0
      ) {
        this.externalAdminEmailList.map((email) => {
          sessionExternalAdmins.push({ EmailAddress: email });
        });
      }
    }

    let companyNameObj;

    if (this.session.sessionType == 'Deloitte') companyNameObj = null;
    else
      companyNameObj = this.session.companyName
        ? this.session.companyName.Name
          ? this.session.companyName.Name
          : this.session.companyName
        : null;

    if (
      this.session.sponsoredCountry == 23 &&
      this.session.serviceLineFunction == 20
    ) {
      $('select[name="serviceLineFunction"]').addClass('is-invalid');
      this.showLoader = false;
      this.IsAfterSubmit = false;
      this.validForm = false;

      return;
    }

    if (
      this.session.disableSFDCIntegration &&
      this.isSFDCDisableOtherReasonInvalid &&
      this.session.sfdcDisableReasonId == 4
    ) {
      this.showLoader = false;
      this.IsAfterSubmit = false;
      this.validForm = false;
      return;
    }

    this.getSelectedSessionFormatName(this.session.sessionFormat);
    this.session.linkExpire = this.session.linkExpire
      ? this.session.linkExpire
      : this.session.sessionDate
        ? this.ngbCalendar.getNext(this.session.sessionDate)
        : null;
    if (this.maximumDate && this.session.linkExpire) {
      this.session.linkExpire =
        new Date(
          this.formattedDateInRequest(this.session.linkExpire)
        ).getTime() >
          new Date(this.formattedDateInRequest(this.maximumDate)).getTime()
          ? this.session.sessionDate
          : this.session.linkExpire;
    }

    let ApprovalStatus: string = 'Draft';
    if (this.draftSession === true) {
      this.old_approvalStatus = 'Draft';
    } else {
      ApprovalStatus = this.session.approvalStatus
        ? (this.session.approvalStatus == 'Approval Pending' ||
          this.session.approvalStatus == 'New' ||
          this.session.approvalStatus == 'Draft') &&
          this.session.sessionType != 'Deloitte'
          ? 'To Review'
          : (this.session.approvalStatus == 'Approval Pending' ||
            this.session.approvalStatus == 'New' ||
            this.session.approvalStatus == 'Draft') &&
            this.session.sessionType == 'Deloitte'
            ? 'Approved'
            : this.session.approvalStatus
        : null;
    }
    if (
      this.session.sponsoredCountry != 23 &&
      this.session.sponsoredCountry != 265 &&
      this.session.sponsoredCountry != 259 &&
      this.session.sponsoredCountry != 266 &&
      this.session.sponsoredCountry != 267 &&
      this.session.sponsoredCountry != 268 &&
      this.session.sponsoredCountry != 269 &&
      this.session.responsiblePpmd
    ) {
      this.responsiblePpmdEmail = this.session.responsiblePpmd
        ? this.session.responsiblePpmd
        : null;
    } else {
      this.responsiblePpmdEmail = this.session.responsiblePpmd
        ? this.session.responsiblePpmd.AD_EmailAdress
        : null;
    }

    // set reason for disable SFDC integration to null if SFDC integration is not enabled
    if (!this.session.disableSFDCIntegration) {
      this.session.sfdcDisableReasonId = null;
      this.session.sfdcDisableOtherReason = null;
    }

    // set other reason to null if the reason id is not others
    if (this.session.sfdcDisableReasonId != 4) {
      this.session.sfdcDisableOtherReason = null;
    }
    this.TopicName = this.dropdownData.Topic?.filter(
      (item) => item.ID == Number(this.session.Topic)
    )?.map((item) => item.TopicName)[0];
    this.ContentAreaName = this.dropdownData.ContentArea?.filter(
      (item) => item.ID == Number(this.session.contentArea)
    )?.map((item) => item.ContentAreaName)[0];

    const AddSessionInputs: any = {
      ModuleName: this.ModuleName,
      SessionCoordinators: this.sessionCoordinatorsList,
      SessionFacilitators: this.sessionFacilitatorsList,
      WBSCODE: wbsList && wbsList.length > 0 ? wbsList : [],
      WBSCODEFORSURCHARGE:
        wbsListForSurcharge && wbsListForSurcharge.length > 0
          ? wbsListForSurcharge
          : [],
      SessionRestrictions:
        sessionRestrictoins && sessionRestrictoins.length > 0
          ? sessionRestrictoins
          : [],
      SessionExternalAdmins:
        sessionExternalAdmins && sessionExternalAdmins.length > 0
          ? sessionExternalAdmins
          : [],
      CountryID: this.session.sponsoredCountry
        ? Number(this.session.sponsoredCountry)
        : 0,
      sLocationID: this.session.sessionCountry
        ? Number(this.session.sessionCountry)
        : 0,
      StateID: this.session.sessionState
        ? Number(this.session.sessionState)
        : 0,
      Citytext: Number(this.session.sessionCountry) == 23
        ? this.cityList.find((data) => (Number(data.CityID) == Number(this.session.sessionCity)))
          .CityName
        : this.session.sessionCity,
      City: Number(this.session.sessionCountry) == 23
        ? this.cityList.find((data) => (data.CityID = this.session.sessionCity))
          .CityID
        : null,
      SessionRequesterEmail: this.session.sessionRequester,
      SessionRequesterFirstName: null,
      SessionRequesterLastName: null,
      ResponsiblePPMDEmail: this.responsiblePpmdEmail,
      ResponsiblePPMDFirstName: this.session.responsiblePpmd
        ? this.session.responsiblePpmd.Name_First
        : null,
      ResponsiblePPMDLastName: this.session.responsiblePpmd
        ? this.session.responsiblePpmd.Name_Last
        : null,
      ServiceFunctionID: this.session.serviceLineFunction
        ? Number(this.session.serviceLineFunction)
        : 0,
      ServiceFunctionText:
        this.session.serviceLineFunction &&
          Number(this.session.serviceLineFunction) !== 20
          ? this.masterData.ServiceFunctions.find(
            (data) => data.ID == this.session.serviceLineFunction
          ).Name
          : this.session.serviceLineNA,
      IndustryID: this.session.sessionIndustry
        ? Number(this.session.sessionIndustry)
        : 0,
      IndustryText:
        this.session.sessionIndustry &&
          Number(this.session.sessionIndustry) !== 23
          ? this.masterData.Industries.find(
            (data) => data.ID == this.session.sessionIndustry
          ).Name
          : this.session.industryNA,
      SectorID: this.session.sessionSector
        ? Number(this.session.sessionSector)
        : 0,
      SectorText:
        this.session.sessionSector && Number(this.session.sessionSector) !== 40
          ? this.masterData.Sectors.find(
            (data) => data.SectorID == this.session.sessionSector
          ).SectorName
          : this.session.sectorNA,
      DepartmentID: this.session.sessionDepartment
        ? Number(this.session.sessionDepartment)
        : 0,
      OtherDepartment: this.session.otherDepartment
        ? this.session.otherDepartment
        : null,
      DelPPDs: this.session.ppmd ? Number(this.session.ppmd) : 0,
      SessionTypeID: this.session.sessionTypes
        ? Number(this.session.sessionTypes)
        : 0,
      SessionSubTypeID: this.session.sessionSubTypes
        ? this.session.sessionSubTypes
        : 0,
      PleaseSpecify:
        this.pleaseSpecifyFieldLength > 0
          ? Number(this.session.sessionTypes) > 0 &&
            (Number(this.session.sessionTypes) === 16 ||
              Number(this.session.sessionTypes) === 24)
            ? this.session.explainRationale
            : this.session.sessionTypeSpecify
          : null,
      SessionFormatID: this.session.sessionFormat
        ? Number(this.session.sessionFormat)
        : 0,
      SessionRange: this.session.sessionDate
        ? this.formattedDateInRequest(this.session.sessionDate)
        : null,
      StartDate: this.session.sessionDate
        ? this.formattedDateInRequest(this.session.sessionDate)
        : null,
      EndDate:
        this.session.linkExpire == null
          ? this.linkExpire
          : this.formattedDateInRequest(this.session.linkExpire),
      Name: this.session.sessionName ? this.session.sessionName : null,
      SessionLink:
        window.location.protocol + '//' + this.hostnameobj + '/#/?SessionID=',
      FormatedModifiedDate: this.session.lastModifiedDate
        ? this.formattedDateInRequest(this.session.lastModifiedDate)
        : null,
      FormatedCreatedDate: this.session.sessionDate
        ? this.formattedDateInRequest(this.session.sessionDate)
        : null,
      Comments: this.session.sessionComments
        ? this.session.sessionComments
        : null,
      Loggedinuser: this.loggedInUserID,
      UniqueID: this.sessionUniqueID ? this.sessionUniqueID : null,
      SessionType: this.session.sessionType ? this.session.sessionType : null,

      ApprovalStatus: ApprovalStatus,
      CompanyName: companyNameObj,
      IsDeloitte: true,
      IsRestricted: this.requiredDomainEmailsVal,

      //US 2869885 changes
      DCEFee: this.session.gxFees ? Math.round(Number(this.session.gxFees)) : 0,
      DelNonPPDs: 0,
      ExtNonExecutives:
        this.session.nonExecutives && this.session.sessionType != 'Deloitte'
          ? Number(this.session.nonExecutives)
          : 0,
      ExtExecutives:
        this.session.executives && this.session.sessionType != 'Deloitte'
          ? Number(this.session.executives)
          : 0,
      ClientProgramID: this.session.clientProgram
        ? Number(this.session.clientProgram)
        : 0,
      subscriptionUniqueID: this.session.subscriptionId
        ? this.session.subscriptionId
        : '0',
      EventId: '0',
      EventName: null,
      Eventlink: null,
      EventTypeID: this.session.sessionTypesEvent
        ? Number(this.session.sessionTypesEvent)
        : 0,
      EventProgramID: this.session.sessionTypesProgram
        ? Number(this.session.sessionTypesProgram)
        : 0,
      SecRestrictedID: this.session.secRestricted
        ? Number(this.session.secRestricted)
        : 0,
      CSuite:
        this.session.sessionType != 'Deloitte' ? this.isExtProfessional : false,
      DeloitteNonProfessional:
        this.session.sessionType != 'Deloitte'
          ? Number(this.session.nonDelProfessional)
          : 0,
      ReportFrequency:
        this.session.sessionType != 'Deloitte'
          ? this.session.sessionReport
          : null,
      ChargebackCurrency: this.session.currencyType,
      Rate: this.session.rate,
      Reason: this.session.reason,

      //US 2869885 changes
      Surcharge: this.negativeSurcharge
        ? Math.round(Number(this.negativeSurcharge))
        : this.session.surcharge
          ? Math.round(Number(this.session.surcharge))
          : this.session.surcharge,

      ApprovalDate:
        this.session.approvalStatus.toLowerCase() == 'approved' &&
          this.session.approvalStatus != this.approvalStatus
          ? new Date()
          : this.approvalDate,
      CadenceDate:
        this.session.sessionReport != this.sessionReport
          ? new Date()
          : this.cadenceDate,
      DisplayName: this.session.displayName,
      //added below four property for audit trail
      SponsoringCountryName: this.SponsoringCountryName,
      SessionCountryName: this.SessionCountryName,
      SessionTypeName: this.SessionTypeName,
      SessionFormatName: this.SessionFormatName,
      OptOutReason: this.optOut == "optOut" ? this.OptOutReason : '',
      FeedbackId : this.FeedbackId==''?null:this.FeedbackId,
      sessionFeedback : this.optOut,
      InvalidAge: this.InvalidAge,
      UserRoles: this.session.UserRoles,
      DisableSFDCIntegration: this.session.disableSFDCIntegration,
      SFDCDisableReasonId: this.session.sfdcDisableReasonId,
      SFDCDisableOtherReason: this.session.sfdcDisableOtherReason,
      SFDCEvents: this.sfdcEvents?.filter((e) => e.eventName !== ''),
      ContentAreaID: this.session.contentArea,
      TopicID: this.session.Topic,
      ContentAreaName: this.ContentAreaName,
      TopicName: this.TopicName,
      IsWBSCodeConfirmed: this.IsWBSCodeConfirmed 
    };

    if (
      this.approvalStatus === 'Draft' &&
      this.draftSession === false &&
      Number(this.sessionId) === 0
    ) {
      this.idforpopup = 0;
    } else {
      this.idforpopup = this.sessionId;
    }


    this.SessionService.addSession(AddSessionInputs, this.sessionId).subscribe(
      (response) => {
        let res = response.Data;
        if (Array.isArray(response.Data)) {
          res = response.Data[0];
        }
        if (res && Object.keys(res).length > 0) {
          if (res.SessionID) {
            this.sessionId = res.SessionID;
            this.responsedSessionName = res.SessionName; //Added for US: 2549253
          }
          if (
            this.session.sponsoredCountry == 23 &&
            this.session.approvalStatus == 'Approved' &&
            (this.userRoleID === 1 || this.userRoleID === 5)
          ) {
            this.downloadAcknowledgementEmail(AddSessionInputs, this.sessionId);
          }
          this.showLoader = false;

          this.session.lastModifiedDate = this.ngbCalendar.getToday();

          if (this.draftSession === true) {
            this.openSavePopUp('Draft');
          } else {
            this.IsAfterSubmit = true;
            this.visibilityApproveOptions();
            this.resetApprovalStatus(res.SessionLink);
            this.openSavePopUp('Submit');
          }
        } else {
          this.showLoader = false;
          this.IsAfterSubmit = false;
        }
      },
      (error) => {
        this.showLoader = false;
        this.IsAfterSubmit = false;
        this.openAccordian(false, form.value, 'submit');
      }
    );
  }

  checkCertifiedFacilitators() {
    if (
      !(
        ((this.userRoleID === 1 ||
          this.userRoleID === 5 ||
          this.userRoleID === 3) &&
          (this.session.sessionType == 'ExternalClient' ||
            this.session.sessionType == 'MixedAudience') &&
          (this.session.sessionTypes == 8 ||
            this.session.sessionTypes == 24)) ||
        (this.userRoleID === 1 && this.session.sessionTypes == 10) ||
        (this.session.sessionTypes == 18 && this.session.sessionTypes == 27)
      ) &&
      !(
        this.sessionId !== 0 &&
        (this.userRoleID === 4 ||
          (this.session.approvalStatus == 'Approved' &&
            (this.userRoleID === 2 ||
              this.userRoleID === 8 ||
              this.userRoleID === 5 ||
              this.userRoleID === 6)))
      ) &&
      this.isClientCertifiedFacilitator === false &&
      this.session.contentArea === 2
    ) {
      return true;
    } else {
      return false;
    }
  }
  isNewNonRecrutingSessionCreatedFromWRF(
    data,
    isExistingNonRecrutingSession: boolean
  ): boolean {
    if (
      !isExistingNonRecrutingSession &&
      this.isSessionCreatedFromWRF &&
      (data.SessionTypeID == 13 || data.SessionTypeID == 20) &&
      (data.SessionSubTypeID == 1 ||
        data.SessionSubTypeID == 3 ||
        data.SessionSubTypeID == 4 ||
        data.SessionSubTypeID == 5 ||
        data.SessionSubTypeID == 7 ||
        data.SessionSubTypeID == 8) &&
      !(
        data.subscriptionUniqueID &&
        !this.subscriptionIDError &&
        !this.isSubscriptionStatusError
      ) &&
      data.ApprovalStatus == 'To Review'
    ) {
      return true;
    }
    return false;
  }

  visibilityApproveOptions() {
    this.showApproveOptions = false;
    if (
      this.sessionId !== 0 &&
      (this.userRoleID === 1 ||
        this.userRoleID === 3 ||
        (this.userRoleID === 4 && this.session.sessionType === 'Deloitte') ||
        (this.userRoleID === 4 &&
          this.session.approvalStatus == 'Approved' &&
          !this.session.subscriptionId) ||
        ((this.userRoleID === 2 || this.userRoleID === 8) &&
          this.session.approvalStatus != 'To Review' &&
          this.session.approvalStatus != 'Approval Pending' &&
          this.session.approvalStatus != 'New'))
    ) {
      this.showApproveOptions = true;
      if (this.userRoleID === 4) {
        this.disableApprove = true;
      }
    } else if (this.sessionId !== 0 && this.userRoleID === 5) {
      this.showApproveOptions = true;
    } else if (
      this.sessionId !== 0 &&
      this.userRoleID === 6 &&
      this.session.approvalStatus != 'Approved'
    ) {
      const partOfSubscriptionAdmin = this.subscriptionAdmins.find(
        (item) => item.ID == this.loggedInUserID
      );
      this.showApproveOptions = partOfSubscriptionAdmin ? true : false;
    }
  }

  responsedSessionName: string = '';
  openSavePopUp(type) {
    this.sessionNameInPopUp = this.responsedSessionName;
    const save_session = new Modal(document.getElementById('save_session'));
    const draft_session = new Modal(document.getElementById('draft_session'));
    if (type == 'Submit') {
      save_session.show();
      this.removeBackdrop();

      // $("#save_session").modal({ backdrop: false }).modal('show');
    } else {
      draft_session.show();
      this.removeBackdrop();

      //  $("#draft_session").modal({ backdrop: false }).modal('show');
    }
    //  $(".modal-backdrop").remove();
    this.removeBackdrop();
  }
  orgSessionDate: Date;
  orgLinkExpDate: Date;
  checkIfEditMode() {
    this.activatedRoute.queryParams
      .pipe(
        map((params) => {
          if (params['id']) {
            this.sessionId = params['id'];
            return params['id'];
          }
          this.addRequesterToCoordinator();
        }),
        mergeMap((id) => this.SessionService.getEditSessionData(id))
      )
      .subscribe((response: any) => {
           if (response.Message == "Unauthorised") {
          this.router.navigate(["/unauthorised"]);
        }
        const data = response.Data;
        if (data && Object.keys(data).length > 0) {
          if (data.UserRoles.length > 0 && !this.isUserSuperAdmin) {
            this.userRoleID = data.UserRoles[0];
            if (data.UserRoles.includes(6)) {
              this.isUserSubscriptionAdminForSession = true;
            }
          }
          this.setInitialOptions();
          this.userRoleService.getUserRoles().subscribe((res) => {
            if (
              (res.LoggedInUserEmail != data.SessionRequesterEmail &&
                data.ApprovalStatus === 'To Review') ||
              (this.userRoleID !== 1 &&
                this.userRoleID !== 3 &&
                data.ApprovalStatus === 'Approved')
            ) {
              this.InvalidAgeDisabled = true;
            }
          });
          this.selectedCompany = data.CompanyName;
          this.disableSessionName = false;
          this.orgSessionDate = data.SessionRange;
          this.orgLinkExpDate = data.EndDate;
          
          // checking for client certified facilitator

          const existingClientCertifiedFacilitator =
            data.SessionFacilitators.find(
              (res) => res.CertificationlevelID == 1
            );
          if (existingClientCertifiedFacilitator) {
            this.isClientCertifiedFacilitator = true;
          } else {
            this.isClientCertifiedFacilitator = false;
          }

          this.operationType = 'Edit';
          this.closeConfirmPopUp();

          this.loadEditData(data);
          this.showLoader = false;
        }else{
          if (this.operationType === 'Edit') {
              this.closeConfirmPopUp();
            } else if (
              this.operationType === 'Add' &&
              this.router.url === '/addSession' 
            ) {
              this.openConfirmationDialog();
              this.showLoader = false;
            }else {
              this.myPopupInstance = null;
              this.showLoader = false;
            }
          }

    });

    //adding below setTimeout function to solve bug: 2701283
    // setTimeout(() => {
    //   if (this.operationType === 'Edit') {
    //     // const mypopup = new Modal(document.getElementById('mypopup'));
    //     // mypopup.hide();
    //     this.closeConfirmPopUp();
    //     // $("#mypopup").modal("hide");
    //   } else if (
    //     this.operationType === 'Add' &&
    //     this.router.url === '/addSession' 
    //   ) {
    //     this.openConfirmationDialog();
    //     this.showLoader = false;
    //   }else {
    //     this.myPopupInstance = null;
    //     this.showLoader = false;
    //   }
    // }, 3000);
  }


  isSessionCreatedFromWRF: boolean = false;
  isSessionCreatedFromCommercialization: boolean = false;

  loadEditData(data) {
    if (data && Object.keys(data).length > 0) {
      if (data.ModuleName == 'BCAdmin') {
        this.isSessionCreatedFromCommercialization = true;
      }
      this.ModuleName = data.ModuleName;
      this.isSessionCreatedFromWRF = data.isSessionCreatedFromWRF
        ? data.isSessionCreatedFromWRF
        : false;
      this.auditTrailList = data.SessionAuditTrail;
      this.FormatedCreatedDate = data.FormatedCreatedDate;

      this.mdmWbsDeploymentDate =
        (AppConfig as any)?.MDMWBSdeploymentDate ||
        data.MDMWBSdeploymentDate ||
        data.ChargeBackChangesDeploymentDate ||
        '';
      this.isSessionCreatedBeforeMdmWbsDeploymentDate =
        this.isSessionCreatedBeforeDeploymentDate(
          data.CreatedDate || data.FormatedCreatedDate,
          this.mdmWbsDeploymentDate
        );

      this.existingSessionDate = data.ChargeBackChangesDeploymentDate;
      this.isExistingNonRecrutingSession =
        this.checkIfExistingNonRecruitingSession(
          data.FormatedCreatedDate,
          data.NonRecrutingChargeBackDeploymentDate
        );
      this.checkIfExistingSession(data.FormatedCreatedDate);
      this.FormatedModifiedDate = data.FormatedModifiedDate;
      this.NonDeloitteUsersCount = data.NonDeloitteUsers;
      this.session.sessionType = data.SessionType;
      this.session.disableSFDCIntegration = data.DisableSFDCIntegration;
      this.session.sfdcDisableReasonId = data.SFDCDisableReasonId;
      this.session.sfdcDisableOtherReason = data.SFDCDisableOtherReason;

      if (
        this.isNewNonRecrutingSessionCreatedFromWRF(
          data,
          this.isExistingNonRecrutingSession
        ) &&
        data.Rate == null
      ) {
        data.Rate = 10;
      }

      // Function will execute on change of Session Audiance and on initial load of component
      this.sessionType1(data.SessionType, false);

      this.setSFDCEvents(data);

      this.approvalStatus = this.session.approvalStatus =
        data.ApprovalStatus == 'To Review'
          ? 'Approval Pending'
          : data.ApprovalStatus;
      this.disableApproveOptions();

      // if-else condition for fixing Bug-1953944
      if (Number(data.subscriptionUniqueID) == 0) {
        this.session.subscriptionId = null;
      } else {
        this.session.subscriptionId = data.subscriptionUniqueID;
      }
      this.editedSubscriptionId = data.subscriptionUniqueID;

      if (this.session.subscriptionId) {
        this.onFocusOutSubscription(this.session.subscriptionId, true);
      }
      this.companyName = data.CompanyName;
      this.session.companyName = data.CompanyName;
      this.session.clientProgram = data.ClientProgramID;
      this.session.secRestricted = data.SecRestrictedID;

      this.session.sponsoredCountry = data.CountryID;
      this.sponsoredCountryChange(this.session.sponsoredCountry);

      this.session.sessionCountry = data.sLocationID;
      this.sessionCountryChange(this.session.sessionCountry);

      this.session.sessionState = data.StateID;
      this.sessionStateChange(this.session.sessionState);

      this.session.sessionCity = data.City;
      this.session.sessionCoordinators = null;

      if (data.SessionCoordinators && data.SessionCoordinators.length > 0) {
        this.selectedCoordinators = data.SessionCoordinators.map((o) => {
          return {
            EmailAddress: o.EmailAddress,
            FirstName: o.FirstName,
            UserId: o.UserId,
            LastName: o.LastName,
            MemberFirm: null,
            Office: null,
          };
        });
        this.session.sessionCoordinators = null;
        this.existingCoordinatorlist = JSON.parse(
          JSON.stringify(this.selectedCoordinators)
        );
      }

      this.session.sessionRequester = data.SessionRequesterEmail;

      if (this.showPPMDAsTextInput) {
        this.session.responsiblePpmd = data.ResponsiblePPMDEmail;
      } else {
        this.session.responsiblePpmd = {
          Name_First: data.ResponsiblePPMDFirstName,
          Name_Last: data.ResponsiblePPMDLastName,
          AD_EmailAdress: data.ResponsiblePPMDEmail,
        };
        this.invalidppmd =
          this.session.responsiblePpmd.Name_First &&
            this.session.responsiblePpmd.Name_Last
            ? false
            : true;
      }

      this.session.serviceLineFunction = data.ServiceFunctionID;
      this.onServiceFunctionChange(data.ServiceFunctionID);
      this.session.serviceLineNA =
        data.ServiceFunctionID == 20 ? data.ServiceFunctionText : null;

      this.session.sessionIndustry = data.IndustryID;
      this.industryChange(data.IndustryID);
      this.session.industryNA =
        data.IndustryID == 23 ? data.IndustryText : null;

      this.session.sessionSector = data.SectorID;
      this.onSectorChange(data.SectorID);
      this.session.sectorNA = data.SectorID == 40 ? data.SectorText : null;

      // added if-else  block to fix bug: 2122551
      const item = this.dropdownData_Sectors.find(
        (index) => index.SectorID == data.SectorID
      );
      if (item == undefined) {
        this.session.sessionSector = null;
      } else {
        this.session.sessionSector = data.SectorID;
      }

      this.session.sessionDepartment = data.DepartmentID;
      this.departmentChange({ target: { value: data.DepartmentID } });
      this.session.otherDepartment = data.OtherDepartment;

      this.session.ppmd = data.DelPPDs;
      this.session.executives = data.ExtExecutives;
      this.session.nonExecutives = data.ExtNonExecutives;
      this.session.nonDelProfessional = data.DeloitteNonProfessional; // for chargeback user story
      this.isExtProfessional = this.session.cSuite = data.CSuite; // for chargeback user story
      this.session.actualUsage = data.ActualUsage;
      this.sessionReport = this.session.sessionReport =
        data.ReportFrequency == 0 ? null : data.ReportFrequency; // for chargeback user story
      this.isReportGeneration = this.session.reportCheck = this.session
        .sessionReport
        ? true
        : false; // for chargeback user story

      this.session.sessionTypes = data.SessionTypeID;

      this.OldSessionRequester = data.SessionRequesterEmail;

      //filter here
      if (this.session.sessionTypes) {
        const dataToFind = this.dropdownData.SessionType.find(
          (a) => a.SessionTypeID == data.SessionTypeID
        );
        if (!dataToFind) {
          const dataToInsert = this.staticSessionType.find(
            (a) => a.SessionTypeID == data.SessionTypeID
          );
          this.dropdownData.SessionType.push(dataToInsert);

          this.staticSessionTypeFlag = true;
          this.sessionProBonoFlag = true;
          this.sessionTypeSpecifyFlag = true;
          this.sessionTypeEventProgramFlag = true;
          this.staticSessionTypeEventFlag = true;
        } else {
          this.onSelectSessionType(this.session.sessionTypes);
        }
      }
      this.session.sessionSubTypes = data.SessionSubTypeID;

      this.session.sessionTypesEvent = data.EventTypeID;
      if (this.session.sessionTypesEvent) {
        this.onSelectSessionTypesEvent(this.session.sessionTypesEvent);
      }

      this.session.sessionTypesProgram = data.EventProgramID;
      if (this.session.sessionTypesProgram) {
        this.onSelectSessionTypesProgram(this.session.sessionTypesProgram);
      }
      if (
        Number(this.session.sessionTypes) > 0 &&
        (Number(this.session.sessionTypes) === 16 ||
          Number(this.session.sessionTypes) === 24)
      ) {
        this.session.proBono = data.PleaseSpecify ? 'yes' : 'no';
        this.session.explainRationale =
          this.session.proBono == 'yes' ? data.PleaseSpecify : null;
        this.session.sessionTypeSpecify = '';
        this.showSpecify = false;
        if (this.session.proBono == 'yes') {
          this.proBonoYes = true;
          this.onProbonoCheck(this.session.proBono);
        }
      } else {
        this.session.proBono = 'no';
        this.onProbonoCheck(this.session.proBono);
        this.session.explainRationale = null;
        this.session.sessionTypeSpecify = data.PleaseSpecify;
      }

      if (
        this.session.explainRationale != null &&
        this.session.explainRationale != undefined &&
        this.session.explainRationale != ''
      ) {
        this.pleaseSpecifyFieldLength = this.session.explainRationale.length;
      }
      if (
        this.session.sessionTypeSpecify != null &&
        this.session.sessionTypeSpecify != '' &&
        this.session.sessionTypeSpecify != undefined
      ) {
        this.pleaseSpecifyFieldLength = this.session.sessionTypeSpecify.length;
      }

      this.session.sessionFormat = data.SessionFormatID;
      if (this.session.sessionFormat) {
        const sessionFormatAvailable = this.dropdownData.SessionFormat.find(
          (a) => a.SessionFormatID == this.session.sessionFormat
        );
        if (!sessionFormatAvailable) {
          const addedSesssionFormat = this.staticSessionFormat.find(
            (b) => b.SessionFormatID == this.session.sessionFormat
          );
          this.dropdownData.SessionFormat.push(addedSesssionFormat);
          this.disableSesionFormat = true;
        }
      }

      this.session.sessionDate = this.formatStandardDate(data.SessionRange);
      this.session.sessionName = data.Name;

      this.session.certifiedFacilitator = null;
      if (data.SessionFacilitators && data.SessionFacilitators.length > 0) {
        this.selectedFacilitator = data.SessionFacilitators.map((o) => {
          return {
            Email: o.EmailAddress,
            FirstName: o.FirstName,
            ID: o.FacilitatorID,
            LastName: o.LastName,
            MemberFirm: null,
            Office: null,
            CertificationlevelID: o.CertificationlevelID,
          };
        });
      }

      this.session.currencyType = data.ChargebackCurrency
        ? data.ChargebackCurrency
        : 4;
      this.session.rate = data.Rate;
      this.session.reason = data.Reason;
      /*this.session.surcharge = data.Surcharge*/
      this.negativeSurcharge =
        data.Surcharge && data.Surcharge < 0 ? data.Surcharge : '';
      if (
        !(
          this.session.subscriptionId &&
          !this.subscriptionIDError &&
          !this.isSubscriptionStatusError
        )
      ) {
        this.session.surcharge = this.checkSurchargeBeforeExpiry(
          this.negativeSurcharge,
          data.EndDate,
          data.Surcharge,
          data.SessionLink
        );
      } else {
        this.session.surcharge = data.Surcharge;
      }

      this.visibilityOfLinkExpiration();
      this.visibilitySurcharge();
      this.visibilityRate();
      this.visibilitySurchargeWBS();

      this.session.lastModifiedDate = this.formatStandardDate(
        data.ModifiedDate
      );

      if (
        data.SessionWBSCodesMappings &&
        data.SessionWBSCodesMappings.length > 0
      ) {
        this.multipleWBS = data.SessionWBSCodesMappings.map((o, index) => {
          return {
            id: index,
            wbsCode: o.wbscode,
            wbsPercentage: o.Description,
            isSelectedFromPicklist: true, // Existing WBS codes are valid
            isExistingWbs: true,
            isNewWbsCode: false,
            isWbsActive: null,
            isWbsStatusChecked: false,
            isWbsStatusChecking: false,
            wbsDunsID: '', // Will be populated by verifyExistingWbsStatuses
          };
        });
      } else if (
        data.WBSCODE != null &&
        data.WBSCODE != undefined &&
        data.WBSCODE != ''
      ) {
        const obj: any = {
          id: 0,
          wbsCode: data.WBSCODE,
          wbsPercentage: '',
          isSelectedFromPicklist: true,
          isExistingWbs: true,
          isNewWbsCode: false,
          isWbsActive: null,
          isWbsStatusChecked: false,
          isWbsStatusChecking: false,
          wbsDunsID: '', // Will be populated by verifyExistingWbsStatuses
        };
        this.multipleWBS[0] = obj;
      }
      this.onWbsCodeEntered();
      this.calculateTotalWBSPercentage();
      if (this.multipleWBS.length <= 1) {
        this.multipleWBS[0].wbsPercentage = '';
        this.session.overageWBS = this.multipleWBS[0].id;
        this.totalWBSPercentage = 0;
      }

      /*WBS surcharge binding*/
      if (
        data.SurchargeWBSCodesMappings &&
        data.SurchargeWBSCodesMappings.length > 0
      ) {
        this.multipleWBSForSurcharge = data.SurchargeWBSCodesMappings.map(
          (o, index) => {
            return {
              id: index + '_surcharge',
              wbsCode: o.wbscode,
              wbsPercentage: o.Description,
              isSelectedFromPicklist: true,
              isExistingWbs: true,
              isNewSurchargeCode: false,
              isWbsActive: null,
              isWbsStatusChecked: false,
              isWbsStatusChecking: false,
            };
          }
        );
      }
      this.onWbsCodeEnteredForSurcharge();
      this.calculateTotalWBSPercentageForSurcharge();
      if (this.multipleWBSForSurcharge.length <= 1) {
        this.multipleWBSForSurcharge[0].wbsPercentage = '';
        this.totalWBSPercentageForSurcharge = 0;
      }

      this.session.gxFees =
        data.Rate == null && data.DCEFee == 0 ? null : data.DCEFee;
      this.session.sessionComments = data.Comments;
      this.session.displayName = data.DisplayName ? data.DisplayName : '';
      if (data.SessionRestrictions && data.SessionRestrictions.length > 0) {
        data.SessionRestrictions.map((data) => {
          if (data.Type == 2) {
            this.domainNameList.push(data.Description);
          }

          if (data.Type == 1) {
            this.participantEmailList.push(data.Description);
          }
        });
      }
      if (data.SessionExternalAdmins && data.SessionExternalAdmins.length > 0) {
        data.SessionExternalAdmins.map((data) => {
          this.externalAdminEmailList.push(data.EmailAddress);
        });
      }

      this.session.sessionLink = data.SessionLink;
      this.linkExpire = data.EndDate;
      this.session.linkExpire =
        data.EndDate && this.session.sessionLink
          ? this.formatStandardDate(data.EndDate)
          : null;

      this.sessionUniqueID = data.UniqueID;
      this.visibilityApproveOptions();
      this.disableEventTypeNavigation();
      if (
        data.PleaseSpecify &&
        Number(this.session.sessionTypes) > 0 &&
        Number(this.session.sessionTypes) != 16 &&
        Number(this.session.sessionTypes) != 24
      ) {
        this.showSpecify = true;
        this.specifyLabel = 'Please specify';
      }

      if (data.EventTypeID && data.EventTypeID > 0) {
        if (data.EventProgramID) {
          this.showProgram = true;
          if (Number(data.EventProgramID) == 192 || Number(data.EventProgramID) == 193 || Number(data.EventProgramID) == 194 || Number(data.EventProgramID) == 195) {
            this.showAuditLabSubType = true;
            this.showSpecify = false;
          } else {
            this.showAuditLabSubType = false;
            this.showSpecify = true;
          }

        }
        this.onSessionEventChange(data.EventTypeID);
      }
      const sessionEndDate = data.EndDate;
      if (this.session.linkExpire != null) {
        const sessionExpiryDate = formatDate(
          sessionEndDate,
          'yyyy-MM-dd',
          'en-us'
        );
        const formattedDate = formatDate(new Date(), 'yyyy-MM-dd', 'en-us');
        if (sessionExpiryDate >= formattedDate) {
          this.enableSurchargeWBS = true;
        }
      }
      if (
        (this.session.approvalStatus == 'Approved' &&
          this.session.sessionType != 'Deloitte' &&
          this.sessionId !== 0) ||
        (this.sessionId !== 0 &&
          this.session.approvalStatus == 'Approval Pending' &&
          (this.userRoleID === 1 || this.userRoleID === 3))
      ) {
        this.showClientAdminAndManagerLink = true;
        this.managerLink =
          window.location.protocol +
          '//' +
          this.hostnameobj +
          '/ManageSessionRestriction?sessionUID=' +
          data.UniqueID;
      } else this.showClientAdminAndManagerLink = false;
      if (this.session.sessionType == 'Deloitte') {
        this.showSessionNotApproved = false;
      }
      this.requiredDomainEmailsVal = data.IsRestricted;
      this.lastModifiedBy = data.LastModifiedByEmail;
      this.createdBy = data.CreatedByEmail;
      if (this.requiredDomainEmailsVal) {
        this.enableEmailInfo = this.requiredDomainEmailsVal;
      }
      this.isaudienceChanged = false;
      this.issubmitEnable = false;

      if (
        this.userRoleID !== null &&
        this.userRoleID != undefined &&
        this.userRoleID !== 1 &&
        this.session.sessionType != 'Deloitte' &&
        this.session.approvalStatus == 'Approved'
      ) {
        this.disableNonDeloitteProfessional = true;
      } else {
        this.disableNonDeloitteProfessional = false;
      }

      this.cadenceDate = data.CadenceDate;
      this.approvalDate = data.ApprovalDate;
      this.disableParticipantDetailsTab();

      if (
        this.session.proBono == 'yes' &&
        !(
          this.session.subscriptionId &&
          !this.subscriptionIDError &&
          !this.isSubscriptionStatusError
        )
      ) {
        this.session.gxFees = 0;
      }

      this.FeedbackId = data.FeedbackId;
      
      if (this.showFeedbackAccordian()) {
           if(data.OptOutReason == "" )
                 this.optOut = "IAgree";
           else 
                 this.optOut = "optOut";
          }
      }

    // for user story if form is valid then enable submit on load edit mode
    if (
      this.selectedFacilitator.length === 0 ||
      ((this.isClientCertifiedFacilitator === false ||
        this.selectedFacilitator.length === 0) &&
        (this.session.sessionType == 'ExternalClient' ||
          this.session.sessionType == 'MixedAudience') &&
        (this.userRoleID === 2 || this.userRoleID === 4) &&
        (this.session.sessionTypes == 8 || this.session.sessionTypes == 24)) ||
      this.isSessionDateGreaterTodayDate == true
    ) {
      this.issubmitEnable = false;
    } else {
      //Bug 2869900 fix
      if (this.session.approvalStatus == 'Draft') {
        if (
          this.selectedFacilitator.length === 0 ||
          (!this.showPPMDAsTextInput &&
            (typeof this.session.responsiblePpmd != 'object' ||
              (typeof this.session.responsiblePpmd == 'object' &&
                !this.session.responsiblePpmd.AD_EmailAdress)))
        ) {
          this.issubmitEnable = false;
        } else {
          this.issubmitEnable = true;
        }
      }
    }
    if (data.OptOutReason != null && data.OptOutReason != '') {
      this.optOut = "optOut";
      this.OptOutReason = data.OptOutReason;
    }
    this.unableSurchargeRateForFacAndCorRoles();
    this.InvalidAge = data.InvalidAge;
    this.session.UserRoles = data.UserRoles;
    if (
      Number(this.session.sessionTypes) === 4 ||
      Number(this.session.sessionTypes) === 10 ||
      Number(this.session.sessionTypes) === 18 ||
      Number(this.session.sessionTypes) === 27 ||
      Number(this.session.sessionTypes) === 3 ||
      Number(this.session.sessionTypes) === 9 ||
      Number(this.session.sessionTypes) === 17 ||
      Number(this.session.sessionTypes) === 25 ||
      Number(this.session.sessionTypes) === 5 ||
      Number(this.session.sessionTypes) === 12 ||
      Number(this.session.sessionTypes) === 22 ||
      Number(this.session.sessionTypes) === 29 ||
      Number(this.session.sessionTypes) === 6 ||
      Number(this.session.sessionTypes) === 31 ||
      Number(this.session.sessionTypes) === 32 ||
      Number(this.session.sessionTypes) === 7
    ) {
      this.doNotIntegrateWithSalesforce = true;
    } else {
      this.doNotIntegrateWithSalesforce = false;
    }
    this.session.contentArea = data.ContentAreaID;
    this.session.Topic = data.TopicID;
    if (
      Number(this.session.sessionTypes) === 1 ||
      Number(this.session.sessionTypes) === 8 ||
      Number(this.session.sessionTypes) === 16 ||
      Number(this.session.sessionTypes) === 24 ||

      Number(this.session.sessionTypes) === 4 ||
      Number(this.session.sessionTypes) === 10 ||
      Number(this.session.sessionTypes) === 18 ||
      Number(this.session.sessionTypes) === 27 ||

      ((Number(this.session.sessionTypes) === 11 ||
        Number(this.session.sessionTypes) === 19 ||
        Number(this.session.sessionTypes) === 26) &&
        (Number(this.session.sessionTypesEvent) == 17 ||
          Number(this.session.sessionTypesEvent) == 18 ||
          Number(this.session.sessionTypesEvent) == 19))
    ) {
      this.disableContentArea = false;
    } else {
      this.disableContentArea = true;
    }
    this.disableApproveOptions();
    this.updateWBSMandatoryStatus();
    this.SFWbsStatus = data.SFWbsStatus;
    this.wbsDisable =  this.checkWbsDisable(this.multipleWBS);
    this.verifyExistingWbsStatuses();
    this.verifyExistingSurchargeWbsStatuses();
    this.IsWBSCodeConfirmed = data.IsWBSCodeConfirmed;
  }

  setSFDCEvents(data: any) {
    this.sfdcEvents = [];
    this.eventId = data.EventId;
    this.eventName = data.EventName;
    this.eventLink = data.Eventlink;

    this.eventUrl = '';
    if (this.eventName) {
      this.eventUrl = this.eventLink + this.eventId;
    }

    if (data.SFDCEvents) {
      data.SFDCEvents.forEach((e) => {
        const sfdcEvent = new SFDCEvent();
        sfdcEvent.eventId = e.EventId;
        sfdcEvent.eventName = e.EventName;
        sfdcEvent.eventUrl = this.eventLink + e.EventId;
        this.sfdcEvents.push(sfdcEvent);
      });
    }

    if (
      this.eventName &&
      this.sfdcEvents.filter((e) => e.eventId == this.eventId).length === 0
    ) {
      const sfdcEvent = new SFDCEvent();
      sfdcEvent.eventId = this.eventId;
      sfdcEvent.eventName = this.eventName;
      sfdcEvent.eventUrl = this.eventLink + this.eventId;
      this.sfdcEvents.push(sfdcEvent);
    }

    if (
      this.sfdcEvents.length === 0 ||
      this.sfdcEvents[this.sfdcEvents.length - 1].eventName
    ) {
      const sfdcEvent = new SFDCEvent();
      sfdcEvent.eventUrl = this.eventLink;
      sfdcEvent.eventName = '';
      sfdcEvent.eventId = null;
      this.sfdcEvents.push(sfdcEvent);
    }
  }

  onDisableSFDCIntegrationChange(event: any) { }

  formatStandardDate(dateReceived) {
    let formattedDate = null;
    if (dateReceived) {
      const d = new Date(dateReceived);
      formattedDate = {
        year: d.getFullYear(),
        month: d.getMonth() + 1,
        day: d.getDate(),
      };
    }
    return formattedDate;
  }

  disableEventTypeNavigation() {
    this.disableDeloitte = null;
    this.disableExternalClient = null;
    this.disableExternalNonClient = null;
    this.disableMixedAudience = null;

    if (this.session.sessionType != 'Deloitte') {
      if (
        this.session.approvalStatus &&
        this.session.approvalStatus.toLowerCase() == 'approved'
      ) {
        if (
          this.userRoleID === 2 ||
          this.userRoleID === 4 ||
          this.userRoleID === 5 ||
          this.userRoleID === 6 ||
          this.userRoleID === 8
        ) {
          this.disableDeloitte = true;
          this.disableExternalClient = true;
          this.disableExternalNonClient = true;
          this.disableMixedAudience = true;
        } else if (this.userRoleID === 1 || this.userRoleID === 3) {
          this.disableDeloitte = this.NonDeloitteUsersCount == 0 ? null : true;
        }
      } else if (
        this.session.approvalStatus &&
        this.session.approvalStatus.toLowerCase() == 'cancelled'
      ) {
        this.disableDeloitte = this.NonDeloitteUsersCount == 0 ? null : true;
      }
    }

    if (this.session.sessionType == 'Deloitte') {
      if (
        this.session.approvalStatus &&
        this.session.approvalStatus.toLowerCase() == 'approved'
      ) {
        if (
          this.userRoleID === 2 ||
          this.userRoleID === 4 ||
          this.userRoleID === 5 ||
          this.userRoleID === 6
        ) {
          this.disableExternalClient = true;
          this.disableExternalNonClient = true;
          this.disableMixedAudience = true;
        }
      }
    }
  }

  loadSessionTypeDropDown() {
    if (
      this.masterData &&
      Object.keys(this.masterData).length > 0 &&
      this.selectedLink
    ) {
      this.session.sessionTypes = null;
      this.onSelectSessionType(this.session.sessionTypes);
    }
  }

  afterPopupClose(type) {
    if (type == 'Submit') {
      this.IsAfterSubmit = false;
    }

    this.userRoleService.getUserRoles().subscribe((res) => {
      this.userRoleService.setUserRoleList(res.Roleid);
      this.router.navigate(['/searchSession'], {
        relativeTo: this.activatedRoute,
      });
    });
  }

  onFocusOutType(value, fieldName) {
    switch (fieldName) {
      case 'coordinator':
        this.textLimitErrorCoordinator =
          value && value.length > 0 && value.length < 3 ? true : false;
        break;
      case 'PPMD':
        this.textLimitErrorPPMD =
          value && value.length > 0 && value.length < 3 ? true : false;
        break;
      case 'company':
        this.textLimitErrorCompany =
          value && value.length > 0 && value.length < 3 ? true : false;
        break;
      case 'facilitator':
        this.textLimitErrorFacilitator =
          value && value.length > 0 && value.length < 3 ? true : false;
        break;
      default:
        break;
    }
  }

  loadDepartmentDropdown() {
    const otherOption = this.masterData.Departments.find(
      (data) => data.ID == 26
    );
    this.dropdownData.Departments = this.masterData.Departments.filter(
      (data) => data.ID != 26
    );
    this.dropdownData.Departments = this.dropdownData.Departments.sort((a, b) =>
      a.Name.localeCompare(b.Name)
    );
    this.dropdownData.Departments.push(otherOption);
  }

  loadTopicDropdown() {
    if (this.masterData?.Topic) {
      this.dropdownData.Topic = JSON.parse(JSON.stringify(this.masterData.Topic));
      this.dropdownData.Topic = this.dropdownData.Topic.sort((a, b) =>
        a.TopicName.localeCompare(b.TopicName)
      );
    }
  }

  onWbsCodeEntered() {
    this.disableAddWBS = false;
    this.multipleWBS.map((data) => {
      if (data.wbsCode == '') {
        this.disableAddWBS = true;
        return;
      }
    });
  }

  onWbsCodeEnteredForSurcharge() {
    this.disableAddWBSForSurcharge = false;
    this.multipleWBSForSurcharge.map((data) => {
      if (data.wbsCode == '') {
        this.disableAddWBSForSurcharge = true;
        return;
      }
    });
  }

  private isPrimaryWbsValidForCopy(): boolean {
    const primary = this.multipleWBS && this.multipleWBS.length > 0 ? this.multipleWBS[0] : null;
    if (!primary || !primary.wbsCode) {
      return false;
    }

    const code = primary.wbsCode.trim();
    if (code.length != 22 || (code.match(/-/g) || []).length != 4 || /^[a-z0-9]+$/i.test(code)) {
      return false;
    }

    if (this.shouldUseWbsPicklist() && !primary.isSelectedFromPicklist) {
      return false;
    }

    if (this.invalidWBSDunsID || primary.isWbsActive !== true) {
      return false;
    }

    return true;
  }

  private syncSurchargeWbsFromPrimary(): void {
    if (!this.session || this.session.sessionType == 'Deloitte') {
      return;
    }

    if (!this.session.surcharge || Number(this.session.surcharge) <= 0) {
      return;
    }

    if (!this.isPrimaryWbsValidForCopy()) {
      return;
    }

    if (!this.multipleWBSForSurcharge || this.multipleWBSForSurcharge.length === 0) {
      this.multipleWBSForSurcharge = [{
        id: '0_surcharge',
        wbsCode: '',
        wbsPercentage: '',
        isSelectedFromPicklist: false,
        isExistingWbs: false,
        isNewSurchargeCode: true,
        isWbsActive: null,
        isWbsStatusChecked: false,
        isWbsStatusChecking: false,
      }];
    }

    const target = this.multipleWBSForSurcharge[0];
    if (!target || this.isInputWbsSurchargeChanged) {
      return;
    }

    if (target.wbsCode && target.wbsCode.trim() !== '') {
      return;
    }

    target.wbsCode = this.multipleWBS[0].wbsCode;
    target.isSelectedFromPicklist = this.multipleWBS[0].isSelectedFromPicklist === true;
    target.isWbsActive = this.multipleWBS[0].isWbsActive === true;
    target.isWbsStatusChecked = this.multipleWBS[0].isWbsStatusChecked === true;
    target.isWbsStatusChecking = false;
    this.onWbsCodeEnteredForSurcharge();
    this.validateWBSCodeForSurcharge();
  }

  private normalizeWbsCode(value: string): string {
    return (value || '').trim().toUpperCase();
  }

  private shouldBypassWbsDunsValidation(wbsCode: string): boolean {
    const normalizedWbsCode = this.normalizeWbsCode(wbsCode);
    return true;
    //return normalizedWbsCode.startsWith('LPE') || normalizedWbsCode.startsWith('GAA') || normalizedWbsCode.startsWith('GEP');
  }

  private updateInactiveWbsState(): void {
    const ignoreExistingInactiveForLegacySession =
      this.operationType === 'Edit' && this.isSessionCreatedBeforeMdmWbsDeploymentDate;

    this.inactiveWbsError =
      this.multipleWBS?.some((item) => {
        if (!item?.wbsCode || item.isWbsActive !== false) {
          return false;
        }

        if (ignoreExistingInactiveForLegacySession && item.isExistingWbs) {
          return false;
        }

        return true;
      }) || false;
    this.disableApproveDueToWbs = this.inactiveWbsError;
  }

  private ensureReplacementWbsFieldForInactiveExisting(): void {
    if (
      this.operationType !== 'Edit' ||
      !this.isSessionCreatedBeforeMdmWbsDeploymentDate ||
      this.isAddingReplacementWbs
    ) {
      return;
    }

    const hasInactiveExisting = this.multipleWBS?.some(
      (item) => item.isExistingWbs && item.isWbsActive === false
    );
    if (!hasInactiveExisting) {
      return;
    }

    const hasOpenNewField = this.multipleWBS?.some(
      (item) => !item.isExistingWbs && (!item.wbsCode || item.wbsCode.trim() === '')
    );
    if (hasOpenNewField) {
      return;
    }

    //this.isAddingReplacementWbs = true;
    //this.updateWBSFields('add');
    //this.isAddingReplacementWbs = false;
  }

  private verifyExistingWbsStatuses(): void {
    if (this.operationType !== 'Edit' || !this.multipleWBS?.length) {
      this.updateInactiveWbsState();
      return;
    }

    this.multipleWBS.forEach((item) => {
      const rawCode = (item.wbsCode || '').trim();
      if (!rawCode || rawCode.length !== 22) {
        item.isWbsActive = null;
        item.isWbsStatusChecked = false;
        item.isWbsStatusChecking = false;
        return;
      }

      const requestCode = rawCode;
      item.isWbsStatusChecking = true;
      this.SessionService.getWBSCodes(requestCode).subscribe((results) => {
        if ((item.wbsCode || '').trim() !== requestCode) {
          return;
        }

        const normalizedRequest = this.normalizeWbsCode(requestCode);
        // Find the matched entry to extract DunsNumber
        const matchedEntry = (results || []).find((entry) => {
          const entryCode = this.normalizeWbsCode(
            entry?.Element || entry?.WBSCode || entry?.wbsCode
          );
          return entryCode && entryCode === normalizedRequest;
        });

        item.isWbsActive = !!matchedEntry;
        item.isWbsStatusChecked = true;
        item.isWbsStatusChecking = false;
        
        // Map DunsNumber from API response to multipleWBS, similar to onWBSSelect
        if (matchedEntry) {
          item.wbsDunsID = matchedEntry.DunsNumber || matchedEntry.DunsID || matchedEntry.dunsId || '';
        }
        
        this.updateInactiveWbsState();
        this.ensureReplacementWbsFieldForInactiveExisting();
        
        // Re-validate WBS codes against company DunsID after mapping
        if (this.selectedCompanyDunsID) {
          this.validateWBSCode();
        }
        
        this.disableApproveOptions();
        this.syncSurchargeWbsFromPrimary();
      });
    });
  }

  private verifyExistingSurchargeWbsStatuses(): void {
    if (this.operationType !== 'Edit' || !this.multipleWBSForSurcharge?.length) {
      return;
    }

    this.multipleWBSForSurcharge.forEach((item) => {
      const rawCode = (item.wbsCode || '').trim();
      if (!rawCode || rawCode.length !== 22) {
        item.isWbsActive = null;
        item.isWbsStatusChecked = false;
        item.isWbsStatusChecking = false;
        return;
      }

      const requestCode = rawCode;
      item.isWbsStatusChecking = true;
      this.SessionService.getWBSCodes(requestCode).subscribe((results) => {
        if ((item.wbsCode || '').trim() !== requestCode) {
          return;
        }

        const normalizedRequest = this.normalizeWbsCode(requestCode);
        const matchedEntry = (results || []).find((entry) => {
          const entryCode = this.normalizeWbsCode(
            entry?.Element || entry?.WBSCode || entry?.wbsCode
          );
          return entryCode && entryCode === normalizedRequest;
        });

        item.isWbsActive = !!matchedEntry;
        item.isWbsStatusChecked = true;
        item.isWbsStatusChecking = false;

        this.validateWBSCodeForSurcharge();
      });
    });
  }

  loadSessionFormatDropdown() {
    if (this.isUserSuperAdmin) {
      if (this.masterData && this.masterData.SessionFormat) {
        if (this.userRoleID === 1) {
          this.dropdownData.SessionFormat = JSON.parse(
            JSON.stringify(this.masterData.SessionFormat)
          );
        } else if (this.userRoleID === 6) {
          // filtering bis dev link as per suggestion by sateesh (done by abhishek)
          this.dropdownData.SessionFormat =
            this.masterData.SessionFormat.filter(
              (data) => data.SessionFormatID != 5
            );
        } else if (this.userRoleID === 2 || this.userRoleID === 3) {
          this.dropdownData.SessionFormat =
            this.masterData.SessionFormat.filter(
              (data) =>
                data.SessionFormatID == 1 ||
                data.SessionFormatID == 2 ||
                data.SessionFormatID == 6
            );
        } else if (this.userRoleID === 5) {
          this.dropdownData.SessionFormat =
            this.masterData.SessionFormat.filter(
              (data) =>
                data.SessionFormatID == 1 ||
                data.SessionFormatID == 2 ||
                data.SessionFormatID == 3 ||
                data.SessionFormatID == 6
            );
        }
      }
    } else {
      if (this.masterData && this.masterData.SessionFormat) {
        this.dropdownData.SessionFormat = this.masterData['SessionFormat']
          ? this.masterData['SessionFormat']
          : [];
      }
      this.dropdownData.SessionFormat = this.dropdownData.SessionFormat
        ? this.getUniqueList(
          this.dropdownData.SessionFormat,
          'SessionFormatName'
        )
        : [];
    }
  }

  validateWBSCode(item?) {
    if (!this.shouldValidateMainWBS()) {
      this.invalidWBS = false;
      this.wbsid = null;
      this.currentWBS = item;
      this.multipleWBS.forEach((data) => {
        $('#' + data.id).removeClass('is-invalid');
      });
      return this.invalidWBS;
    }
    this.invalidWBS = false;
    this.invalidWBSDunsID = false;
    this.wbsid = null;
    this.currentWBS = item;
    const companyDunsID = (this.selectedCompanyDunsID || '').toString().trim();
    this.multipleWBS.map((data) => {
      let isCurrentItemValid = true;

      // Check if WBS is mandatory and empty
      if (this.isWBSMandatory && (!data.wbsCode || data.wbsCode.trim() === '')) {
        this.invalidWBS = true;
        this.wbsid = data.id;
        $('#' + data.id).addClass('is-invalid');
        data.isWbsActive = null;
        data.isWbsStatusChecked = false;
        data.isWbsStatusChecking = false;
        isCurrentItemValid = false;
      } else if (!data.wbsCode && data.wbsCode != '' && this.multipleWBS.length > 0) {
        this.invalidWBS = true;
        this.wbsid = data.id;
        $('#' + data.id).removeClass('is-invalid');
        data.isWbsActive = null;
        data.isWbsStatusChecked = false;
        data.isWbsStatusChecking = false;
        isCurrentItemValid = false;
      } else if (
        data.wbsCode &&
        (data.wbsCode.length != 22 ||
          (data.wbsCode.match(/-/g) || []).length != 4 ||
          /^[a-z0-9]+$/i.test(data.wbsCode))
      ) {
        $('#' + data.id).addClass('is-invalid');
        this.invalidWBS = true;
        this.wbsid = data.id;
        data.isWbsActive = null;
        data.isWbsStatusChecked = false;
        data.isWbsStatusChecking = false;
        isCurrentItemValid = false;
      } else if (
        this.shouldUseWbsPicklist() &&
        data.wbsCode &&
        !data.isSelectedFromPicklist
      ) {
        data.wbsDunsID = '';
        data.isWbsActive = null;
        data.isWbsStatusChecked = false;
        data.isWbsStatusChecking = false;
        $('#' + data.id).addClass('is-invalid');
        this.invalidWBS = true;
        this.wbsid = data.id;
        isCurrentItemValid = false;
      } else {
        $('#' + data.id).removeClass('is-invalid');
      }
      
      // Validate DunsID against selected company's DunsID.
      // Both DUNS values are mandatory and must match exactly.
      const wbsDunsID = (data.wbsDunsID || '').toString().trim();
      const shouldBypassDunsValidation = this.shouldBypassWbsDunsValidation(data.wbsCode);
      if (data.wbsCode && !shouldBypassDunsValidation && (!companyDunsID || !wbsDunsID || wbsDunsID !== companyDunsID)) {
        this.invalidWBS = true;
        this.invalidWBSDunsID = true;
        this.wbsid = data.id;
        $('#' + data.id).addClass('is-invalid');
        data.isWbsActive = null;
        data.isWbsStatusChecked = false;
        data.isWbsStatusChecking = false;
        isCurrentItemValid = false;
      }
      
      this.multipleWBS.map((innerCheckdata) => {
        if (
          data.wbsCode == innerCheckdata.wbsCode &&
          data.id != innerCheckdata.id
        ) {
          this.invalidWBS = true;
          this.wbsid = innerCheckdata.id;
          $('#' + innerCheckdata.id).addClass('is-invalid');
          innerCheckdata.isWbsActive = null;
          innerCheckdata.isWbsStatusChecked = false;
          innerCheckdata.isWbsStatusChecking = false;
          isCurrentItemValid = false;
        }
      });

      if (isCurrentItemValid && data.wbsCode) {
        data.isWbsStatusChecked = true;
        data.isWbsStatusChecking = false;

        if (!(data.isExistingWbs && data.isWbsActive === false)) {
          data.isWbsActive = true;
        }
      }
    });
    if (this.multipleWBS[0].wbsCode && this.multipleWBS[0].wbsCode != '') {
      this.isaudienceChanged = true;
      this.issubmitEnable = true;
    }
    //Bug 3684642 fix
    if (!this.invalidWBS) {
      this.issubmitEnable = true;
    }
    return this.invalidWBS;
  }
  openWBSpopup() {
    this.IsWBSCodeConfirmed = false;
    this.cdr.detectChanges();
    const valid_wbs = new Modal(document.getElementById('valid_wbs'));
    if (!this.invalidWBS && this.multipleWBS[0].wbsCode) {
      valid_wbs.show();
      this.removeBackdrop();
    }
  }

  onWbsConfirmationChange(event: any) {
    this.IsWBSCodeConfirmed = event.target.checked;
    this.cdr.detectChanges();
  }
  validateWBSCodeForSurcharge() {
    this.invalidWBSForSurcharge = false;
    this.wbsidForSurcharge = null;
    this.multipleWBSForSurcharge.map((data) => {
      let isCurrentItemValid = true;
      if (
        !data.wbsCode &&
        data.wbsCode != '' &&
        this.multipleWBSForSurcharge.length > 0
      ) {
        this.invalidWBSForSurcharge = true;
        this.wbsidForSurcharge = data.id;
        $('#' + data.id).removeClass('is-invalid');
        data.isWbsActive = null;
        data.isWbsStatusChecked = false;
        data.isWbsStatusChecking = false;
        isCurrentItemValid = false;
      } else if (
        data.wbsCode &&
        (data.wbsCode.length != 22 ||
          (data.wbsCode.match(/-/g) || []).length != 4 ||
          /^[a-z0-9]+$/i.test(data.wbsCode))
      ) {
        $('#' + data.id).addClass('is-invalid');
        this.invalidWBSForSurcharge = true;
        this.wbsidForSurcharge = data.id;
        data.isWbsActive = null;
        data.isWbsStatusChecked = false;
        data.isWbsStatusChecking = false;
        isCurrentItemValid = false;
      } else if (
        this.shouldUseWbsPicklist() &&
        data.wbsCode &&
        !data.isSelectedFromPicklist
      ) {
        $('#' + data.id).addClass('is-invalid');
        this.invalidWBSForSurcharge = true;
        this.wbsidForSurcharge = data.id;
        data.isWbsActive = null;
        data.isWbsStatusChecked = false;
        data.isWbsStatusChecking = false;
        isCurrentItemValid = false;
      } else {
        $('#' + data.id).removeClass('is-invalid');
      }
      this.multipleWBSForSurcharge.map((innerCheckdata) => {
        if (
          data.wbsCode == innerCheckdata.wbsCode &&
          data.id != innerCheckdata.id
        ) {
          this.invalidWBSForSurcharge = true;
          this.wbsidForSurcharge = innerCheckdata.id;
          $('#' + innerCheckdata.id).addClass('is-invalid');
          innerCheckdata.isWbsActive = null;
          innerCheckdata.isWbsStatusChecked = false;
          innerCheckdata.isWbsStatusChecking = false;
          isCurrentItemValid = false;
        }
      });

      if (isCurrentItemValid && data.wbsCode) {
        data.isWbsStatusChecked = true;
        data.isWbsStatusChecking = false;
        if (!(data.isExistingWbs && data.isWbsActive === false)) {
          data.isWbsActive = true;
        }
      }
    });
    if (
      this.multipleWBSForSurcharge[0].wbsCode &&
      this.multipleWBSForSurcharge[0].wbsCode != ''
    ) {
      this.isaudienceChanged = true;
      this.issubmitEnable = true;
    }
    //Bug 3684642 fix
    if (!this.invalidWBSForSurcharge) {
      this.issubmitEnable = true;
    }
    return this.invalidWBSForSurcharge;
  }

  validateWBSPercentage() {
    if (!this.shouldValidateMainWBS()) {
      this.invalidPercenatge = false;
      return;
    }
    this.invalidPercenatge = false;
    if (this.multipleWBS.length > 1) {
      this.multipleWBS.map((data) => {
        if (!data.wbsPercentage) {
          this.invalidPercenatge = true;
        }
      });
    }
    /*return invalidPercenatge;*/
  }

  validateWBSPercentageForSurcharge() {
    this.invalidPercenatgeForSurcharge = false;
    if (this.multipleWBSForSurcharge.length > 1) {
      this.multipleWBSForSurcharge.map((data) => {
        if (!data.wbsPercentage) {
          this.invalidPercenatgeForSurcharge = true;
        }
      });
    }
    /*return invalidPercenatge;*/
  }

  validateWBSCodeOnSubmit() {
    this.updateWBSMandatoryStatus();
    if (!this.shouldValidateMainWBS()) {
      this.invalidWBS = false;
      this.wbsid = null;
      this.multipleWBS.forEach((data) => {
        $('#' + data.id).removeClass('is-invalid');
      });
      return;
    }
    this.invalidWBS = false;
    this.wbsid = null;
    this.multipleWBS.map((data) => {
      // Check if WBS is mandatory and empty
      if (!data.wbsCode || data.wbsCode.trim() === '') {
        this.invalidWBS = true;
        this.wbsid = data.id;
        $('#' + data.id).addClass('is-invalid');
      } else if (
        data.wbsCode &&
        (data.wbsCode.length != 22 ||
          (data.wbsCode.match(/-/g) || []).length != 4 ||
          /^[a-z0-9]+$/i.test(data.wbsCode))
      ) {
        $('#' + data.id).addClass('is-invalid');
        this.invalidWBS = true;
        this.wbsid = data.id;
      } else if (
        this.shouldUseWbsPicklist() &&
        data.wbsCode &&
        !data.isSelectedFromPicklist
      ) {
        $('#' + data.id).addClass('is-invalid');
        this.invalidWBS = true;
        this.wbsid = data.id;
      } else {
        $('#' + data.id).removeClass('is-invalid');
      }
      this.multipleWBS.map((innerCheckdata) => {
        if (
          data.wbsCode == innerCheckdata.wbsCode &&
          data.id != innerCheckdata.id
        ) {
          this.invalidWBS = true;
          this.wbsid = innerCheckdata.id;
          $('#' + innerCheckdata.id).addClass('is-invalid');
        }
      });
    });
  }

  validateWBSCodeOnSubmitForSurcharge() {
    this.invalidWBSForSurcharge = false;
    this.wbsidForSurcharge = null;
    this.multipleWBSForSurcharge.map((data) => {
      if (!data.wbsCode && this.multipleWBSForSurcharge.length > 1) {
        this.invalidWBSForSurcharge = true;
        this.wbsidForSurcharge = data.id;
        $('#' + data.id).removeClass('is-invalid');
      } else if (
        data.wbsCode &&
        (data.wbsCode.length != 22 ||
          (data.wbsCode.match(/-/g) || []).length != 4 ||
          /^[a-z0-9]+$/i.test(data.wbsCode))
      ) {
        $('#' + data.id).addClass('is-invalid');
        this.invalidWBSForSurcharge = true;
        this.wbsidForSurcharge = data.id;
      } else if (
        this.shouldUseWbsPicklist() &&
        data.wbsCode &&
        !data.isSelectedFromPicklist
      ) {
        $('#' + data.id).addClass('is-invalid');
        this.invalidWBSForSurcharge = true;
        this.wbsidForSurcharge = data.id;
      } else {
        $('#' + data.id).removeClass('is-invalid');
      }
      this.multipleWBSForSurcharge.map((innerCheckdata) => {
        if (
          data.wbsCode == innerCheckdata.wbsCode &&
          data.id != innerCheckdata.id
        ) {
          this.invalidWBSForSurcharge = true;
          this.wbsidForSurcharge = innerCheckdata.id;
          $('#' + innerCheckdata.id).addClass('is-invalid');
        }
      });
    });
  }
  invalidSessionName: boolean = false;
  onFocusOutSessionName(event: FocusEvent) {
    const target = event.target as HTMLInputElement; // Perform type assertion here
    const value = target.value;
    this.invalidSessionName = value && value.trim() ? false : true;
  }

  onFocusOutOtherReason() {
    if (this.session?.sfdcDisableOtherReason?.trim().length === 0) {
      this.session.sfdcDisableOtherReason = null;
    }
  }

  onFocusOutCompany(event) {
    this.invalidCompany =
      event && event.target.value && event.target.value.trim() ? false : true;
    if (!this.invalidCompany) {
      // if condition will execute on creating a new session
      if (this.sessionId === 0) {
        this.generateSessionName();
      }

      // Adding if() condition as Session Name should update on change of Session Audiance AND (companyName OR Department OR Date)
      if (this.sessionId !== 0 && this.afterEditIsAudianceChanged == true) {
        this.generateSessionName();
      }

      this.session.companyName = { Name: event.target.value.trim() };
      $('#companyID').val(event.target.value.trim());
      this.companyName = event.target.value.trim();
      this.checkInvalidCompany();
    } else {
      this.disableSessionName = true;
      this.companyName = event.target.value.trim();
      this.session.clientProgram = null;
      this.session.sessionIndustry = null;
      this.session.sessionSector = null;
    }
  }

  validateNumber(e) {
    if (
      !(
        (e.keyCode > 95 && e.keyCode < 106) ||
        (e.keyCode > 47 && e.keyCode < 58) ||
        e.keyCode == 8
      )
    ) {
      return false;
    }
    return true;
  }

  restrictNumeric(e) {
    if (e.target.value && e.target.value.length >= 9) {
      e.preventDefault();
      return false;
    }
    if (e.metaKey || e.ctrlKey) {
      return true;
    }
    if (e.which == 32) {
      return false;
    }
    if (e.which == 0) {
      return true;
    }
    if (e.which < 33) {
      return true;
    }
    const input = String.fromCharCode(e.which);
    return !!/[\d\s]/.test(input);
  }

  ngOnDestroy() {
    this.closeConfirmPopUp();
    this.userRoleService.setDisableUserRoleList(false);
  }
  onFocusClosetCity(value, valid) {
    if (valid == true && value != '' && value.trim() == '')
      $('#sessionCity').addClass('is-invalid');
    else $('#sessionCity').removeClass('is-invalid');
  }

  visibilityOfLinkExpiration() {
    this.disableLinkExpire = true;

    // updated if condition for fixing bug: 2117322; Adding condition for coordinataor for 2540433
    if (
      (this.session.approvalStatus.toLowerCase() == 'approved' &&
        this.session.subscriptionId &&
        this.userRoleID !== 2 &&
        this.userRoleID !== 8 &&
        this.userRoleID !== 4) ||
      (this.session.approvalStatus.toLowerCase() == 'approved' &&
        !this.session.subscriptionId &&
        this.userRoleID !== 2 &&
        this.userRoleID !== 4 &&
        this.userRoleID !== 5 &&
        this.userRoleID !== 6 &&
        this.userRoleID !== 8)
    ) {
      this.disableLinkExpire = false;
    }
  }

  disableApproveOptions() {
    this.disableApprove = false;
    if (
      this.sessionId !== 0 &&
      ((this.session.approvalStatus == 'Approved' && this.userRoleID === 6) ||
        this.userRoleID === 4 ||
        this.userRoleID === 8 ||
        this.userRoleID === 2)
    ) {
      this.disableApprove = true;
      if (
        this.session.sessionType == 'Deloitte' &&
        (this.userRoleID === 2 || this.userRoleID === 8) &&
        this.session.approvalStatus == 'Approved'
      ) {
        this.disableApprove = false;
      }
    }
    const isSubscriptionAdmin = this.subscriptionAdmins.find(
      (item) => item.ID == this.loggedInUserID
    );
    const isCoordinators = this.selectedCoordinators.find(
      (item) => item.ID == this.loggedInUserID
    );
    const isFacilitators = this.selectedFacilitator.find(
      (item) => item.ID == this.loggedInUserID
    );
    let isValid = true;
    const sessionTypeId = Number(this.session.sessionTypes);
    if (
      sessionTypeId != 2 &&
      sessionTypeId != 11 &&
      sessionTypeId != 19 &&
      sessionTypeId != 26 &&
      sessionTypeId != 3 &&
      sessionTypeId != 9 &&
      sessionTypeId != 17 &&
      sessionTypeId != 25 &&
      sessionTypeId != 4 &&
      sessionTypeId != 10 &&
      sessionTypeId != 18 &&
      sessionTypeId != 27
    ) {
      isValid = false;
    }
    if (this.sessionId !== 0 && this.userRoleID === 5) {
      if (this.session.subscriptionId) {
        if (
          (this.session.UserRoles.includes(2) ||
            this.session.UserRoles.includes(4) ||
            isCoordinators ||
            isFacilitators) &&
          !this.session.UserRoles.includes(6) &&
          !isSubscriptionAdmin
        ) {
          this.disableApprove = true;
        }
        if (!this.session.UserRoles.includes(6) && !isSubscriptionAdmin) {
          this.disableApprove = true;
        }

        if (this.session.UserRoles.includes(6) || isSubscriptionAdmin) {
          if (!isValid) {
            this.disableApprove = true;
          } else if (
            this.session.approvalStatus != 'To Review' &&
            this.session.approvalStatus != 'Approval Pending'
          ) {
            this.disableApprove = true;
          } else {
            if (this.session.UserRoles.includes(4) || isCoordinators) {
              this.disableApprove = true;
            }
          }
        }
        if (
          this.session.UserRoles.includes(6) &&
          isSubscriptionAdmin &&
          !this.isUserSuperAdmin &&
          (this.session.approvalStatus == 'To Review' ||
            this.session.approvalStatus == 'Approval Pending') &&
          this.session.approvalStatus != 'Approved'
        ) {
          if (!isValid) {
            this.disableApprove = false;
          }
        }
      } else if (!isValid) {
        this.disableApprove = true;
      }
    }
    if ((this.userRoleID !== 1 && this.userRoleID !== 3) && this.session.contentArea == 2) {
      this.disableApprove = true;
     this.session.approvalStatus = this.approvalStatus;
    }
    if(this.userRoleID == 3 && this.session.contentArea != 2){
      this.disableApprove = false;
    }
  }
  OrgSponsoringCountries = [];
  loadSponsoringCountry() {
    if (this.masterData && Object.keys(this.masterData).length > 0) {
      const assignedCountries = this.userRoleService.userAssignedCountries;
      this.sponsoringCountries = JSON.parse(
        JSON.stringify(this.masterData.Countries)
      );
      if (
        assignedCountries &&
        assignedCountries.length > 0 &&
        this.userRoleID === 3
      ) {
        this.sponsoringCountries = [];
        assignedCountries.map((country, index) => {
          const countryDetail = this.masterData.Countries.filter(
            (country) => country.ID == assignedCountries[index]
          );
          if (countryDetail && countryDetail.length > 0) {
            this.sponsoringCountries.push(countryDetail[0]);
          }
        });
        this.sponsoringCountries.sort((a, b) => a.Name.localeCompare(b.Name));
        const usCountries = this.sponsoringCountries.filter(
          (country) =>
            country.ID == 23 || country.ID == 259 || country.ID == 265 || country.ID == 266 || country.ID == 267 || country.ID == 268 || country.ID == 269
        );
        const nonUSCountries = this.sponsoringCountries.filter(
          (country) =>
            country.ID != 23 && country.ID != 259 && country.ID != 265 && country.ID != 266 &&
            country.ID != 267 && country.ID != 268 && country.ID != 269
        );
        this.sponsoringCountries = [...usCountries, ...nonUSCountries];
       }
    }
    this.OrgSponsoringCountries = this.sponsoringCountries;
  }

  loadSFDCDisableReasons() {
    if (this.masterData && Object.keys(this.masterData).length > 0) {
      this.sfdcDisableReasons = JSON.parse(
        JSON.stringify(this.masterData.SFDCDisableReasons)
      );
    }
  }

  initalizeStaticSessionFormat() {
    this.staticSessionFormat = [
      {
        SessionFormatID: 3,
        SessionFormatName: 'AdeptPro Digital Experience',
        ToolTip: 'Session will be delivered digitally on the AdeptPro platform',
      },
      {
        SessionFormatID: 5,
        SessionFormatName: 'Business Development Link',
        ToolTip:
          'Single person / single use link specifically intended in the pursuit process',
      },
      {
        SessionFormatID: 1,
        SessionFormatName: 'In-Person',
        ToolTip: 'Session will be delivered in person',
      },
      {
        SessionFormatID: 4,
        SessionFormatName: 'Subscription Link',
        ToolTip: 'Session link used for long term access',
      },
      {
        SessionFormatID: 2,
        SessionFormatName: 'Virtual',
        ToolTip:
          'Session will not be delivered in person, but rather using an online meeting application',
      },
      {
        SessionFormatID: 6,
        SessionFormatName: 'Hybrid (In Person/Virtual)',
        ToolTip: '',
      },
    ];
  }

  updateSessionName() {
    let companyName = '';

    if (!this.session.companyName.Name)
      companyName = this.session.companyName ? this.session.companyName : '';
    else
      companyName = this.session.companyName
        ? this.session.companyName.Name
        : '';

    if (this.session.sessionType != 'Deloitte') {
      if (this.session.sessionName.includes('Deloitte')) {
        this.session.sessionName = this.session.sessionName.replace(
          'Deloitte',
          companyName
        );
      }
    }
    if (this.session.sessionType == 'Deloitte') {
      if (this.session.sessionName.includes(companyName)) {
        this.session.sessionName = this.session.sessionName.replace(
          companyName,
          'Deloitte'
        );
      }
    }
  }

  onCSuiteChange(event: Event) {
    const checkbox = event.target as HTMLInputElement;
    const isChecked = checkbox.checked;
    this.isExtProfessional = this.session.cSuite = isChecked;
  }

  onReportSelect(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const isChecked = inputElement.checked;

    this.isReportGeneration = this.session.reportCheck = isChecked;
    this.session.sessionReport = this.isReportGeneration
      ? this.session.sessionReport
      : null;
  }

  sessionReportChange(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const reportType = inputElement.value;

    this.session.sessionReport = reportType;
  }

  onWBSSelected(id, wbsCode) { }

  calculateChargebackAndSurcharge() {
    this.isFLPEvent = false;
    this.negativeSurcharge = '';
    const nonDelProfessional = this.session.nonDelProfessional
      ? this.session.nonDelProfessional
      : 0;
    const actualUsage = this.session.actualUsage ? this.session.actualUsage : 0;

    // probono yes no
    const probonoValue = this.session.proBono;
    const sessionTypeValue = this.session.sessionTypes;
    if (
      this.session.sessionType == 'ExternalNonClient' ||
      this.session.sessionType == 'MixedAudience'
    ) {
      if (
        this.session.sponsoredCountry == 23 &&
        (sessionTypeValue == 16 || sessionTypeValue == 24) &&
        probonoValue == 'no'
      ) {
        const rate = this.session.rate != null ? this.session.rate : 80;
        if (
          this.session.rate != null &&
          !(
            this.session.subscriptionId &&
            !this.subscriptionIDError &&
            !this.isSubscriptionStatusError
          )
        ) {
          this.session.gxFees = nonDelProfessional * rate;
        } else if (
          !(
            this.session.subscriptionId &&
            !this.subscriptionIDError &&
            !this.isSubscriptionStatusError
          )
        ) {
          this.session.gxFees =
            nonDelProfessional <= 50 ? 4000 : nonDelProfessional * rate;
        }

        /*calculation of surcharge*/
        if (
          !(
            this.session.subscriptionId &&
            !this.subscriptionIDError &&
            !this.isSubscriptionStatusError
          )
        ) {
          if (nonDelProfessional <= 50 && actualUsage <= 55) {
            this.session.surcharge = this.session.rate != null ? 0 : null;
          } else if (nonDelProfessional <= 50 && actualUsage > 55) {
            this.session.surcharge = (actualUsage - 50) * rate;
          } else if (
            nonDelProfessional > 50 &&
            actualUsage >= nonDelProfessional
          ) {
            this.session.surcharge =
              actualUsage - this.session.nonDelProfessional <= 5
                ? ''
                : (this.session.actualUsage - this.session.nonDelProfessional) *
                rate;
          } else if (
            nonDelProfessional > 50 &&
            actualUsage < nonDelProfessional
          ) {
            this.session.surcharge = (actualUsage - nonDelProfessional) * rate;
          }
        }

        this.session.gxFees = this.session.gxFees
          ? +this.session.gxFees % 1 != 0
            ? (+this.session.gxFees).toFixed(2)
            : this.session.gxFees
          : this.session.gxFees;
        this.session.surcharge = this.session.surcharge
          ? +this.session.surcharge % 1 != 0
            ? (+this.session.surcharge).toFixed(2)
            : this.session.surcharge
          : this.session.surcharge;

        if (
          this.session.surcharge < 0 &&
          !(
            this.session.subscriptionId &&
            !this.subscriptionIDError &&
            !this.isSubscriptionStatusError
          )
        ) {
          this.negativeSurcharge = JSON.parse(
            JSON.stringify(this.session.surcharge)
          );
          this.session.surcharge = this.checkSurchargeBeforeExpiry(
            this.negativeSurcharge,
            this.linkExpire,
            this.session.surcharge,
            this.session.sessionLink
          );
        }
        this.disabledFieldsOnProBonoYes();
        return;
      } else if (
        this.session.sponsoredCountry == 23 &&
        (sessionTypeValue == 16 || sessionTypeValue == 24) &&
        probonoValue == 'yes' &&
        !(
          this.session.subscriptionId &&
          !this.subscriptionIDError &&
          !this.isSubscriptionStatusError
        )
      ) {
        this.session.gxFees = 0;
        this.session.rate = null;
        this.session.reason = '';
        this.session.surcharge = null;
        this.disabledFieldsOnProBonoYes();
        return;
      }
    }

    if (
      this.session.sessionType != 'Deloitte' &&
      this.session.sponsoredCountry == 23 &&
      !this.isExistingSession
    ) {
      /*For business chemistry standard session*/
      if (
        this.session.sessionTypes == 8 ||
        this.session.sessionTypes == 16 ||
        this.session.sessionTypes == 24 ||
        this.session.sessionTypes == 33 ||
        this.session.sessionTypes == 34 ||
        this.session.sessionTypes == 35 ||
        (this.session.sessionTypes == 11 &&
          this.session.sessionTypesEvent == 6) ||
        (this.session.sessionTypes == 19 &&
          this.session.sessionTypesEvent == 10) ||
        (this.session.sessionTypes == 26 &&
          this.session.sessionTypesEvent == 14)
      ) {
        const rate = this.session.rate != null ? this.session.rate : 80;
        /*calculation of chargback*/
        if (
          this.session.rate != null &&
          !(
            this.session.subscriptionId &&
            !this.subscriptionIDError &&
            !this.isSubscriptionStatusError
          )
        ) {
          this.session.gxFees = nonDelProfessional * rate;
        } else if (
          !(
            this.session.subscriptionId &&
            !this.subscriptionIDError &&
            !this.isSubscriptionStatusError
          )
        ) {
          if (
            ((this.session.sessionTypes == 11 &&
              this.session.sessionTypesEvent == 6) ||
              (this.session.sessionTypes == 19 &&
                this.session.sessionTypesEvent == 10) ||
              (this.session.sessionTypes == 26 &&
                this.session.sessionTypesEvent == 14)) &&
            !this.isExistingNonRecrutingSession
          ) {
            this.isFLPEvent = true;
            this.session.gxFees = 0;
          } else {
            this.isFLPEvent = false;
            this.session.gxFees =
              nonDelProfessional <= 50 ? 4000 : nonDelProfessional * rate;
          }
        }

        /*calculation of surcharge*/
        if (
          !(
            this.session.subscriptionId &&
            !this.subscriptionIDError &&
            !this.isSubscriptionStatusError
          )
        ) {
          if (nonDelProfessional <= 50 && actualUsage <= 55) {
            this.session.surcharge = this.session.rate != null ? 0 : null;
          } else if (nonDelProfessional <= 50 && actualUsage > 55) {
            this.session.surcharge = (actualUsage - 50) * rate;
          } else if (
            nonDelProfessional > 50 &&
            actualUsage >= nonDelProfessional
          ) {
            this.session.surcharge =
              actualUsage - this.session.nonDelProfessional <= 5
                ? ''
                : (this.session.actualUsage - this.session.nonDelProfessional) *
                rate;
          } else if (
            nonDelProfessional > 50 &&
            actualUsage < nonDelProfessional
          ) {
            this.session.surcharge = (actualUsage - nonDelProfessional) * rate;
          }
        }
      }

      /*for non-recruting event*/
      if (
        Number(this.session.sessionTypes) === 13 ||
        Number(this.session.sessionTypes) === 20
      ) {
        // calculate gxFees, surcharge and set rate to 10 for new sessions with session sub type 1,3,4,5,7,8
        if (
          (this.session.sessionSubTypes == 1 ||
            this.session.sessionSubTypes == 3 ||
            this.session.sessionSubTypes == 4 ||
            this.session.sessionSubTypes == 5 ||
            this.session.sessionSubTypes == 7 ||
            this.session.sessionSubTypes == 8) &&
          !this.isExistingNonRecrutingSession
        ) {
          if (
            !this.session.rate &&
            !(
              this.session.subscriptionId &&
              !this.subscriptionIDError &&
              !this.isSubscriptionStatusError
            )
          ) {
            this.session.rate = 10;
          }
          this.session.gxFees =
            this.session.rate != null &&
              !(
                this.session.subscriptionId &&
                !this.subscriptionIDError &&
                !this.isSubscriptionStatusError
              )
              ? nonDelProfessional * this.session.rate
              : this.session.gxFees;

          this.session.surcharge =
            this.session.rate != null &&
              !(
                this.session.subscriptionId &&
                !this.subscriptionIDError &&
                !this.isSubscriptionStatusError
              )
              ? (actualUsage - nonDelProfessional) * this.session.rate
              : this.session.surcharge;
        } else {
          // calculate gxFees and surcharge for existing sessions and new sessions with session sub type other than 1,3,4,5,7,8
          this.session.gxFees =
            this.session.rate != null &&
              !(
                this.session.subscriptionId &&
                !this.subscriptionIDError &&
                !this.isSubscriptionStatusError
              )
              ? nonDelProfessional * this.session.rate
              : this.session.gxFees;

          this.session.surcharge =
            this.session.rate != null &&
              !(
                this.session.subscriptionId &&
                !this.subscriptionIDError &&
                !this.isSubscriptionStatusError
              )
              ? (actualUsage - nonDelProfessional) * this.session.rate
              : this.session.surcharge;
        }
      }

      /*for recruting event/other client/other non-client/mixed group*/
      if (
        this.session.sessionTypes == 14 ||
        this.session.sessionTypes == 21 ||
        this.session.sessionTypes == 15 ||
        this.session.sessionTypes == 30 ||
        this.session.sessionTypes == 23
      ) {
        this.session.gxFees =
          this.session.rate != null &&
            !(
              this.session.subscriptionId &&
              !this.subscriptionIDError &&
              !this.isSubscriptionStatusError
            )
            ? nonDelProfessional * this.session.rate
            : this.session.gxFees;
        this.session.surcharge =
          this.session.rate != null &&
            !(
              this.session.subscriptionId &&
              !this.subscriptionIDError &&
              !this.isSubscriptionStatusError
            )
            ? (actualUsage - nonDelProfessional) * this.session.rate
            : this.session.surcharge;
      }

      this.session.gxFees = this.session.gxFees
        ? +this.session.gxFees % 1 != 0
          ? (+this.session.gxFees).toFixed(2)
          : this.session.gxFees
        : this.session.gxFees;
      this.session.surcharge = this.session.surcharge
        ? +this.session.surcharge % 1 != 0
          ? (+this.session.surcharge).toFixed(2)
          : this.session.surcharge
        : this.session.surcharge;

      if (
        this.session.surcharge < 0 &&
        !(
          this.session.subscriptionId &&
          !this.subscriptionIDError &&
          !this.isSubscriptionStatusError
        )
      ) {
        this.negativeSurcharge = JSON.parse(
          JSON.stringify(this.session.surcharge)
        );
        this.session.surcharge = this.checkSurchargeBeforeExpiry(
          this.negativeSurcharge,
          this.linkExpire,
          this.session.surcharge,
          this.session.sessionLink
        );
      }
    }
    if ( this.session.sponsoredCountry == 23 && (Number(this.session.sessionTypesProgram) === 193 || Number(this.session.sessionTypesProgram) === 194 || Number(this.session.sessionTypesProgram) === 195)) {
      this.session.gxFees = 4000;
      this.chargebackDisabledFlag = true;
    } else {
      this.chargebackDisabledFlag = false;
    }
    this.onOpenChargeCodeAccordian();
    this.syncSurchargeWbsFromPrimary();
  }

  myFlag: boolean = false;
  chargebackDisabledFlag: boolean = false;
  disabledFieldsOnProBonoYes() {
    // probono yes
    const probonoValue = this.session.proBono;
    const sessionTypeValue = this.session.sessionTypes;

    if (
      this.session.sessionType == 'ExternalNonClient' ||
      this.session.sessionType == 'MixedAudience'
    ) {
      if (
        this.session.sponsoredCountry == 23 &&
        (this.userRoleID === 1 ||
          this.userRoleID === 2 ||
          this.userRoleID === 3 ||
          this.userRoleID === 4 ||
          this.userRoleID === 5 ||
          this.userRoleID === 6) &&
        (sessionTypeValue == 16 || sessionTypeValue == 24) &&
        probonoValue == 'yes' &&
        !(
          this.session.subscriptionId &&
          !this.subscriptionIDError &&
          !this.isSubscriptionStatusError
        )
      ) {
        this.myFlag = true;
        this.chargebackDisabledFlag = true;
        this.session.gxFees = 0;
      } else if (
        this.session.sponsoredCountry == 23 &&
        (this.userRoleID === 1 ||
          this.userRoleID === 2 ||
          this.userRoleID === 3 ||
          this.userRoleID === 4 ||
          this.userRoleID === 5 ||
          this.userRoleID === 6) &&
        (sessionTypeValue == 16 || sessionTypeValue == 24) &&
        probonoValue == 'no'
      ) {
        this.myFlag = false;
        this.chargebackDisabledFlag = false;
      }
    }
  }

  resetChargebackFields() {
    //if DU client event of XA programs/event is selected then defaulting values in chargeback/fee section
    if (
      this.session.sessionTypesEvent == '17' ||
      this.session.sessionTypesEvent == '18' ||
      this.session.sessionTypesEvent == '19'
    ) {
      this.isDUClientEvent = true;
      this.session.gxFees = !(
        this.session.subscriptionId &&
        !this.subscriptionIDError &&
        !this.isSubscriptionStatusError
      )
        ? 1000
        : this.session.gxFees;
    } else {
      this.session.gxFees = !(
        this.session.subscriptionId &&
        !this.subscriptionIDError &&
        !this.isSubscriptionStatusError
      )
        ? null
        : this.session.gxFees;
      this.isDUClientEvent = false;
    }
    this.session.currencyType = 4;
    this.session.rate = !(
      this.session.subscriptionId &&
      !this.subscriptionIDError &&
      !this.isSubscriptionStatusError
    )
      ? null
      : this.session.rate;
    this.session.reason = !(
      this.session.subscriptionId &&
      !this.subscriptionIDError &&
      !this.isSubscriptionStatusError
    )
      ? ''
      : this.session.reason;
    this.session.surcharge = !(
      this.session.subscriptionId &&
      !this.subscriptionIDError &&
      !this.isSubscriptionStatusError
    )
      ? null
      : this.session.surcharge;
  }
  onSessionAudienceChange(e: string, flag: boolean) {
    if (e == 'ExternalClient') {
      this.sponsoringCountries = this.OrgSponsoringCountries.filter(
        (country) => country.ID != 266
      );
    } else {
      this.sponsoringCountries = this.OrgSponsoringCountries;
    }
    if (
      this.sessionId !== 0 &&
      this.session.approvalStatus.toLowerCase() == 'approved' &&
      (this.session.gxFees || this.session.surcharge)
    ) {
      this.confirmationDialogService
        .confirm(
          'Confirmation',
          'The fee related fields will be reset, please re-enter the values',
          'OK',
          'CANCEL',
          null,
          false,
          true
        )
        .then((confirmed) => {
          if (confirmed) {
            this.sessionType1(e, flag);
          } else {
            this.session.sessionType = this.selectedLink;
          }
        });
    } else {
      this.sessionType1(e, flag);
    }
  }

  validateChargeBackFields(event, rate?) {
    if (
      (event.charCode >= 48 && event.charCode <= 57) ||
      (!rate && event.charCode == 45) ||
      event.charCode == 46
    ) {
      if (event.target.value.indexOf('.') >= 0) {
        return event.target.value.length -
          event.target.value.indexOf('.') -
          1 <=
          1
          ? true
          : false;
      }
      return true;
    }
    return false;
  }
  visibilitySurcharge() {
    this.disableSurcharge = true;
    if (
      this.isExistingSession ||
      (this.session.approvalStatus.toLowerCase() == 'approved' &&
        (this.userRoleID === 1 || this.userRoleID === 3))
    ) {
      this.disableSurcharge = false;
    }
    if (
      this.session.approvalStatus.toLowerCase() == 'approval pending' &&
      this.userRoleID === 3
    ) {
      this.disableSurcharge = false;
    }
  }

  visibilityRate() {
    this.disableRate = false;
    if (
      this.session.approvalStatus.toLowerCase() == 'approved' &&
      !this.isExistingSession
    ) {
      this.disableRate = true;
    }
  }

  visibilitySurchargeWBS() {
    this.showSurchargeWBS = false;
    if (
      (this.session.sessionType != 'Deloitte' &&
        this.session.approvalStatus.toLowerCase() == 'approved' &&
        this.session.surcharge > 0 &&
        this.session.surcharge != '' &&
        (this.userRoleID === 2 ||
          this.userRoleID === 8 ||
          this.userRoleID === 5 ||
          this.userRoleID === 6 ||
          this.userRoleID === 4)) ||
      this.userRoleID === 3 ||
      this.userRoleID === 1
    ) {
      this.showSurchargeWBS = true;
    }
  }

  downloadAcknowledgementEmail(AddSessionInputs, sessionId) {
    const itemType = this.dropdownData.SessionType.find(
      (data) => data.SessionTypeID == AddSessionInputs.SessionTypeID
    );
    const itemEventType = this.dropdownData.SessionTypeEvents.find(
      (data) => data.eventID == AddSessionInputs.EventTypeID
    );
    const itemSubType = this.dropdownData.SessionSubType.find(
      (data) => data.SessionSubTypeID == AddSessionInputs.SessionSubTypeID
    );
    let isWBS = false;
    let emailSubject = '';
    if (
      AddSessionInputs.WBSCODE &&
      AddSessionInputs.WBSCODE.length > 0 &&
      AddSessionInputs.WBSCODE[0].wbscode != ''
    ) {
      isWBS = true;
    }
    if (
      AddSessionInputs.subscriptionUniqueID == 0 &&
      AddSessionInputs.SessionType != 'Deloitte' &&
      isWBS &&
      itemType.SessionTypeName == 'XA Program/Event' &&
      itemEventType.Name == 'Finance Leadership Program (FLP)'
    ) {
      emailSubject =
        'Acknowledgement Letter BusinessChemistry Finance Leadership Program';
    }
    if (
      AddSessionInputs.subscriptionUniqueID == 0 &&
      AddSessionInputs.SessionType != 'Deloitte' &&
      AddSessionInputs.SessionType != 'MixedAudience' &&
      !isWBS &&
      itemType.SessionTypeName == 'Non-Recruiting College Event' &&
      (itemSubType.SessionSubTypeName == 'Administrators and staff only' ||
        itemSubType.SessionSubTypeName == 'Students and administrator' ||
        itemSubType.SessionSubTypeName == 'Students only')
    ) {
      emailSubject = 'Acknowledgement Letter UniversityStudents ProBono';
    }
    if (
      AddSessionInputs.subscriptionUniqueID == 0 &&
      AddSessionInputs.SessionType != 'Deloitte' &&
      AddSessionInputs.SessionType != 'MixedAudience' &&
      isWBS &&
      itemType.SessionTypeName == 'Non-Recruiting College Event' &&
      (itemSubType.SessionSubTypeName == 'Administrators and staff only' ||
        itemSubType.SessionSubTypeName == 'Students and administrator' ||
        itemSubType.SessionSubTypeName == 'Students only' ||
        itemSubType.SessionSubTypeName == 'Formalized curriculum')
    ) {
      emailSubject = 'Acknowledgement Letter UniversityEngagement Paid';
    }
    if (
      AddSessionInputs.subscriptionUniqueID == 0 &&
      this.proBonoYes &&
      AddSessionInputs.SessionType != 'Deloitte' &&
      AddSessionInputs.SessionType != 'ExternalClient' &&
      !isWBS &&
      itemType.SessionTypeName == 'Business Chemistry Standard Session'
    ) {
      emailSubject = 'Acknowledgement Letter ProBono';
    }
    if (
      AddSessionInputs.subscriptionUniqueID == 0 &&
      AddSessionInputs.IndustryText == 'Government & Public Services' &&
      AddSessionInputs.SessionType != 'Deloitte' &&
      isWBS &&
      itemType.SessionTypeName == 'Business Chemistry Standard Session'
    ) {
      emailSubject = 'Acknowledgement Letter GPS Certified Network';
    } else if (
      AddSessionInputs.subscriptionUniqueID == 0 &&
      AddSessionInputs.SessionType != 'Deloitte' &&
      isWBS &&
      (itemType.SessionTypeName == 'Business Chemistry Standard Session' ||
        itemType.SessionTypeName == 'Executive Transition Accelerator')
    ) {
      emailSubject = 'Acknowledgement Letter Certified Network';
    }
    if (
      AddSessionInputs.subscriptionUniqueID == 0 &&
      AddSessionInputs.SessionType != 'Deloitte' &&
      itemType.SessionTypeName == 'Custom Business Chemistry Lab'
    ) {
      emailSubject = 'Acknowledgement Letter BusinessChemistryLab';
    }
    if (emailSubject !== '') {
      this.SessionService.emailDownload(
        AddSessionInputs,
        sessionId,
        emailSubject
      ).subscribe((res) => {
        var binaryData = [];
        binaryData.push(res);

        const url = window.URL.createObjectURL(
          new Blob(binaryData, { type: 'application/vnd.ms-excel' })
        );
        // create hidden dom element (so it works in all browsers)
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        // create file, attach to hidden element and open hidden element
        a.href = url;
        a.download = emailSubject + '.eml';
        a.click();
      });
    }
  }

  checkIfExistingSession(createdDate) {
    this.isExistingSession = false;
    const sessionCreatedDate = new Date(createdDate);
    const dateForExistingSession = new Date(this.existingSessionDate);
    if (sessionCreatedDate.getTime() < dateForExistingSession.getTime()) {
      this.isExistingSession = true;
    }
  }

  private isSessionCreatedBeforeDeploymentDate(createdDate: any, deploymentDate: any): boolean {
    const parsedCreatedDate = this.parseDateValue(createdDate);
    const parsedDeploymentDate = this.parseDateValue(deploymentDate);

    if (!parsedCreatedDate || !parsedDeploymentDate) {
      return false;
    }

    return parsedCreatedDate.getTime() < parsedDeploymentDate.getTime();
  }

  private parseDateValue(value: any): Date | null {
    if (!value) {
      return null;
    }

    const rawValue = typeof value === 'string' ? value.trim() : value;
    const normalizedValue =
      typeof rawValue === 'string'
        ? rawValue.replace(/\s(CST|CDT|EST|EDT|PST|PDT)$/i, '').trim()
        : rawValue;

    const parsedDate = new Date(normalizedValue);
    return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
  }

  // method to check if session is created after non-recruiting chargeback deployment date or not
  checkIfExistingNonRecruitingSession(
    createdDate,
    nonRecrutingChargeBackDeploymentDate
  ) {
    const sessionCreatedDate = new Date(createdDate);
    const deploymentDate = new Date(nonRecrutingChargeBackDeploymentDate);
    if (sessionCreatedDate.getTime() < deploymentDate.getTime()) {
      return true;
    }
    return false;
  }

  copySessionLink() {
    if (this.session.sessionLink) {
      const newVariable = window.navigator;
      if (newVariable && newVariable.share) {
        const $temp = $('#sessLink');
        $temp.focus();
        $temp.select();
        newVariable.clipboard
          .writeText(this.session.sessionLink)
          .then(() => {
            this.isLinkCopied = true;
            setTimeout(() => {
              this.isLinkCopied = false;
            }, 5000);
          })
          .catch((error) => {
            this.isLinkCopied = false;
          });
      }
    }
  }
  copyFeedbackId() {
    if (this.FeedbackId) {
      const newVariable = window.navigator;
      if (newVariable && newVariable.share) {
        const $temp = $('#feedbackId');
        $temp.focus();
        $temp.select();
        newVariable.clipboard
          .writeText(this.FeedbackId)
          .then(() => {
            this.isFeedbackIdCopied = true;
            setTimeout(() => {
              this.isFeedbackIdCopied = false;
            }, 5000);
          })
          .catch((error) => {
            this.isFeedbackIdCopied = false;
          });
      }
    }
  }

  onExit() {
    let url = localStorage.getItem('previousUrl');
    url =
      !url || url.includes('addSession') || url.includes('editSession')
        ? '/searchSession'
        : url;
    url = url.includes('sessionTimeout') ? '/searchSession' : url;
    const isUntouched = $('#subButton').prop('disabled');
    if (!isUntouched) {
      this.confirmationDialogService
        .confirm(
          'Confirmation',
          'Any unsaved changes made will be lost. Are you sure?',
          'YES',
          'NO',
          null,
          false,
          true
        )
        .then((confirmed) => {
          if (confirmed) {
            this.router.navigate([url], {
              relativeTo: this.activatedRoute,
            });
          }
        });
    } else {
      this.router.navigate([url], {
        relativeTo: this.activatedRoute,
      });
    }
  }

  checkSurchargeBeforeExpiry(negativeSur, endDate, surcharge, sessionLink) {
    if (!endDate || !sessionLink) {
      return null;
    }
    if (negativeSur && endDate) {
      const todaysDate = new Date().setHours(0, 0, 0, 0);
      const expiryDate = new Date(endDate).setHours(0, 0, 0, 0);

      if (todaysDate < expiryDate) {
        return null;
      }
      return negativeSur;
    }
    return surcharge;
  }

  onChangeSurcharge() {
    this.negativeSurcharge = '';
    this.syncSurchargeWbsFromPrimary();
  }

  addRequesterToCoordinator() {
    if (this.masterData && this.masterData.loginUserInfo) {
      const requester = { item: this.masterData.loginUserInfo };
      requester.item['Email'] = this.masterData.loginUserInfo.EmailAddress;
      this.updateCoordinator(requester, 'add', false);
    }
  }

  // accordion flag for group 1 Organization Details
  accordionFlag1: boolean = false;
  checkAccordionGrouping1(resource) {
    if (resource.sessionType == 'Deloitte') {
      //for Internal Deloitte
      if (
        resource.sessionDepartment == null ||
        resource.serviceLineFunction == null ||
        resource.sessionIndustry == null ||
        resource.sessionSector == null ||
        resource.sponsoredCountry == null ||
        (resource.sponsoredCountry == 23 &&
          resource.serviceLineFunction == 20) ||
        this.isSubscriptionStatusError ||
        (this.showNAFields == true &&
          (((resource.serviceLineNA == null ||
          resource.serviceLineNA == '') && !this.disableServiceFunctionNA) ||
          ((resource.industryNA == null ||
          resource.industryNA == '') && !this.disableIndustryNA)||
            ((resource.sectorNA == null ||
          resource.sectorNA == '') && !this.disableSectorNA))) ||
        (this.otherDepartmentDisable === false &&
          (this.session.otherDepartment?.trim() === '' || this.session.otherDepartment?.trim() === undefined))
      ) {
        return (this.accordionFlag1 = true); // field empty
      } else {
        return (this.accordionFlag1 = false);
      }
    } else {
      let checkEmptyObject;
      if (resource.companyName.Name == '') {
        checkEmptyObject = 0;
      } else {
        checkEmptyObject = Object.keys(resource.companyName).length;
      }

      if (
        this.isSessionDateWithinRange === true ||
        this.isSessionSingleLink === true ||
        this.invalidCompany ||
        this.subscriptionIDError ||
        this.isSubscriptionStatusError ||
        (resource.secRestricted == null && resource.sessionType != "ExternalNonClient" ) ||
        resource.sessionDepartment == null ||
        resource.serviceLineFunction == null ||
        resource.sessionIndustry == null ||
        resource.sessionSector == null ||
        resource.sponsoredCountry == null ||
        (resource.sponsoredCountry == 23 &&
          resource.serviceLineFunction == 20) ||
        this.isSubscriptionStatusError ||
        (this.showNAFields == true &&
          (((resource.serviceLineNA == null ||
            resource.serviceLineNA == '') && !this.disableServiceFunctionNA) ||
            ((resource.industryNA == null ||
              resource.industryNA == '') && !this.disableIndustryNA) ||
            ((resource.sectorNA == null ||
              resource.sectorNA == '') && !this.disableSectorNA))) ||
        (this.otherDepartmentDisable === false &&
          (this.session.otherDepartment?.trim() === '' || this.session.otherDepartment?.trim() === undefined))
      ) {
        return (this.accordionFlag1 = true);
      } else {
        return (this.accordionFlag1 = false);
      }
    }
  }

  // accordion flag for group 2 Session Details
  accordionFlag2: boolean = false;
  checkAccordionGrouping2(resource) {
    if (
      (resource.sessionType == 'Deloitte' && resource.ppmd == null) ||
      (resource.sessionType != 'Deloitte' &&
        resource.nonDelProfessional == null) ||
      resource.sessionCountry == null ||
      resource.sessionCity == null ||
      resource.sessionCity == '' ||
      resource.sessionFormat == null ||
      resource.sessionDate == null ||
      this.InvalidSessionDate ||
      resource.sessionTypes == null ||
      (resource.sessionCountry.toString() === '23' &&
        resource.sessionState == null) ||
      (resource.sessionTypes.toString() === '2' &&
        resource.sessionTypesEvent == null) ||
      (resource.sessionTypes.toString() === '2' &&
        (resource.sessionTypesEvent.toString() === '1' ||
          resource.sessionTypesEvent.toString() === '3' ||
          resource.sessionTypesEvent.toString() === '4') &&
        resource.sessionTypesProgram == null) ||
      (resource.sessionTypes.toString() === '2' &&
        (resource.sessionTypesEvent.toString() === '1' ||
          resource.sessionTypesEvent.toString() === '3' ||
          resource.sessionTypesEvent.toString() === '4') &&
        resource.sessionTypesProgram != null &&
        resource.sessionTypeSpecify == '') ||
      ((resource.sessionTypes.toString() === '6' ||
        resource.sessionTypes.toString() === '7') &&
        resource.sessionTypeSpecify == '') ||
      //client
      (resource.sessionTypes.toString() === '11' &&
        resource.sessionTypesEvent == null) ||
      (resource.sessionTypes.toString() === '13' &&
        resource.sessionSubTypes == null) ||
      (resource.sessionTypes.toString() === '15' &&
        resource.sessionTypeSpecify === '') ||
      (resource.sessionTypes.toString() === '11' &&
        (resource.sessionTypesEvent.toString() === '5' ||
          resource.sessionTypesEvent.toString() === '7' ||
          resource.sessionTypesEvent.toString() === '8') &&
        resource.sessionTypesProgram == null) ||
      (resource.sessionTypes.toString() === '11' &&
        (resource.sessionTypesEvent.toString() === '5' ||
          resource.sessionTypesEvent.toString() === '7' ||
          resource.sessionTypesEvent.toString() === '8') &&
        resource.sessionTypesProgram != null &&
        resource.sessionTypeSpecify == '') ||
      //non client
      (resource.sessionTypes.toString() === '19' &&
        resource.sessionTypesEvent == null) ||
      (resource.sessionTypes.toString() === '20' &&
        resource.sessionSubTypes == null) ||
      ((resource.sessionTypes.toString() === '23' ||
        resource.sessionTypes.toString() === '31') &&
        resource.sessionTypeSpecify == '') ||
      (resource.sessionTypes.toString() === '19' &&
        (resource.sessionTypesEvent.toString() === '9' ||
          resource.sessionTypesEvent.toString() === '11' ||
          resource.sessionTypesEvent.toString() === '12') &&
        resource.sessionTypesProgram == null) ||
      (resource.sessionTypes.toString() === '19' &&
        (resource.sessionTypesEvent.toString() === '9' ||
          resource.sessionTypesEvent.toString() === '11' ||
          resource.sessionTypesEvent.toString() === '12') &&
        resource.sessionTypesProgram != null &&
        resource.sessionTypeSpecify == '') ||
      //Mixed Aud
      (resource.sessionTypes.toString() === '26' &&
        resource.sessionTypesEvent == null) ||
      ((resource.sessionTypes.toString() === '28' ||
        resource.sessionTypes.toString() === '30' ||
        resource.sessionTypes == '32') &&
        resource.sessionTypeSpecify == '') ||
      (resource.sessionTypes.toString() === '26' &&
        (resource.sessionTypesEvent.toString() === '13' ||
          resource.sessionTypesEvent.toString() === '15' ||
          resource.sessionTypesEvent.toString() === '16') &&
        resource.sessionTypesProgram == null) ||
      (resource.sessionTypes.toString() === '26' &&
        (resource.sessionTypesEvent.toString() === '13' ||
          resource.sessionTypesEvent.toString() === '15' ||
          resource.sessionTypesEvent.toString() === '16') &&
        resource.sessionTypesProgram != null &&
        resource.sessionTypeSpecify == '') ||
      (this.showProBono == true && resource.proBono == null) ||
      (resource.proBono === "yes" &&
        resource.explainRationale == null) ||
      (this.disableContentArea == false && this.session.contentArea == null) ||
      (this.session.contentArea == 2 && this.session.Topic == null)
    ) {
      this.accordionFlag2 = true; // field empty
    } else {
      this.accordionFlag2 = false;
    }
  }

  // accordion flag for group 5 Role
  accordionFlag5: boolean = false;
  checkAccordionGrouping5(resource, type) {
    let ppmdFlag = false;
    const result = false;
    if (
      (resource.sponsoredCountry == '259' ||
        resource.sponsoredCountry == '23' ||
        resource.sponsoredCountry == '265' ||
        resource.sponsoredCountry == '266' ||
        resource.sponsoredCountry == '267' ||
        resource.sponsoredCountry == '268' ||
        resource.sponsoredCountry == '269') &&
      (resource?.responsiblePpmd == '' ||
        resource?.responsiblePpmd?.AD_EmailAdress == '' ||
        resource?.responsiblePpmd?.AD_EmailAdress == undefined ||
        resource?.responsiblePpmd?.AD_EmailAdress == null)
    ) {
      ppmdFlag = true;
    }

    if (type == 'submit') {
      if (
        this.invalidSessionRequester == true ||
        resource.sessionRequester == '' ||
        this.selectedCoordinators.length === 0 ||
        this.checkCertifiedFacilitators() ||
        ppmdFlag == true ||
        this.selectedFacilitator.length === 0 ||
        ((this.isClientCertifiedFacilitator === false ||
          this.selectedFacilitator.length === 0) &&
          (this.session.sessionType == 'ExternalClient' ||
            this.session.sessionType == 'MixedAudience') &&
          (this.userRoleID === 2 || this.userRoleID === 4) &&
          (this.session.sessionTypes == 8 || this.session.sessionTypes == 24) &&
          !(this.session.proBono == 'yes')) ||
        (this.isSessionDateGreaterTodayDate == true &&
          this.sessionId !== 0 &&
          (this.selectedFacilitator.length === 0 ||
            this.isClientCertifiedFacilitator === false) &&
          (this.session.sessionType == 'ExternalClient' ||
            this.session.sessionType == 'MixedAudience') &&
          (this.userRoleID === 2 || this.userRoleID === 4) &&
          (this.session.sessionTypes == 8 || this.session.sessionTypes == 24) &&
          !(this.session.proBono == 'yes')) ||
        this.textLimitErrorPPMD || ((this.selectedFacilitator.length == 0 || this.isClientCertifiedFacilitator == false) && (this.session.sessionTypes == 1 || (this.session.sessionTypes == 4  && this.session.contentArea == 2))) ||
        (!this.showPPMDAsTextInput && this.invalidppmd)
      ) {
        this.accordionFlag5 = true;
        return;
      } else {
        this.accordionFlag5 = false;
      }
    } else if (
      this.invalidSessionRequester === true ||
      resource.sessionRequester == '' ||
      this.selectedCoordinators.length === 0
    ) {
      this.accordionFlag5 = true;
      return;
    } else {
      this.accordionFlag5 = false;
    }
  }

  // accordion flag for group 4 Charge Codes
  accordionFlag4: boolean = false;
  checkAccordionGrouping4() {
    // this condition for WBS
    const shouldValidateMainWBS = this.shouldValidateMainWBS();
    if (
      !this.isSelected('Deloitte') &&
      ((shouldValidateMainWBS && (this.wbsError || this.invalidWBS || this.invalidPercenatge)) ||
        this.wbsErrorForSurcharge ||
        this.invalidWBSForSurcharge ||
        this.invalidPercenatgeForSurcharge)
    ) {
      this.accordionFlag4 = true;
    } else {
      this.accordionFlag4 = false;
    }
  }

  private openWbsAccordionAndFocus(): void {
    this.accordionFlag4 = true;
    const element = document.querySelector('#accordion .accordion4');
    if (element) {
      element.classList.add('show');
      element.classList.remove('collapse');
    }
    if (document.getElementById('collapse6')) {
      const tempScrollValue = $('#collapse6').offset().top - 100;
      $(window).scrollTop(Math.ceil(tempScrollValue));
    }
  }

  accordionFlag3: boolean = false;
  checkAccordionGrouping3(resource) {
    // close the accordian if the fields are valid
    if (
      !resource.disableSFDCIntegration ||
      (resource.disableSFDCIntegration &&
        resource.sfdcDisableReasonId &&
        ((resource.sfdcDisableReasonId == 4 &&
          resource.sfdcDisableOtherReason &&
          !this.isSFDCDisableOtherReasonInvalid) ||
          resource.sfdcDisableReasonId != 4))
    ) {
      this.accordionFlag3 = false;
    } else {
      this.accordionFlag3 = true;
    }
  }

  //For Session Feedback
  accordionFlag9: boolean = false;
  checkAccordionGrouping9(resource) {
    if (this.showFeedbackAccordian()) {
      if (this.isSessionFeedbackVisible() && this.optOut == null) {
        this.optOut = "IAgree";
      } 
      if (this.optOut == null || (this.optOut == "optOut" && (this.invalidOptOutReason || this.OptOutReason === ''))) {
        this.accordionFlag9 = true;
      } else {
        this.accordionFlag9 = false;
      }
  }
      else{
       this.accordionFlag9 = false;
      }
    }

  
  //check session feedback requirements
  showFeedbackAccordian() {
    if ((this.session.sponsoredCountry == '23' || this.session.sponsoredCountry == '266') && !this.InvalidAge && !this.session.subscriptionId  && ((this.session.sessionType == 'ExternalClient' && (this.session.sessionTypes == '8' ||
      this.session.sessionTypes == '10' || (this.session.sessionTypes == '13' && this.session.sessionSubTypes == '1') || this.session.sessionTypes == '15')) || (this.session.sessionType == 'ExternalNonClient' && (this.session.sessionTypes == '16' ||
        this.session.sessionTypes == '18' || (this.session.sessionTypes == '20' && this.session.sessionSubTypes == '5') || this.session.sessionTypes == '31' || this.session.sessionTypes == '23')) || (this.session.sessionType == 'MixedAudience' && (this.session.sessionTypes == '24' || this.session.sessionTypes == '27' ||
          this.session.sessionTypes == '28' || this.session.sessionTypes == '32' || this.session.sessionTypes == '30')))) {
      return true;
    } else {
      return false;
    }
  }
  // For Session Summary
  accordionFlag6: boolean = false;
  checkAccordionGrouping6(resource) {
    // this condition for WBS
    if (
      (!this.isSelected('Deloitte') &&
        resource.reportCheck == true &&
        resource.sessionReport == null) 
      
    ) {
      this.accordionFlag6 = true;
    } else {
      this.accordionFlag6 = false;
    }
  }

  // For Participants Details
  accordionFlag7: boolean = false;
  checkAccordionGrouping7(resource) {
    //below if&else condition for fixing bug: 2557874
    if (
      resource.sessionType != 'Deloitte' &&
      this.requiredDomainEmailsVal == true
    ) {
      if (this.checkValidParticipantDetails()) {
        this.accordionFlag7 = true;
      } else {
        this.accordionFlag7 = false;
      }
    } else {
      this.accordionFlag7 = false;
    }
  }

  moveScrollForAccordion() {
    let topOffsetPostion;
    if (this.accordionFlag0) {
      //Organization Details
      const tempScrollValue = $('#collapse2').offset().top - 190;
      topOffsetPostion = Math.ceil(tempScrollValue);
      $(window).scrollTop(topOffsetPostion);
      return;
    } else if (this.accordionFlag1) {
      //Organization Details
      const tempScrollValue = $('#collapse2').offset().top - 190;
      topOffsetPostion = Math.ceil(tempScrollValue);
      $(window).scrollTop(topOffsetPostion);
      return;
    } else if (this.accordionFlag2) {
      //Session Details
      const tempScrollValue = $('#accordn2').offset().top - 100;
      topOffsetPostion = Math.ceil(tempScrollValue);
      $(window).scrollTop(topOffsetPostion);
      return;
    } else if (this.accordionFlag4) {
      //Charge Codes
      const tempScrollValue = $('#collapse6').offset().top - 100;
      topOffsetPostion = Math.ceil(tempScrollValue);
      $(window).scrollTop(topOffsetPostion);
      return;
    } else if (this.accordionFlag5) {
      //Roles
      const tempScrollValue = $('#collapse_6').offset().top - 100;
      topOffsetPostion = Math.ceil(tempScrollValue);
      $(window).scrollTop(topOffsetPostion);
      return;
    } else if (this.accordionFlag9) {
      //Session Feedback
      const tempScrollValue = $('#collapse9').offset()?.top - 100;
      topOffsetPostion = Math.ceil(tempScrollValue);
      $(window).scrollTop(topOffsetPostion);

    } else if (this.accordionFlag6) {
      //summary
      const tempScrollValue = $('#collapse_06').offset().top - 100;
      topOffsetPostion = Math.ceil(tempScrollValue);
      $(window).scrollTop(topOffsetPostion);
      return;
    }
  }
  accordionFlag0: boolean = false;
  openAccordian(validForm, formvalue, type) {
    const tempResource = JSON.stringify(formvalue);
    const FinalFormValues = JSON.parse(tempResource);
    if (type == 'draft') {
      this.draftSession = true;
    } else {
      this.draftSession = false;
    }
    // Session Name validation
    if (this.invalidSessionName) {
      this.accordionFlag0 = true;
    } else {
      this.accordionFlag0 = false;
    }
    // Accordion 1 // Organization details
    this.checkAccordionGrouping1(FinalFormValues);
    if (this.accordionFlag1 == true) {
      //  $("#accordion .accordion1").collapse("show");
      // var myCollapse = new bootstrap.Collapse(document.querySelector('#accordion .accordion1'), {
      //   show: true
      // });
      const element = document.querySelector('#accordion .accordion1');
      if (element) {
        element.classList.add('show');
        element.classList.remove('collapse');
      }
    } else {
      const element = document.querySelector('#accordion .accordion1');
      if (element) {
        element.classList.add('collapse');
        element.classList.remove('show');
      }
      //  $("#accordion .accordion1").collapse("hide");
      // var myCollapse = new bootstrap.Collapse(document.querySelector('#accordion .accordion1'), {
      //   hide: true
      // });
    }

    // Accordion 2 Session Details
    this.checkAccordionGrouping2(FinalFormValues);
    if (this.accordionFlag2 == true) {
      const element = document.querySelector('#accordion .accordion2');
      if (element) {
        element.classList.add('show');
        element.classList.remove('collapse');
      }
      // var myCollapse = new bootstrap.Collapse(document.querySelector('#accordion .accordion2'), {
      //   show: true
      // });
      // $("#accordion .accordion2").collapse("show");
    } else {
      const element = document.querySelector('#accordion .accordion2');
      if (element) {
        element.classList.add('collapse');
        element.classList.remove('show');
      }
      // var myCollapse = new bootstrap.Collapse(document.querySelector('#accordion .accordion2'), {
      //   hide: true
      // });
      // $("#accordion .accordion2").collapse("hide");
    }

    // Accordian 3 Chargebacks/Fees
    this.checkAccordionGrouping3(FinalFormValues);
    if (this.accordionFlag3 == true) {
      // var myCollapse = new bootstrap.Collapse(
      //   document.querySelector('#accordion .accordion3'),
      //   {
      //     show: true,
      //   }
      // );
      const element = document.querySelector('#accordion .accordion3');
      if (element) {
        element.classList.add('show');
        element.classList.remove('collapse');
      }
      // $("#accordion .accordion3").collapse("show");
    } else {
      const element = document.querySelector('#accordion .accordion3');
      if (element) {
        element.classList.add('collapse');
        element.classList.remove('show');
      }
      // var myCollapse = new bootstrap.Collapse(
      //   document.querySelector('#accordion .accordion3'),
      //   {
      //     hide: true,
      //   }
      // );
      //  $("#accordion .accordion3").collapse("hide");
    }

    // Accordion 5 Roles
    this.checkAccordionGrouping5(FinalFormValues, type);
    if (this.accordionFlag5 == true) {
      // $("#accordion .accordion5").collapse("show");
      // var myCollapse = new bootstrap.Collapse(
      //   document.querySelector('#accordion .accordion5'),
      //   {
      //     show: true,
      //   }
      // );
      const element = document.querySelector('#accordion .accordion5');
      if (element) {
        element.classList.add('show');
        element.classList.remove('collapse');
      }
    } else {
      // $("#accordion .accordion5").collapse("hide");
      // var myCollapse = new bootstrap.Collapse(
      //   document.querySelector('#accordion .accordion5'),
      //   {
      //     hide: true,
      //   }
      // );
      const element = document.querySelector('#accordion .accordion5');
      if (element) {
        element.classList.add('collapse');
        element.classList.remove('show');
      }
    }

    //Accordion 4 WBS
    this.checkAccordionGrouping4();
    if (this.accordionFlag4 == true) {
      // $("#accordion .accordion4").collapse("show");
      // var myCollapse = new bootstrap.Collapse(
      //   document.querySelector('#accordion .accordion4'),
      //   {
      //     show: true,
      //   }
      // );

      const element = document.querySelector('#accordion .accordion4');
      if (element) {
        element.classList.add('show');
        element.classList.remove('collapse');
      }
    } else {
      // $("#accordion .accordion4").collapse("hide");
      // var myCollapse = new bootstrap.Collapse(
      //   document.querySelector('#accordion .accordion4'),
      //   {
      //     hide: true,
      //   }
      // );
      const element = document.querySelector('#accordion .accordion4');
      if (element) {
        element.classList.add('collapse');
        element.classList.remove('show');
      }
    }

    // Accordion 9 Session Feedback
    this.checkAccordionGrouping9(FinalFormValues);
    if (this.accordionFlag9 == true) {
      const element = document.querySelector('#accordion .accordion9');
      if (element) {
        element.classList.add('show');
        element.classList.remove('collapse');
      }
    } else {
      const element = document.querySelector('#accordion .accordion9');
      if (element) {
        element.classList.add('collapse');
        element.classList.remove('show');
      }

    }

    // Accordion 6 Session Summary
    this.checkAccordionGrouping6(FinalFormValues);
    if (this.accordionFlag6 == true) {
      // $("#accordion .accordion6").collapse("show");
      // var myCollapse = new bootstrap.Collapse(
      //   document.querySelector('#accordion .accordion6'),
      //   {
      //     show: true,
      //   }
      // );

      const element = document.querySelector('#accordion .accordion6');
      if (element) {
        element.classList.add('show');
        element.classList.remove('collapse');
      }
    } else {
      // $("#accordion .accordion6").collapse("hide");
      // var myCollapse = new bootstrap.Collapse(
      //   document.querySelector('#accordion .accordion6'),
      //   {
      //     show: true,
      //   }
      // );

      const element = document.querySelector('#accordion .accordion6');
      if (element) {
        element.classList.add('collapse');
        element.classList.remove('show');
      }
    }

    // Accordion 7 Participant Details
    this.checkAccordionGrouping7(FinalFormValues);
    if (this.accordionFlag7 == true) {
      // $("#accordion .accordion7").collapse("show");
      // var myCollapse = new bootstrap.Collapse(
      //   document.querySelector('#accordion .accordion7'),
      //   {
      //     show: true,
      //   }
      // );
      const element = document.querySelector('#accordion .accordion7');
      if (element) {
        element.classList.add('show');
        element.classList.remove('collapse');
      }
    } else {
      // $("#accordion .accordion7").collapse("hide");
      // var myCollapse = new bootstrap.Collapse(document.querySelector('#accordion .accordion7'), {
      //   hide: true
      // });

      const element = document.querySelector('#accordion .accordion7');
      if (element) {
        element.classList.add('collapse');
        element.classList.remove('show');
      }
    }

    this.moveScrollForAccordion();
  }

  //To get selected Sponsouring Country Name for audit trail
  public SponsoringCountryName: string = '';
  getSelectedSponsoringCountryName(countryId) {
    this.sponsoringCountries.findIndex((item) => {
      if (item.ID == countryId) {
        this.SponsoringCountryName = item.Name;
        return item.ID;
      }
    });
  }

  //To get selected Session Country Name for audit trail
  public SessionCountryName: string = '';
  getSelectedSessionCountryName(countryId) {
    this.dropdownData.Countries.findIndex((item) => {
      if (item.ID == countryId) {
        this.SessionCountryName = item.Name;
      }
    });
  }

  //To get selected Session Type Name for audit trail
  public SessionTypeName: string = '';
  getSelectedSessionTypeName(typeId) {
    this.dropdownData.SessionType.findIndex((item) => {
      if (item.SessionTypeID == typeId) {
        this.SessionTypeName = item.SessionTypeName;
      }
    });
  }

  //To get selected Session Format Name for audit trail
  public SessionFormatName: string = '';
  getSelectedSessionFormatName(formatId) {
    this.dropdownData.SessionFormat.findIndex((item) => {
      if (item.SessionFormatID == formatId) {
        this.SessionFormatName = item.SessionFormatName;
      }
    });
  }

  checkInvalidCompany() {
    if (this.session.sessionType == 'Deloitte') {
      this.invalidCompany = false;
    } else {
      const companyName =
        this.session.companyName && typeof this.session.companyName == 'string'
          ? this.session.companyName
          : this.session.companyName
            ? this.session.companyName.Name
            : '';
      if (
        this.session.sessionType == 'ExternalClient' &&
        this.session.sponsoredCountry == '23'
      ) {
        if (this.sessionId > 0) {
          this.SessionService.searchword(companyName, 0).subscribe((data) => {
            this.selectedCompanyDunsID = data[0].DunsID || '';
            this.invalidCompany =
              data &&
                data.length > 0 &&
                data.some((res) => res.Name == companyName)
                ? false
                : true;
          });
        } else {
          this.invalidCompany =
            this.session.companyName &&
              companyName &&
              this.selectedCompany == companyName
              ? false
              : true;
        }
      } else {
        this.SessionService.searchword(companyName, 0).subscribe((data) => {
          this.selectedCompanyDunsID = data[0].DunsID || '';
        });
        this.invalidCompany =
          this.session.companyName &&
            companyName &&
            companyName.replace(/^\s+|\s+$/gm, '') != ''
            ? false
            : true;
      }
    }
  }

  updateSecRestrictedOptionsOnChangeAudience() {
    if (this.session.sessionType == 'ExternalClient') {
      this.dropdownData.SECRestriction = this.masterData.SECRestriction.filter(
        (data) => data.SecRestrictionID == 1 || data.SecRestrictionID == 2
      );
    } else if (this.session.sessionType == 'ExternalNonClient') {
      this.dropdownData.SECRestriction = [];
    } else if (this.session.sessionType == 'MixedAudience') {
      this.dropdownData.SECRestriction = this.masterData.SECRestriction.filter(
        (data) => true
      );
    }
    this.session.secRestricted = null;
  }

  updateSecRestrictedOptionsAtInitialLoad() {
    if (this.session.sessionType == 'ExternalClient') {
      this.dropdownData.SECRestriction = this.masterData.SECRestriction?.filter(
        (data) => data.SecRestrictionID == 1 || data.SecRestrictionID == 2
      );
      if (
        this.session.secRestricted &&
        !this.dropdownData.SECRestriction.find(
          (data) => data.SecRestrictionID == this.session.secRestricted
        )
      ) {
        this.dropdownData.SECRestriction =
          this.masterData.SECRestriction.filter(
            (data) =>
              data.SecRestrictionID == 1 ||
              data.SecRestrictionID == 2 ||
              data.SecRestrictionID == this.session.secRestricted
          );
      }
    }
  }

  public openConfirmationDialog() {
    const modalEl = document.getElementById('mypopup');
    if (modalEl) {
        this.myPopupInstance = Modal.getOrCreateInstance(modalEl, {
          backdrop: 'static',
          keyboard: false
        });
      this.myPopupInstance.show();
    }
  }

  public closeConfirmPopUp() {
    if(this.myPopupInstance) {
      this.myPopupInstance.hide();
    }
  }

  validateOptOutReason() {
    if (this.OptOutReason !== '') {
      const normalizedReason = this.OptOutReason.trim().replace(/\s+/g, ''); 
      const regex = /^[0-9!@#\$%\^\&*\)\(+=._-]+$/g;
      const regex1 = /^[!@#\$%\^\&*\)\(+=._-]+$/g;
      if (
        normalizedReason.length < 5 ||
        normalizedReason.length > 1000 ||
        normalizedReason === 'N/A' ||
        normalizedReason === 'NA' ||
        normalizedReason === "Not Applicable" ||
        normalizedReason === "NotApplicable" ||
        regex.test(normalizedReason) ||
        regex1.test(normalizedReason)
      ) {
        this.invalidOptOutReason = true;
        this.invalidOptOutReasonText =
          'Please enter valid reason for opting out.';
      } else {
        this.invalidOptOutReason = false;
        this.invalidOptOutReasonText = '';
      }
    } else {
      this.invalidOptOutReason = true;
      this.invalidOptOutReasonText = 'Please include a reason for opting out.';
    }
  }

  /**
   * Validates the SFDC disable other reason.
   * If the session's sfdcDisableOtherReason is provided, it checks if it meets the following criteria:
   * - Length should be between 5 and 1000 characters.
   * - Should not be "N/A" or "NA".
   * - Should not contain only special characters or numbers.
   *
   * If the sfdcDisableOtherReason is invalid, it sets the isSFDCDisableOtherReasonInvalid flag to true
   * and assigns an error message to sfdcDisableOtherReasonInvalidMessage.
   * Otherwise, it sets the isSFDCDisableOtherReasonInvalid flag to false and clears the error message.
   */
  validateSFDCDisableOtherReason() {
    if (this.session.sfdcDisableOtherReason) {
      const regex = /^[0-9!@#\$%\^\&*\)\(+=._-]+$/g;
      const regex1 = /^[!@#\$%\^\&*\)\(+=._-]+$/g;
      if (
        this.session.sfdcDisableOtherReason.trim().length < 5 ||
        this.session.sfdcDisableOtherReason.trim().length > 1000 ||
        this.session.sfdcDisableOtherReason.trim() === 'N/A' ||
        this.session.sfdcDisableOtherReason.trim() === 'NA' ||
        regex.test(this.session.sfdcDisableOtherReason) ||
        regex1.test(this.session.sfdcDisableOtherReason)
      ) {
        this.isSFDCDisableOtherReasonInvalid = true;
        this.sfdcDisableOtherReasonInvalidMessage =
          'Please enter a valid reason.';
      } else {
        this.isSFDCDisableOtherReasonInvalid = false;
        this.sfdcDisableOtherReasonInvalidMessage = '';
      }
    } else {
      this.isSFDCDisableOtherReasonInvalid = true;
      this.sfdcDisableOtherReasonInvalidMessage = 'Please enter a reason';
    }
  }

  onChangeOfSessionSubType(sessionSubTypeId) {
    this.optOut = "IAgree";
    this.OptOutReason = '';

    // for sesssion type non recruiting event
    if (
      !this.isExistingNonRecrutingSession &&
      !(
        this.session.subscriptionId &&
        !this.subscriptionIDError &&
        !this.isSubscriptionStatusError
      )
    ) {
      // reset rate, gxfees, surcharge to null if session sub type is changed to 'Students only'
      if (
        this.session.sessionSubTypes == 2 ||
        this.session.sessionSubTypes == 6
      ) {
        this.session.rate = null;
        this.session.gxFees = null;
        this.session.surcharge = null;
      }
      this.calculateChargebackAndSurcharge();
    }
  }
  DownloadSubsUsageReport(subscriptionId) {
    this.SessionService.exportSubsUsageReport(subscriptionId).subscribe(
      (res) => {
        const binaryData = [];
        binaryData.push(res);
        const url = window.URL.createObjectURL(
          new Blob(binaryData, { type: 'application/vnd.ms-excel' })
        );
        // create hidden dom element (so it works in all browsers)
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        // create file, attach to hidden element and open hidden element
        a.href = url;
        a.download = 'SubscriptionUsageReport.xls';
        a.click();
      }
    );
  }

  unableSurchargeRateForFacAndCorRoles() {
    if (
      this.operationType === 'Edit' &&
      this.session.sponsoredCountry == 23 &&
      this.session.approvalStatus == 'Approved'
    ) {
      if (
        this.session.rate != '' &&
        this.session.rate != null &&
        (((this.session.sessionTypes == '11' ||
          this.session.sessionTypes == '26' ||
          this.session.sessionTypes == '19') &&
          (this.session.sessionTypesEvent == '6' ||
            this.session.sessionTypesEvent == '14' ||
            this.session.sessionTypesEvent == '10' ||
            this.session.sessionTypesEvent == '17' ||
            this.session.sessionTypesEvent == '18' ||
            this.session.sessionTypesEvent == '19')) ||
          this.session.sessionTypes == '8' ||
          this.session.sessionTypes == '16' ||
          this.session.sessionTypes == '24' ||
          this.session.sessionTypes == '20' ||
          this.session.sessionTypes == '13' ||
          this.session.sessionTypes == '33' ||
          this.session.sessionTypes == '34' ||
          this.session.sessionTypes == '35' ||
          this.session.sessionTypes == '14' ||
          this.session.sessionTypes == '21' ||
          this.session.sessionTypes == '15' ||
          this.session.sessionTypes == '30' ||
          this.session.sessionTypes == '23')
      ) {
        this.showRatefieldForFacAndCor = true;
      } else {
        this.showRatefieldForFacAndCor = false;
      }
      if (
        +this.session.surcharge > 0 &&
        (this.userRoleID === 2 ||
          this.userRoleID === 4 ||
          this.userRoleID === 5) &&
        (((this.session.sessionTypes == '11' ||
          this.session.sessionTypes == '26' ||
          this.session.sessionTypes == '19') &&
          (this.session.sessionTypesEvent == '6' ||
            this.session.sessionTypesEvent == '14' ||
            this.session.sessionTypesEvent == '10')) ||
          this.session.sessionTypes == '8' ||
          this.session.sessionTypes == '16' ||
          this.session.sessionTypes == '24' ||
          this.session.sessionTypes == '14' ||
          this.session.sessionTypes == '26' ||
          this.session.sessionTypes == '11' ||
          this.session.sessionTypes == '19' ||
          this.session.sessionTypes == '21' ||
          this.session.sessionTypes == '15' ||
          this.session.sessionTypes == '30' ||
          this.session.sessionTypes == '23' ||
          this.session.sessionTypes == '33' ||
          this.session.sessionTypes == '34' ||
          this.session.sessionTypes == '35')
      ) {
        this.showSurchargefieldForFacAndCor = true;
      } else {
        this.showSurchargefieldForFacAndCor = false;
      }
    } else if (
      this.session.approvalStatus == 'Approval Pending' &&
      this.userRoleID !== 5 &&
      this.userRoleID !== 6
    ) {
      if (
        this.sessionId !== 0 &&
        this.session.subscriptionId &&
        (this.userRoleID === 2 || this.userRoleID === 4) &&
        !this.session.rate
      ) {
        this.showSurchargefieldForFacAndCor = false;
        this.showRatefieldForFacAndCor = false;
      } else {
        this.showSurchargefieldForFacAndCor = true;
        this.showRatefieldForFacAndCor = true;
      }
    } else {
      this.showSurchargefieldForFacAndCor = false;
      this.showRatefieldForFacAndCor = false;
    }
  }
  onSelectInvalidAge(InvalidAge: Event) {
    const checkbox = InvalidAge.target as HTMLInputElement;
    const isChecked = checkbox.checked;
    this.InvalidAge = isChecked;
  }
  resetInvalidAge() {
    this.InvalidAge = false;
  } 
  ClearWBS(mode: 'all' | 'current') {
    this.IsWBSCodeConfirmed = false;
    if (mode === 'all' || this.multipleWBS.length == 1) {
      this.multipleWBS = [{ id: 0, wbsCode: '', wbsPercentage: '', isSelectedFromPicklist: false, isWbsActive: null, isWbsStatusChecked: false, isWbsStatusChecking: false }];
      this.invalidPercenatge = false;
      this.wbsError = false;
      this.invalidWBS = false;
      return;
    } 
    if (this.currentWBS && this.currentWBS.wbsCode && this.multipleWBS.length > 1) {
      this.multipleWBS = this.multipleWBS.filter(item => item.wbsCode !== this.currentWBS.wbsCode);
      if (this.multipleWBS.length == 1) {
        this.invalidPercenatge = false;
        this.wbsError = false;
      }
    }
  }
}
